export default {
  it: {
    menu_tabs: {
      panoramica: "Panoramica",
      dispositivi: "Dispositivi",
      area_tecnica: "Area Tecnica",
      anagrafica: "Anagrafica Impianti"
    },
    tracker_feedback: {
      titolo: "Feedback tracker",
      colonna: {
        tracker: "Tracker",
        id_device: "ID Device",
        esito: "Esito",
      },
      esito: {
        ok: "OK",
        timeout: "Timeout",
        refused: "Rifiutato",
        attesa: "In attesa",
      },
    },
    operation: "Operazione",
    menu_strumenti_log_config_tracker: "Log configurazioni tracker",
    log_config_tracker: {
      statistiche: "Statistiche",
      colonna: {
        createdAt: "Data invio",
        impianto: "Impianto",
        utente: "Utente",
        dst: "Destinatari",
        tracker_count: "N° tracker",
        ack_status: "Stato ack",
        latency: "Latenza ack",
        request_id: "Request ID",
        azioni: "Azioni",
        operation: "Operazione",
      },
      filtro: {
        titolo: "Filtri",
        periodo: "Periodo",
        impianto: "Impianto",
        utente: "Utente",
        dst: "Destinatari",
        status: "Stato ack",
        request_id: "Request ID",
        attesa_oltre: "In attesa da oltre (min)",
      },
      dst: {
        tutti: "Tutti",
        selezione: "Selezione",
      },
      status: {
        ok: "OK",
        error: "Errore",
        pending: "In attesa",
        attesa_da: "In attesa da {min}m",
      },
      button: {
        confronta: "Confronta",
        reset_filtri: "Reset filtri",
      },
      tooltip: {
        confronta_disabled: "Seleziona esattamente 2 righe per confrontare",
      },
      toast: {
        errore_caricamento: "Errore nel caricamento del log configurazioni",
      },
      stats: {
        totale: "Invii totali",
        per_status: "Per stato ack",
        top_impianti: "Top impianti",
        periodo: "Tutto il periodo",
        top_comandi: "Top comandi",
      },
      titolo_confronto: "Confronto configurazioni",
      confronto: {
        label_a: "Config A",
        label_b: "Config B",
        chiave: "Chiave",
        campo: "Campo",
        config_differenti: "Config differenti",
        scalar_differenti: "Campi differenti",
        nessuna_differenza_config:
          "Nessuna differenza nella configurazione inviata",
        nessuna_differenza_scalare: "Nessuna differenza nei campi",
        solo_in_a: "Solo in A",
        solo_in_b: "Solo in B",
        comuni: "Comuni",
        changed: "Modificati",
        tracker_target: "Tracker destinatari",
        esiti_per_quadro: "Esiti per quadro",
      },
      titolo_dettaglio: "Dettaglio invio configurazione",
      dettaglio: {
        informazioni_generali: "Informazioni generali",
        config_inviata: "Configurazione inviata",
        tracker_destinatari: "Tracker destinatari",
        matrice_quadri: "Esiti per quadro",
        json_grezzi: "Dati grezzi",
      },
      operation: {
        push: "Push",
      },
    },
    ultimo_comando_remoto: "Ultimo comando remoto",
    feedback_ultimo_comando_remoto: "Feedback ultimo comando remoto",
    tensione_batteria: "Tensione batteria",
    reset_counter: "Reset counter",
    motivo_cambio_modalita: "Motivo cambio modalità",
    impianto: "Impianto",
    attivazione_licenza: "Attivazione licenza",
    scadenza_licenza: "Scadenza licenza",
    elenco_impianti_associati: "Elenco impianti associati",
    utente_nome: "Utente",
    tracker_count: "Tracker",
    request_id: "Request Id",
    mostra_dettagli: "Mostra dettagli",
    codice_univoco: "Codice univoco",
    archivio_elimina_selezionati: "Elimina selezionati",
    menu_strumenti_archivio: "Archivio",
    attuale: "Attuale",
    completato: "Completato",
    passo: "Passo",
    menu_versioni_firmware: "Versioni firmware",
    menu_strumenti_log_comandi_manuali: "Log comandi manuali",
    caricamento: "Caricamento...",
    trackers: {
      config: {
        error: {
          payload_invalido: "Payload non valido",
          permesso_negato: "Permesso negato",
          tracker_non_appartiene_impianto:
            "Il tracker non appartiene all'impianto selezionato",
          config_invalida: "Configurazione non valida",
        },
      },
      send_manual_cmd: {
        error: {
          payload_invalido: "Payload non valido",
          target_fuori_range: "Valore target fuori range",
          permesso_negato: "Permesso negato",
          tracker_non_appartiene_impianto:
            "Il tracker non appartiene all'impianto selezionato",
          request_id_esauriti:
            "Troppi comandi in attesa su questo impianto: riprovare tra un minuto",
        },
        inviato: "Comando inviato correttamente",
        tracker_non_raggiunti:
          "Alcuni tracker non hanno risposto al comando. Controlla lo stato dei tracker e riprova.",
        toast: {
          socket_non_connesso:
            "Socket non connesso. Impossibile inviare il comando.",
          tracker_non_raggiunti:
            "Alcuni tracker non hanno risposto al comando. Controlla lo stato dei tracker e riprova.",
        },
        socket_non_connesso:
          "Socket non connesso. Impossibile inviare il comando.",
        pill: {
          descrizione: "{n} quadri in attesa di risposta",
        },
      },
    },
    tracker_config: {
      gruppo: {
        batteria: "Batteria",
        vento: "Vento",
        angoli: "Angoli",
        mesh: "Mesh",
      },
      enum: {
        abilitato: "Abilitato",
        disabilitato: "Disabilitato",
        est: "Est",
        ovest: "Ovest",
        segno_neg: "Negativo (-1)",
        segno_pos: "Positivo (+1)",
      },
      campo: {
        currentThreshold: {
          label: "Soglia corrente allarme motore",
          desc: "Soglia di corrente per la segnalazione dell'allarme di assorbimento motore.",
        },
        trackerSide: {
          label: "Verso controller",
          desc: "Verso del controller del tracker (est/ovest).",
        },
        socLow: {
          label: "Soglia allarme batteria",
          desc: "Soglia di allarme sullo stato di carica della batteria.",
        },
        socHigh: {
          label: "Soglia ripristino batteria",
          desc: "Soglia di ripristino dell'allarme float sulla batteria.",
        },
        powerGood: {
          label: "Power good",
          desc: "Tempo di stabilità dell'alimentazione del pannello.",
        },
        maxChargerCurrent: {
          label: "Corrente max caricabatterie",
          desc: "Soglia massima di corrente del caricabatterie.",
        },
        windSpeedEn: {
          label: "Sensore velocità vento",
          desc: "Abilitazione del sensore di velocità del vento.",
        },
        windDirEn: {
          label: "Sensore direzione vento",
          desc: "Abilitazione del sensore di direzione del vento.",
        },
        windSpeedAdd: {
          label: "Indirizzo sensore velocità",
          desc: "Indirizzo Modbus del sensore di velocità del vento.",
        },
        windDirAdd: {
          label: "Indirizzo sensore direzione",
          desc: "Indirizzo Modbus del sensore di direzione del vento.",
        },
        windDirOffset: {
          label: "Offset direzione vento",
          desc: "Offset del sensore di direzione del vento (gradi ×10, da 0.0 a 360.0).",
        },
        windThresholdOffset: {
          label: "Offset soglia vento",
          desc: "Offset applicato alla soglia di allarme vento.",
        },
        eastAngleSign: {
          label: "Segno angoli est",
          desc: "Segno degli angoli sul lato est (-1 o +1).",
        },
        angleLower: {
          label: "Angolo minimo",
          desc: "Angolo minimo di movimentazione del tracker.",
        },
        angleUpper: {
          label: "Angolo massimo",
          desc: "Angolo massimo di movimentazione del tracker.",
        },
        motorPhase: {
          label: "Fase motore",
          desc: "Fase del motore (est/ovest).",
        },
        meshId: {
          label: "Mesh ID",
          desc: "Identificativo alfanumerico della mesh.",
        },
        windSpeedMeanT: {
          label: "Periodo campionamento vento",
          desc: "Periodo di campionamento della misura del vento.",
        },
        missingWeatherTime: {
          label: "Tempo assenza meteo",
          desc: "Tempo di tolleranza per l'assenza della stazione meteo.",
        },
        meshDownTime: {
          label: "Tempo assenza mesh",
          desc: "Tempo di tolleranza per l'assenza di comunicazione mesh.",
        },
        PowerFromPanel: {
          label: "Abilita MPPT",
          desc: "Alimentazione da pannello solare (MPPT) anziché da rete elettrica.",
        },
      },
      invia: {
        corrente: "Invia a questo",
        gruppo: "Invia a gruppo",
        tutti: "Invia a tutti",
      },
      gruppo_dialog: {
        titolo: "Seleziona i tracker destinatari",
      },
      modifiche_conteggio: "{n} modifiche non inviate",
      nessuna_modifica: "Nessuna modifica",
      reset_tutto: "Ripristina tutto",
      contesto: {
        tracker: "Tracker",
      },
      errore: {
        tracker_non_trovato: "Tracker non trovato",
        titolo: "Impossibile caricare la configurazione",
        richiesta_fallita: "Richiesta di configurazione fallita.",
        tracker_non_raggiunto: "Il tracker non è raggiungibile.",
        nessuna_risposta: "Nessuna risposta dal tracker. Riprova.",
      },
      toast: {
        inviato: "Configurazione inviata con successo!",
        ack_errore: "Il tracker ha segnalato un errore sulla configurazione.",
        nessun_invio: "Nessun tracker raggiunto: configurazione non inviata.",
      },
      confirm: {
        titolo: "Conferma invio configurazione",
        messaggio:
          "Stai per inviare {n} modifiche a {dest} dispositivi. Confermi?",
      },
      session: {
        titolo: "Sessione configurazione tracker",
        destinatari: "Destinatari",
        progresso: "Progresso",
        campi_modificati: "Campi modificati",
        campi_conteggio: "{n} campi",
        errore_label: "Errore",
      },
      pill: {
        descrizione: "{n} campi verso {dest} destinatari",
      },
    },
    comandi_manuali: {
      wizard: {
        step_impianto: "Seleziona impianto",
        placeholder_impianto: "Scegli un impianto...",
        step_mode: "Modalità operativa",
        step_target: "Imposta inclinazione",
        range_target: "Il valore deve essere compreso tra -55° e +55°",
        step_destinatari: "Seleziona destinatari",
        tutti_tracker: "Tutti i tracker dell'impianto",
        lista_tracker: "Seleziona tracker specifici",
        carica_da_gruppo: "Carica da un gruppo di preset...",
        filtro_tracker: "Cerca tracker per nome o ID...",
        step_riepilogo: "Riepilogo comando",
        modalita_compatta: "Modalità compatta",
        modalita_guidata: "Guidata",
        modalita_expert: "Expert",
        lista_sub: "Scegli i singoli tracker o carica un gruppo",
        selezionati: "selezionati",
      },
      toolbar: {
        titolo: "Controllo dispositivi",
        tracker_disponibili: "tracker disponibili",
        tracker_lower: "tracker",
        pannello_completo: "Pannello completo",
        preset_rapidi: "Preset rapidi",
        stop_tutti: "Stop tutti",
        auto_tutti: "Auto tutti",
        manuale: "Manuale",
        preset_orizzontale: "Orizzontale (0°)",
        preset_est: "(est)",
        preset_ovest: "(ovest)",
        angolo_personalizzato: "Angolo personalizzato…",
        gruppi_salvati: "Gruppi salvati",
        apri_per_gruppo: "Apri il pannello con questo gruppo preselezionato",
        invio_rapido: "Invio rapido",
        azione: "Azione",
      },
      mode: {
        stop: "STOP",
        stop_desc: "Arresta immediatamente il movimento dei tracker",
        manual: "Manuale",
        manual_desc: "Sposta i tracker a un'inclinazione target specifica",
        auto: "Automatico",
        auto_desc: "Ripristina l'inseguimento solare automatico",
      },
      col: {
        nome: "Nome Tracker",
        id_device: "ID Dispositivo",
      },
      label: {
        impianto: "Impianto",
        mode: "Modalità",
        target: "Inclinazione Target",
        destinatari: "Destinatari",
      },
      button: {
        conferma_invia: "Conferma e Invia",
      },
      confirm: {
        titolo: "Attenzione: Invio Comando",
        warning_movimento:
          "Stai per inviare un comando manuale che sposterà i dispositivi fisici. Assicurati che non ci siano operazioni di manutenzione in corso.",
        riepilogo:
          "Invia modalità {mode}{target} a {n} dispositivi sull'impianto '{impianto}'.",
      },
      await: {
        titolo: "Comandi in attesa",
        tracker_inviati: "Tracker inviati",
        tracker_non_raggiunti: "Tracker non raggiunti",
        risposte_ricevute: "Risposte ricevute",
        in_attesa: "In attesa di risposta...",
        in_attesa_breve: "in attesa",
        quadro: "Quadro",
      },
      dialog: {
        nessun_comando_attivo: "Nessun comando attivo",
        nessun_comando_attivo_sottotitolo:
          "I comandi inviati ai tracker compariranno qui in attesa di conferma.",
        sessioni_attive: "Sessioni attive",
        pulisci_completati: "Pulisci completati",
        rimuovi_comando: "Rimuovi comando",
      },
      pill: {
        in_attesa: "Comandi in corso",
        tutti_completati: "Tutti completati",
        quadri: "quadri",
        sessioni: "sessioni",
        trascina: "Trascina per spostare",
        espandi: "Espandi finestra",
      },
      session: {
        completata: "Sessione completata",
        in_corso: "Sessione in corso",
        completata_label: "Completata",
        live: "Live",
        comando: "Comando",
        progresso_quadri: "Progresso quadri",
        quadri_attesi: "Quadri attesi",
        tracker_anonimo: "Tracker",
        senza_risposta_label: "Senza risposta",
      },
      descrizione: {
        stop: "Stop · {n} tracker",
        manual: "Manuale {target}° · {n} tracker",
        auto: "Auto · {n} tracker",
        generico: "Comando · {n} tracker",
      },
    },
    log_comandi_manuali: {
      statistiche: "Statistiche",
      titolo_dettaglio: "Dettaglio Comando",
      titolo_confronto: "Confronto Comandi",
      tooltip: {
        confronta_disabled: "Seleziona esattamente 2 comandi per confrontarli",
      },
      button: {
        confronta: "Confronta",
        reset_filtri: "Reset filtri",
      },
      toast: {
        errore_caricamento: "Errore nel caricamento dei comandi",
      },
      filtro: {
        titolo: "Filtri",
        impianto: "Impianto",
        utente: "Utente",
        mode: "Modalità",
        status: "Stato",
        periodo: "Periodo",
        target_min: "Target min (°)",
        target_max: "Target max (°)",
        request_id: "Request ID",
        attesa_oltre: "In attesa oltre (min)",
      },
      colonna: {
        createdAt: "Data invio",
        impianto: "Impianto",
        utente: "Utente",
        mode: "Modalità",
        target: "Target",
        tracker_count: "Tracker",
        response_status: "Stato risposta",
        latency: "Latenza",
        request_id: "Request ID",
        azioni: "Azioni",
        quadro: "Quadro",
        tracker_richiesti: "Tracker richiesti",
        esito_invio: "Esito invio",
        ack_status: "Stato ACK",
        ack_at: "ACK ricevuto",
        errore: "Errore",
      },
      mode: {
        stop: "Stop",
        manual: "Manuale",
        auto: "Auto",
      },
      status: {
        ok: "OK",
        error: "Errore",
        pending: "In attesa",
        attesa_da: "In attesa da {min}m",
        offline: "Offline",
        no_response: "Nessuna risposta",
      },
      dst_all: {
        tutti: "Tutti",
        selezione: "Selezione",
      },
      stats: {
        totale: "Totale comandi",
        per_mode: "Per modalità",
        per_status: "Per stato",
        top_impianti: "Top impianti",
        periodo: "Tutti i periodi",
      },
      dettaglio: {
        informazioni_generali: "Informazioni generali",
        matrice_quadri: "Matrice quadri / esiti",
        timeline_ack: "Timeline ACK",
        json_grezzi: "JSON grezzi",
        errore_globale: "Errore globale",
        nessuna_risposta: "Nessuna risposta ricevuta",
        evento_invio_label: "Comando inviato",
        delta_dopo_invio: "dopo invio",
      },
      confronto: {
        riepilogo: "Riepilogo",
        scalar_differenti: "Campi scalari differenti",
        tracker_richiesti: "Tracker richiesti",
        esiti_per_quadro: "Esiti per quadro",
        risposte_quadri: "Risposte quadri",
        campo: "Campo",
        label_a: "Comando A",
        label_b: "Comando B",
        nessuna_differenza_scalare: "Nessuna differenza nei campi scalari",
        solo_in_a: "Solo in A",
        solo_in_b: "Solo in B",
        comuni: "Comuni",
        changed: "Modificati",
      },
    },
    gruppi_tracker: {
      tooltip: {
        elimina_selezionati:
          "Seleziona prima un impianto per eliminare i gruppi",
      },
      seleziona_impianto: "Seleziona un impianto per visualizzare i gruppi",
      placeholder: {
        ricerca: "Cerca gruppo...",
        scegli_impianto: "Scegli un impianto",
      },
      label: {
        impianto: "Impianto",
        nome: "Nome gruppo",
        descrizione: "Descrizione",
        colore: "Colore",
        personalizzato: "Personalizzato",
        nessun_gruppo_presente: "Nessun gruppo presente per questo impianto",
      },
      col: {
        nome: "Nome",
        descrizione: "Descrizione",
        num_membri: "Membri",
        azioni: "Azioni",
        id_device: "ID Dispositivo",
      },
      confirm: {
        elimina_titolo: "Conferma eliminazione",
        elimina_messaggio: 'Sei sicuro di voler eliminare il gruppo "{nome}"?',
      },
      dialog: {
        titolo_nuovo: "Nuovo gruppo tracker",
        titolo_modifica: "Modifica gruppo tracker",
      },
      banner: {
        overline: "Gruppo",
        placeholder_nome: "Nome gruppo...",
        membri: "Membri",
      },
      section: {
        dati: "Dati gruppo",
        membri: "Membri",
      },
      empty: {
        no_impianto_title: "Nessun impianto selezionato",
        no_impianto_hint:
          "Seleziona un impianto per visualizzare i tracker disponibili",
      },
      error: {
        nome_richiesto: "Il nome è obbligatorio",
        almeno_un_tracker: "Seleziona almeno un tracker",
        salvataggio_fallito: "Errore durante il salvataggio del gruppo",
        nome_duplicato: "Esiste già un gruppo con questo nome",
        payload_invalido: "Payload non valido",
        permesso_negato: "Permesso negato",
        tracker_non_appartiene_impianto:
          "Uno o più tracker non appartengono all'impianto selezionato",
        colore_invalido: "Colore non valido",
      },
    },
    modelli_inverter: {
      tooltip: {
        elimina_selezionati: "Archivia i modelli selezionati",
      },
      placeholder: {
        ricerca: "Cerca modello inverter...",
      },
      label: {
        marca: "Marca",
        modello: "Modello",
        potenza_ac_max: "Potenza massima AC",
        mppt_indipendenti: "MPPT indipendenti",
        ingressi_per_mppt: "Ingressi per MPPT",
        tensione_dc_min: "Tensione DC minima",
        tensione_dc_max: "Tensione DC massima",
        efficienza_max: "Efficienza massima",
        link_produttore: "Link al sito del produttore",
        apri_link: "Apri la scheda prodotto",
        anteprima_immagine: "Anteprima immagine",
      },
      col: {
        marca: "Marca",
        modello: "Modello",
        immagine: "Immagine",
        potenza_ac_max: "Potenza max AC",
        mppt_indipendenti: "MPPT indipendenti",
        ingressi_per_mppt: "Ingressi per MPPT",
        tensione_dc_min: "Tensione DC min",
        tensione_dc_max: "Tensione DC max",
        efficienza_max: "Efficienza max",
        link_produttore: "Link produttore",
        apri: "Apri",
        azioni: "Azioni",
      },
      section: {
        dati: "Dati modello",
        dati_tecnici: "Dati tecnici",
        immagine: "Immagine del modello",
      },
      dialog: {
        titolo_nuovo: "Nuovo modello inverter",
        titolo_modifica: "Modifica modello inverter",
      },
      confirm: {
        elimina_titolo: "Conferma archiviazione",
        elimina_messaggio:
          'Sei sicuro di voler archiviare il modello "{nome}"?',
      },
      error: {
        nome_richiesto: "Il nome è obbligatorio",
        nome_duplicato: "Esiste già un modello di inverter con questo nome",
        modello_duplicato:
          "Esiste già un modello di inverter con questa marca e questo modello",
        marca_non_valida: "Marca non valida",
        modello_non_valido: "Modello non valido",
        potenza_non_valida: "Potenza massima AC non valida",
        mppt_non_valido: "Numero di MPPT/ingressi non valido",
        tensione_non_valida:
          "Intervallo di tensione DC non valido: il minimo non può superare il massimo",
        efficienza_non_valida: "Efficienza massima non valida (0-100%)",
        link_non_valido:
          "Link non valido: deve iniziare con http:// oppure https://",
        payload_invalido: "Payload non valido",
        permesso_negato: "Permesso negato",
        salvataggio_fallito: "Errore durante il salvataggio del modello",
      },
    },
    utenti_api: {
      placeholder: {
        ricerca: "Cerca utente API...",
      },
      button: {
        kit_integratore: "Kit integratore",
      },
      tooltip: {
        kit_integratore:
          "Scarica guida ed esempi da consegnare all'integratore insieme alle credenziali",
      },
      col: {
        nome: "Nome",
        username: "Username",
        attivo: "Attivo",
        permesso_comandi: "Comandi",
        impianti: "Impianti",
        token_attivi: "Token attivi",
        ultimo_login: "Ultimo login",
        ultimo_cambio_password: "Ultimo cambio password",
        azioni: "Azioni",
      },
      label: {
        nessun_utente: "Nessun utente API",
        attivo: "Attivo",
        disattivo: "Disattivo",
        comandi_abilitati: "Comandi abilitati",
        sola_lettura: "Sola lettura",
        mai: "Mai",
        nome: "Nome",
        username: "Username",
        password: "Password",
        permesso_comandi: "Permesso di inviare comandi",
        ip_ammessi: "IP ammessi",
        impianti: "Impianti assegnati",
      },
      sezione: {
        anagrafica: "Anagrafica",
        accesso: "Accesso",
        impianti: "Impianti",
      },
      hint: {
        ip_ammessi:
          "Indirizzi IPv4/IPv6 o subnet CIDR, premi Invio per aggiungerli. Se vuoto, l'accesso è consentito da qualsiasi IP.",
      },
      dialog: {
        titolo_crea: "Nuovo utente API",
        titolo_modifica: "Modifica utente API",
        titolo_password: "Password dell'utente API",
        avviso_password:
          "Copia la password adesso: dopo la chiusura di questa finestra non sarà più visibile.",
      },
      confirm: {
        permesso_comandi_titolo: "Abilitare i comandi?",
        permesso_comandi_messaggio:
          "Con questo permesso l'utente API potrà inviare comandi che muovono i tracker degli impianti assegnati. Continuare?",
        rigenera_password_titolo: "Rigenerare la password?",
        rigenera_password_messaggio:
          "Verrà generata una nuova password per {nome}: quella attuale smetterà di funzionare e tutti i token attivi saranno revocati.",
        revoca_token_titolo: "Revocare i token?",
        revoca_token_messaggio:
          "Tutti i token attivi di {nome} saranno revocati: il portale dovrà rifare il login.",
        elimina_titolo: "Eliminare l'utente API?",
        elimina_messaggio:
          "L'utente API {nome} sarà eliminato e i suoi token revocati: il portale non potrà più accedere alle API.",
        elimina_selezionati_messaggio:
          "Gli utenti API selezionati ({n}) saranno eliminati e i loro token revocati: i portali non potranno più accedere alle API.",
      },
      toast: {
        creato: "Utente API creato",
        aggiornato: "Utente API aggiornato",
        eliminato: "Eliminazione completata",
        token_revocati: "Token revocati",
        password_copiata: "Password copiata negli appunti",
        password_rigenerata: "Nuova password generata",
        copia_non_riuscita: "Copia non riuscita: copia la password a mano",
        kit_non_scaricato: "Download del kit integratore non riuscito",
      },
      error: {
        payload_invalido: "Dati non validi",
        nome_non_valido: "Nome obbligatorio, al massimo 255 caratteri",
        username_non_valido:
          "Username da 3 a 100 caratteri: lettere, numeri, punto, trattino o underscore",
        username_duplicato: "Username già in uso",
        ip_non_valido: "Indirizzo IP o subnet non valido",
        impianti_non_validi: "Uno o più impianti non sono validi",
        utente_non_trovato: "Utente API non trovato",
      },
    },
    primevue: {
      accept: "Si",
      addRule: "Aggiungi regola",
      am: "AM",
      apply: "Applica",
      cancel: "Annulla",
      choose: "Scegli",
      chooseDate: "Seleziona Data",
      chooseMonth: "Seleziona Mese",
      chooseYear: "Seleziona Anno",
      clear: "Cancella tutto",
      completed: "Completato",
      contains: "Contiene",
      custom: "Personalizzato",
      dateAfter: "La data è successiva",
      dateBefore: "La data è precedente",
      dateFormat: "dd/mm/yy",
      dateIs: "La data è",
      dateIsNot: "La data non è",
      dayNames: [
        "Domenica",
        "Lunedi",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato",
      ],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      emptyFilterMessage: "Nessuna opzione disponibile",
      emptyMessage: "Nessun risultato trovato",
      emptySearchMessage: "Nessun risultato trovato",
      emptySelectionMessage: "Nessun elemento selezionato",
      endsWith: "Finisce con",
      equals: "Equivale",
      fileChosenMessage: "{0} file",
      fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      filter: "Filtro",
      firstDayOfWeek: 1,
      gt: "Maggiore di",
      gte: "Maggiore o uguale a",
      lt: "Minore di",
      lte: "Minore o uguale a",
      matchAll: "Abbina tutto",
      matchAny: "Abbina alcuni",
      medium: "Medio",
      monthNames: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      monthNamesShort: [
        "Gen",
        "Feb",
        "Mar",
        "Apr",
        "Mag",
        "Giu",
        "Lug",
        "Ago",
        "Set",
        "Ott",
        "Nov",
        "Dic",
      ],
      nextDecade: "Decade successiva",
      nextHour: "Ora successiva",
      nextMinute: "Minuto successivo",
      nextMonth: "Mese successivo",
      nextSecond: "Secondo successivo",
      nextYear: "Anno successivo",
      noFileChosenMessage: "Nessun file scelto",
      noFilter: "Senza Filtro",
      notContains: "Non contiene",
      notEquals: "Non uguale",
      now: "Ora attuale",
      passwordPrompt: "Inserisci la password",
      pending: "In corso",
      pm: "PM",
      prevDecade: "Decade precedente",
      prevHour: "Ora precedente",
      prevMinute: "Minuto precedente",
      prevMonth: "Mese precedente",
      prevSecond: "Secondo precedente",
      prevYear: "Anno precedente",
      reject: "No",
      removeRule: "Rimuovi regola",
      searchMessage: "{0} risultati disponibili",
      selectionMessage: "{0} elementi selezionati",
      showMonthAfterYear: false,
      startsWith: "Inizia con",
      strong: "Forte",
      today: "Oggi",
      upload: "Carica",
      weak: "Debole",
      weekHeader: "Sett",
      licenze: {
        errors: {
          notifiche_non_consentite_perpetua:
            "Le notifiche non sono consentite per le licenze perpetue",
          tipologia_periodo_non_valida: "Tipologia periodo non valida",
          valore_notifica_non_valido: "Valore notifica non valido",
          valore_notifica_oltre_limite:
            "Valore notifica oltre il limite consentito",
          notifiche_duplicate: "Notifiche duplicate (tipologia + valore)",
          campi_obbligatori_mancanti: "Campi obbligatori mancanti",
          durata_mesi_non_valida: "Durata mesi non valida",
          chiave_duplicata: "Valore duplicato non consentito",
          id_non_valido: "ID non valido",
          licenza_non_trovata: "Licenza non trovata",
        },
      },
      aria: {
        cancelEdit: "Annulla modifica",
        close: "Chiudi",
        collapseLabel: "Riduci",
        collapseRow: "Riduci riga",
        editRow: "Modifica riga",
        expandLabel: "Espandi",
        expandRow: "Espandi riga",
        falseLabel: "Falso",
        filterConstraint: "Costante di filtro",
        filterOperator: "Operatore di filtro",
        firstPageLabel: "Prima pagina",
        gridView: "Griglia",
        hideFilterMenu: "Nascondi Menu filtri",
        jumpToPageDropdownLabel: "Vai alla Dropdown delle pagine",
        jumpToPageInputLabel: "Vai all'Input delle pagine",
        lastPageLabel: "Ultima pagina",
        listLabel: "Elenco delle opzioni",
        listView: "Lista",
        moveAllToSource: "Muovi tutto alla sorgente",
        moveAllToTarget: "Muovi tutto all'elemento",
        moveBottom: "Vai in fondo",
        moveDown: "Vai sotto",
        moveTop: "Vai in cima",
        moveToSource: "Vai alla sorgente",
        moveToTarget: "Vai all'elemento",
        moveUp: "Vai sopra",
        navigation: "Naviga",
        next: "Successivo",
        nextPageLabel: "Pagina successiva",
        nullLabel: "Non selezionato",
        otpLabel: "Inserisci il carattere della password monouso {0}",
        pageLabel: "Pagina {page}",
        passwordHide: "Nascondi password",
        passwordShow: "Mostra password",
        previous: "Precedente",
        prevPageLabel: "Pagina precedente",
        removeLabel: "Rimuovere",
        rotateLeft: "Ruota a sinistra",
        rotateRight: "Ruota a destra",
        rowsPerPageLabel: "Elementi per pagina",
        saveEdit: "Salva modifica",
        scrollTop: "Torna sù",
        selectAll: "Seleziona tutti gli elementi",
        selectLabel: "Seleziona",
        selectRow: "Seleziona riga",
        showFilterMenu: "Mostra Menu filtri",
        slide: "Scorri",
        slideNumber: "{slideNumber}",
        star: "1 stella",
        stars: "{star} stelle",
        trueLabel: "Vero",
        unselectAll: "Deseleziona tutti gli elementi",
        unselectLabel: "Deseleziona",
        unselectRow: "Deseleziona riga",
        zoomImage: "Zoom Immagine",
        zoomIn: "Ingrandisci",
        zoomOut: "Riduci",
      },
    },
    codice_fiscale_non_valido: "Codice fiscale non valido",
    inclinazione: "Inclinazione",
    batteria: "Batteria",
    segnale: "Segnale",
    versione_software: "Versione SW",
    versione_hardware: "Versione HW",
    username_gia_esistente_nel_database: "Username già esistente nel database",
    menu_amministratori: "Amministratori",
    menu_aziende: "Aziende",
    menu_missioni: "Missioni",
    menu_anagrafiche: "Anagrafiche",
    menu_strumenti_backup: "Backup",
    menu_strumenti_log: "Log",
    menu_strumenti_manutenzioni: "Manutenzioni",
    menu_strumenti_statistiche: "Statistiche",
    menu_strumenti: "Strumenti",
    menu_emails_envirologic: "Emails Envirologic",
    menu_evocleaners: "Evocleaners",
    menu_utenti: "Utenti",
    menu_strumenti_comunicazioni: "Comunicazioni",
    menu_proprietario: "Proprietari",
    menu_impianti: "Impianti",
    menu_amministratore: "Amministratori",
    menu_tecnico: "Tecnici",
    menu_licenze: "Licenze",
    menu_configurazioni: "Configurazioni",
    numero_impianti_associati: "Impianti associati",
    menu_cerca_nel_menu: "Cerca nel menu...",
    menu_strumenti_log_connessioni: "Log connessioni",
    menu_strumenti_database: "Database",
    menu_centraline_connesse: "Centraline connesse",
    menu_gruppi_trackers: "Gruppi Trackers",
    menu_modelli_inverters: "Modelli Inverters",
    menu_utenti_api: "Utenti API",
    database_console: {
      export_troncato:
        "Esportazione troncata: sono state esportate solo le prime {n} righe",
      blocco_sola_lettura:
        "Modalità sola lettura attiva: le query di scrittura sono bloccate",
      indici: "Indici",
      recenti: "Query recenti",
      preferiti: "Favoriti",
      usa: "Usa",
      ordine_non_stabile:
        "L'ordine non è stabile: i risultati possono differire tra esecuzioni",
      nessuno: "Nessuno",
      salva_preferito: "Salva la query attuale nei preferiti",
      nome_preferito: "Nome preferito",
      struttura: "Struttura tabella",
      tabelle: "Tabelle",
      cerca_tabella: "Cerca tabella...",
      nessuna_tabella: "Nessuna tabella trovata",
      nessun_risultato: "Nessun risultato",
      editor_placeholder: "Scrivi qui la tua query SQL...",
      scorciatoia_esegui: "Ctrl/Cmd + Invio per eseguire",
      errore_query: "Errore nell'esecuzione della query",
      righe_restituite: "{n} righe restituite",
      righe_interessate: "{n} righe interessate",
      istruzioni:
        "Seleziona una tabella o scrivi una query SQL e premi Esegui per visualizzare i risultati.",
      colonne: "Colonne",
      tipo: "Tipo",
      copia_cella: "Copia valore",
      cella_copiata: "Valore copiato negli appunti",
      copia_riga: "Copia riga (JSON)",
      riga_copiata: "Riga copiata negli appunti",
      conferma_write: "Questa query modifica dei dati. Vuoi eseguirla?",
      conferma_write_senza_where:
        "ATTENZIONE: UPDATE/DELETE senza clausola WHERE — verranno interessate TUTTE le righe. Eseguire comunque?",
      chiave_primaria: "Chiave primaria",
      colonna: "Colonna",
      conferma_ddl: "Confermi l'esecuzione di questo comando DDL?",
      default_col: "Default",
      esegui_select: "Esegui SELECT",
      nullable: "Nullable",
      per_eseguire: "per eseguire",
      pk_fk: "PK / FK",
      righe_stimate: "Righe stimate",
      sola_lettura: "Sola lettura",
      sola_lettura_tooltip:
        "Modalità sola lettura: sono consentite solo query SELECT.",
      stringa_vuota: "(stringa vuota)",
      svuota_recenti: "Svuota recenti",
      timeout_hint: "La query ha superato il tempo massimo di esecuzione.",
      troncato: "Risultato troncato",
    },
    menu_recenti: "Recenti",
    impianto_gia_associato_dal_proprietario:
      "Questo impianto è già stato associato dal proprietario. Contatta il supporto per assistenza.",
    licenze: {
      archiviazione: {
        tutte_con_impianti:
          "Nessuna licenza archiviabile: tutte quelle selezionate hanno impianti associati",
        alcune_con_impianti:
          "Alcune licenze selezionate hanno impianti associati e non verranno archiviate",
      },
      errors: {
        id_non_valido: "ID licenza non valido",
        licenza_non_trovata: "Licenza non trovata",
        campi_obbligatori_mancanti: "Campi obbligatori mancanti",
        durata_mesi_non_valida: "Durata in mesi non valida",
        tipologia_periodo_non_valida: "Tipologia di periodo non valida",
        chiave_duplicata: "Esiste già una licenza con questa chiave",
        notifiche_duplicate: "Sono presenti notifiche duplicate",
        notifiche_non_consentite_perpetua:
          "Le notifiche di scadenza non sono consentite sulle licenze perpetue",
        valore_notifica_non_valido: "Valore della notifica non valido",
        valore_notifica_oltre_limite:
          "Il valore della notifica supera la durata della licenza",
        destinatari_amministrazione_non_configurati:
          "Destinatari amministrazione non configurati",
        cambio_tipologia_con_associazioni_non_consentito:
          "Non è possibile cambiare tipologia: la licenza ha impianti associati",
      },
      notifiche_scadenza: "Notifiche scadenza licenze",
      note: "Note",
      inserisci_durata: "Inserisci durata in mesi",
      durata_mesi: "Durata (mesi)",
      tipo: "Tipo",
      nome_licenza: "Nome licenza",
      notifica_amministrazione: "Notifica amministrazione",
      invia_preavviso: "Invia preavviso scadenza",
      tipologia_periodo: "Tipologia periodo notifiche",
      riepilogo: "Riepilogo",
      aggiungi_notifica: "Aggiungi notifica",
      auto_fix_notifiche:
        "Correggi automaticamente notifiche fuori range al salvataggio.",
      filtro: {
        periodo: "Periodo",
        tipo: "Tipo",
        durata_min: "Durata minima",
        durata_max: "Durata massima",
        reset: "Reimposta",
      },
      impianti_associati: "Impianti associati",
    },
    detail: {
      creazione_eseguita: "Creazione eseguita",
      modifica_eseguita: "Modifica eseguita",
      aggiornamento_eseguito: "Aggiornamento eseguito",
      manca_id_elemento: "Manca ID elemento",
      nessun_elemento_selezionato_per_esportazione:
        "Nessun elemento selezionato per esportazione",
    },
    button: {
      esporta: "Esporta",
      repeater: "Repeater",
      esegui: "Esegui",
      modifica: "Modifica",
      tabella: "Tabella",
      ricarica: "Ricarica",
      reset_filtri: "Azzera filtri",
      elimina_selezionati: "Elimina selezionati",
      crea_backup: "Crea backup",
      elimina: "Elimina",
      annulla: "Annulla",
      scarica: "Scarica",
      aggiorna_tabella: "Aggiorna tabella",
      aggiorna: "Aggiorna",
      pagina: "Pagina",
      conferma: "Conferma",
      crea: "Crea",
      imposta_logo_azienda: "Imposta logo azienda",
      rimuovi: "Rimuovi",
      avanti: "Avanti",
      indietro: "Indietro",
      genera_password: "Genera password",
      cambia_password: "Cambia password",
      ricalcola_coordinate: "Ricalcola coordinate",
      calcola_coordinate: "Calcola coordinate",
      mostra_dettagli: "Mostra dettagli",
      salva: "Salva",
      ripristina: "Ripristina",
      riprova: "Riprova",
      invia: "Invia",
      importa: "Importa",
      chiudi: "Chiudi",
      visualizza: "Visualizza",
      aggiungi_nodo: "Aggiungi nodo",
      aggiungi_kml: "Gestisci File KML",
      anemometro: "Anemometro",
      direzionevento: "Direzione vento",
      importa_csv: "Importa CSV",
      inverter: "Inverter",
      meteo: "Stazione meteo",
      tracker_meteo: "Tracker meteo",
      quadro: "Quadro",
      ripristina_vista: "Ripristina vista",
      tracker: "Tracker",
      vela: "Vela",
      vento: "Vento",
      elimina_quadro: "Elimina quadro",
      modifica_credenziali: "Modifica credenziali",
      no_grazie: "No grazie",
      attiva_tema_scuro: "Attiva tema scuro",
      tutti: "Tutti",
      nessuno: "Nessuno",
      nuovo: "Nuovo",
    },
    label: {
      seleziona_quadro: "Seleziona quadro",
      dettagli: "Dettagli",
      direzionevento: "Vento",
      anemometro: "Anemometro",
      dispositivo: "Dispositivo",
      inverter: "Inverter",
      tipo: "Tipo",
      vela: "Vela",
      gruppo: "Gruppo",
      tracker: "Tracker",
      adatta_vista: "Adatta vista",
      totale_elementi: "Totale elementi",
      tracker_associati: "Tracker associati",
      azioni: "Azioni",
      dettagli_vela: "Dettagli Vela",
      altezza: "Altezza",
      caricamento: "Caricamento...",
      codice_locale: "Codice locale",
      codice_locale_auto: "Il codice locale verrà generato automaticamente",
      conn_type: "Tipo connessione",
      distanza: "Distanza",
      filtra_componenti: "Filtra componenti",
      filtri_tipo: "Filtri per tipo",
      id_device: "ID dispositivo",
      id_mac_device: "MAC dispositivo",
      impianto: "Impianto",
      larghezza: "Larghezza",
      latitudine: "Latitudine",
      longitudine: "Longitudine",
      lunghezza: "Lunghezza",
      marca: "Marca",
      misure_vela: "Misure vela",
      modello: "Modello",
      nome: "Nome",
      nome_inverter: "Nome inverter",
      nome_tracker: "Nome tracker",
      nome_vela: "Nome vela",
      offset_direzione: "Offset direzione",
      reset_vista: "Reset vista",
      righe_visualizzate: "Righe visualizzate",
      type_code: "Tipo nodo",
      unita_misura: "Unità di misura",
      vela_collegata: "Vela collegata",
      velocita_max: "Velocità massima",
      zoom_in: "Zoom in",
      zoom_out: "Zoom out",
      titolo_scada: "SCADA Telemetria",
      placeholder_filtra_componenti: "Cerca Tracker, Inverter, Meteo...",
      placeholder_tutti_tipi: "Tutti i tipi",
      totale_tracker_help: "Totale tracker/vele presenti nel dataset corrente.",
      righe_help:
        "Numero di righe richieste per distribuire visivamente le vele nella mappa.",
      colonne_help:
        "Numero di colonne calcolate automaticamente in base a totale tracker e righe richieste.",
      totale_abbr: "Tot",
      righe_abbr: "R",
      colonne_abbr: "C",
      tipo_hardware: "Tipo hardware",
      // Modifiche xxx
      vers_so: "Versione Sistema Operativo",
      vers_app: "Versione Applicazione",
      // FINE - Modifiche xxx
      username_quadro: "Username quadro",
      crea_nodo: "Crea nodo",
      misure: "Misure",
      device_id: "Device ID",
      stato: "Stato",
      id_sensore: "ID Sensore",
      gruppo_inverter: "Gruppo Inverter",
      stazione_meteo: "Stazione Meteo",
      direzione_vento: "Direzione Vento",
      motore: "Motore",
      vela_default: "Vela",
      quadro_default: "Quadro",
      password_quadro: "Password quadro",
      password_nascosta: "•••••••• (nascosta)",
      password_lascia_vuoto: "Lascia vuoto per non modificare",
      id: "ID",
      nessun_dato: "Nessun dato",
      repeater: "Repeater",
    },
    tracker_status_cf: {
      ok: "OK",
      timeout: "Timeout",
      offline: "Offline",
      nd: "N/A",
      refused: "Rifiutato",
    },
    tracker_status: {
      ok: "Online",
      allarme: "Allarme",
      offline: "Offline",
      nd: "N/D",
    },
    tracker_mode: {
      stop: "Stop",
      manual: "Manuale",
      auto: "Auto",
      local: "Locale",
      emergency: "Emergenza",
      safety: "Sicurezza",
    },
    weather_code: {
      sereno: "Sereno",
      prevalentemente_sereno: "Prevalentemente sereno",
      parzialmente_nuvoloso: "Parzialmente nuvoloso",
      coperto: "Coperto",
      nebbia: "Nebbia",
      nebbia_con_brina: "Nebbia con brina",
      pioggerella_leggera: "Pioggerella leggera",
      pioggerella_moderata: "Pioggerella moderata",
      pioggerella_intensa: "Pioggerella intensa",
      pioggerella_gelata_leggera: "Pioggerella gelata leggera",
      pioggerella_gelata_intensa: "Pioggerella gelata intensa",
      pioggia_leggera: "Pioggia leggera",
      pioggia_moderata: "Pioggia moderata",
      pioggia_intensa: "Pioggia intensa",
      pioggia_gelata_leggera: "Pioggia gelata leggera",
      pioggia_gelata_intensa: "Pioggia gelata intensa",
      neve_leggera: "Neve leggera",
      neve_moderata: "Neve moderata",
      neve_intensa: "Neve intensa",
      granelli_di_neve: "Granelli di neve",
      rovesci_leggeri: "Rovesci leggeri",
      rovesci_moderati: "Rovesci moderati",
      rovesci_violenti: "Rovesci violenti",
      rovesci_di_neve_leggeri: "Rovesci di neve leggeri",
      rovesci_di_neve_intensi: "Rovesci di neve intensi",
      temporale: "Temporale",
      temporale_con_grandine_leggera: "Temporale con grandine leggera",
      temporale_con_grandine_intensa: "Temporale con grandine intensa",
      ignoto: "Ignoto",
    },
    toolbar: {
      contrai_sidebar_tabelle: "Contrai sidebar tabelle",
      espandi_sidebar_tabelle: "Espandi sidebar tabelle",
    },
    versioni_firmware: "Versioni firmware",
    impianti: {
      scegli_versione_fw: "Scegli versione firmware",
      versione_firmware: "Versione firmware",
    },
    dashboard: {
      layout_solo_lista: "Solo lista",
      layout_diviso: "Vista divisa",
      layout_solo_mappa: "Solo mappa",
      dispositivi_totali: "Dispositivi totali",
      configurazione_tracker: "Configurazione tracker",
      configurazione_tracker_offline: "Impossibile Configurare tracker offline",
      ultimo_comando_remoto: "Ultimo comando remoto",
      feedback_ultimo_comando_remoto: "Feedback ultimo comando remoto",
      comandi_manuali: "Comandi manuali",
      analisi_tracker_raw_label: "Analisi tracker RAW",
      legenda_stato_tracker: "Stato",
      legenda_modalita_tracker: "Modalità",
      legenda_vento: "Vento",
      nessun_impianto_trovato: "Nessun impianto trovato.",
      cerca_impianto: "Cerca impianto...",
      modalita_selezionate: "Modalità selezionate",
      wind_threshold_tooltip_0: "Nessun allarme vento rilevato sull'impianto",
      trackers: "Trackers",
      angolo_attuale: "Angolo attuale",
      angolo_target: "Angolo target",
      cerca_tracker: "Cerca tracker per nome o ID...",
      filtra_stato: "Filtra per stato",
      filtra_modalita: "Filtra per modalità",
      stati_selezionati: "{0} stati selezionati",
      filtri: "Filtri",
      ordina: "Ordina",
      ordina_per: "Ordina per",
      crescente: "Crescente",
      decrescente: "Decrescente",
      dispositivi_trovati: "dispositivi trovati",
      tipologia_filtro: "Filtra per tipologia tracker",
      non_root: "Non root",
      root_tutti: "Tutti",
      aggiornato_alle: "Aggiornato alle",
      stato_generale: "Stato generale",
      tracker_totali: "Tracker totali",
      inverter_totali: "Inverter totali",
      batteria_media: "Batteria media",
      mappa_dispositivi: "Mappa dispositivi",
      rete_mesh: "Rete mesh",
      nodi: "Nodi",
      modalita: "Modalità",
      dispositivi: "Dispositivi",
      in_arrivo: "In arrivo",
      impianto: "Impianto",
      impianti: "Impianti",
      health: {
        ok: "Tutto regolare",
        attenzione: "Richiede attenzione",
        offline: "Impianto offline",
        nd: "Stato non disponibile",
        online: "Impianto online",
      },
      root: "Root",
      analisi_tracker: "Analisi tracker",
      tipologia_tracker: "Tipologia tracker",
      ultime_24h: "Ultime 24 ore",
      caricamento: "Caricamento in corso...",
      inclinazione_reale: "Inclinazione reale",
      inclinazione_teorica: "Inclinazione teorica",
      inclinazione_reale_min: "Inclinazione reale minima",
      inclinazione_reale_max: "Inclinazione reale massima",
      inclinazione_teorica_min: "Inclinazione teorica minima",
      inclinazione_teorica_max: "Inclinazione teorica massima",
      banda_min_max_hint: "Banda = escursione min/max nel bucket",
      escursione_label: "Escursione",
      attiva_analisi_tracker_raw_label: "Attiva RAW 1:1",
      disattiva_analisi_tracker_raw_label: "Disattiva RAW 1:1",
      analisi_tracker_raw_hint: "1 punto per riga DB, senza bucket",
      analisi_tracker_raw_tooltip_enable:
        "Attiva la modalità RAW 1:1: il grafico usa 1 punto per ogni riga di tracker_telemetry. Disponibile fino a 7 giorni selezionati.",
      analisi_tracker_raw_tooltip_active:
        "Modalità RAW 1:1 attiva: il grafico usa 1 punto per ogni riga di tracker_telemetry.",
      analisi_tracker_raw_tooltip_disabled:
        "RAW 1:1 disponibile solo fino a 7 giorni selezionati.",
      analisi_tracker_help_title: "Come leggere questo grafico",
      analisi_tracker_help_intro:
        "Il grafico adatta automaticamente la risoluzione al periodo selezionato per restare navigabile. Sulle inclinazioni la linea principale mostra l'ultimo valore disponibile nel bucket, mentre la banda evidenzia l'escursione reale min/max dello stesso intervallo.",
      analisi_tracker_help_current_bucket: "Bucket attuale",
      analisi_tracker_help_resolution_title: "Risoluzione automatica",
      analisi_tracker_help_rule_5m:
        "Per intervalli fino a 1 giorno il grafico usa bucket da 5 minuti: è la vista più dettagliata disponibile e mantiene il comportamento più vicino al dato grezzo.",
      analisi_tracker_help_rule_1h:
        "Per intervalli fino a 7 giorni il grafico raggruppa i dati in bucket da 1 ora per restare leggibile senza perdere i picchi principali.",
      analisi_tracker_help_rule_6h:
        "Per intervalli fino a 31 giorni il grafico usa bucket da 6 ore: la linea mostra l'ultimo valore del bucket, la banda conserva min e max.",
      analisi_tracker_help_rule_1d:
        "Oltre 31 giorni il grafico usa bucket giornalieri per mantenere tempi di caricamento e navigazione stabili.",
      analisi_tracker_help_reading_title: "Come interpretare le serie",
      analisi_tracker_help_line:
        "Le linee di inclinazione reale e teorica mostrano l'ultimo valore disponibile nel bucket selezionato. Se il backend non lo fornisce ancora, viene usata la media come fallback.",
      analisi_tracker_help_band:
        "La banda colorata attorno alle linee mostra l'escursione minima/massima registrata nel bucket: serve a non nascondere spostamenti brevi ma significativi.",
      analisi_tracker_help_health:
        "Batteria e segnale restano serie medie aggregate per bucket: sono utili per il trend generale, non per analizzare singoli picchi rapidi.",
      analisi_tracker_help_events:
        "Le linee verticali tratteggiate indicano gli eventi del tracker nel periodo selezionato e aiutano a collegare i cambi di comportamento al contesto operativo.",
      analisi_tracker_help_raw_mode:
        "Quando attivi RAW 1:1 il grafico ignora i bucket e usa un punto per ogni riga di tracker_telemetry. È più fedele, ma più pesante, quindi viene consentito solo fino a 7 giorni selezionati.",
      analisi_tracker_help_eventi_title: "Eventi sul grafico",
      analisi_tracker_help_eventi_intro:
        "Visibili per periodi fino a 7 giorni. Passa il mouse su una linea per vedere dettaglio e orario.",
      evento_tracker_mode_change: "Cambio modalità",
      evento_tracker_mode_change_help:
        "Il tracker è passato a un'altra modalità (Stop, Manuale, Auto, Locale, Emergenza, Sicurezza).",
      evento_tracker_cr_change: "Cambio comando",
      evento_tracker_cr_change_help:
        "Il tracker ha preso in carico un nuovo comando dalla piattaforma (Stop, Manuale, Auto o Configurazione) oppure ha azzerato l'ultimo.",
      evento_tracker_reset: "Riavvio tracker",
      evento_tracker_reset_help:
        "La scheda del tracker si è riavviata: il contatore dei riavvii è aumentato.",
      evento_tracker_comando_config: "Configurazione",
      evento_tracker_contatore_reset: "Riavvii totali",
      energia_oggi: "Energia oggi",
      potenza_reale: "Potenza reale",
      nome: "Nome",
      stato: "Stato",
      inclinazione: "Inclinazione (R/T)",
      inclinazione_tooltip: "Inclinazione (Reale / Teorica)",
      standard: "Standard",
      batteria: "Batteria",
      segnale: "Segnale",
      versione_software: "Versione SW",
      versione_hardware: "Versione HW",
      andamento: "Andamento",
      modello: "Modello",
      energia: "Energia",
      tensione: "Tensione",
      tensione_batteria: "Tensione batteria",
      reset_counter: "Reset counter",
      motivo_cambio_modalita: "Motivo cambio modalità",
      corrente: "Corrente",
      dettagli: "Dettagli",
      nessun_impianto: "Nessun impianto con coordinate disponibili.",
      mappa_layer: "Stile mappa",
      mappa_layer_auto: "Auto",
      mappa_layer_stradale: "Stradale",
      mappa_layer_chiara: "Chiara",
      mappa_layer_scura: "Scura",
      mappa_layer_satellitare: "Satellitare",
      mappa_layer_ibrida: "Ibrida",
      mappa_layer_topografica: "Topografica",
      mappa_layer_terreno: "Terreno",
      mappa_layer_grigi: "Grigi",
      mappa_layer_umanitaria: "Umanitaria",
      dettagli_tracker: "Dettagli tracker",
      collassa: "Collassa",
      espandi: "Espandi",
      kpi: {
        operativita_auto: "Operatività AUTO",
        operativita: "Operatività",
        allineamento: "Allineamento",
        allineamento_sub_none: "Nessun tracker in AUTO",
        allineamento_sub_count: "{n} tracker in AUTO",
        vento: "Vento corrente",
        vento_velocita: "Velocità vento",
        vento_direzione: "Direzione vento",
        tracker_in_stato: "Tracker in stato",
        tracker_in_modalita: "Tracker in modalità",
        provenienza_api: "Il dato proviene da servizi web meteo",
        provenienza_sensore: "Informazione trasmesse dal sensore dell'impianto.",
        meteo_corrente: "Meteo corrente",
        api_vento: "Vento",
        api_temperatura: "Temperatura",
        api_copertura: "Copertura nuvole",
        api_precipitazioni: "Precipitazioni",
        api_dettagli_precipitazioni: "Dettagli precipitazioni",
        api_tempo: "Tempo",
        stato_tracker: "Dettaglio stato tracker",
        modalita_tracker: "Dettaglio modalità tracker",
        energia: "Dettaglio energia",
        tracker: "tracker",
        kwh_oggi: "kwh giornalieri",
        tracker_non_disponibile: "Tracker non disponibili",
        energia_non_disponibile: "Inverter non disponibili",
        storico_resa: "Storico",
        mappa_impianto: "Mappa Impianto",
        seleziona_vista: "Seleziona vista"
      },
      tracker_stato_ignoto: "Sconosciuto",
      modalita_anomale: "Modalità anomale",
      tracker_stato_ignoto_desc_sing:
        "Lo stato del tracker è sconosciuto in quanto non ha ancora comunicato informazioni con il software.",
      tracker_stato_ignoto_desc_plur:
        "Lo stato dei trackers è sconosciuto in quanto non hanno ancora comunicato informazioni con il software.",
      tracker_stato_ok_desc_sing:
        "Lo stato del tracker è ok.",
      tracker_stato_ok_desc_plur:
        "Lo stato dei trackers è ok.",
      tracker_stato_allarm_desc_sing:
        "Lo stato del tracker è in allarme.",
      tracker_stato_allarm_desc_plur:
        "Lo stato dei trackers è in allarme.",
      tracker_stato_offline_desc_sing:
        "Lo stato del tracker è offline.",
      tracker_stato_offline_desc_plur:
        "Lo stato dei trackers è offline.",
      legenda: "Legenda",
      wind_desc: "Velocità del vento rilevata sull'impianto: ",
      wind_threshold_label_0: "Normale",
      wind_threshold_label_1: "Debole",
      wind_threshold_label_2: "Moderato",
      wind_threshold_label_3: "Forte",
      wind_threshold_tooltip_1: "Allarme vento debole rilevato sull'impianto",
      wind_threshold_tooltip_2: "Allarme vento moderato rilevato sull'impianto",
      wind_threshold_tooltip_3: "Allarme vento forte rilevato sull'impianto",
      tracker_modalita_stop: "Tracker in STOP",
      tracker_modalita_manual: "Tracker in MANUAL",
      tracker_modalita_local: "Tracker in LOCAL",
      tracker_modalita_emergency: "Tracker in EMERGENCY",
      tracker_modalita_safety: "Tracker in SAFETY",
      allarmi_attivi: "Allarmi attivi",
      dati_non_disponibili: "Dati non disponibili",
      azioni_non_disponibili_device: "Azioni non disponibili per questo dispositivo",
      online: "Online",
      riepilogo: "Riepilogo",
      tab_dispositivi: "Dispositivi",
      planimetria_3d: "Planimetria 3D",
      layer_meteo: "Dati meteo",
      non_raggiungibile: "Non raggiungibile",
      no_trackers: "Nessun tracker associato",
      stili_mappa: "Stili Mappa",
      livelli_aggiuntivi: "Livelli Aggiuntivi",
      intensita_pioggia: "Intensità pioggia",
      debole: "Debole",
      grandine: "Grandine",
      label_mobile_tot_imp: "Totale impianti",
      label_mobile_onl_imp: "Impianti Online",
      label_mobile_off_imp: "Impianti Offline",
      label_mobile_all_imp: "Impianti in Allarme",
      show_list: "Vedi Lista",
      risultato: "Risultato",
      risultati: "Risultati",
      no_impianti: "Nessun impianto in questa categoria",
      storicoResa: {
        titolo: "Storico resa impianto",
        potenzaInstallata: "Potenza installata",
        potenzaIstantanea: "Potenza istantanea",
        selezionaPeriodo: "Seleziona il periodo",
        periodi: {
          giornaliero: { "label": "Giornaliero", "breve": "Giorno", "descrizione": "Oggi" },
          settimanale: { "label": "Settimanale", "breve": "Sett.", "descrizione": "Ultimi 7 giorni" },
          mensile: { "label": "Mensile", "breve": "Mese", "descrizione": "Mese corrente" },
          annuale: { "label": "Annuale", "breve": "Anno", "descrizione": "Anno corrente" },
          totale: { "label": "Totale", "breve": "Tot.", "descrizione": "Dall'entrata in esercizio" }
        },
        dalInizio: "Dal {data}",
        kpi: {
          energiaProdotta: "Energia prodotta",
          resaSpecifica: "Resa specifica",
          co2Evitata: "CO₂ risparmiata",
          ricavoIncentivo: "Ricavo incentivo",
          ricavoVendita: "Ricavo vendita",
          guadagnoTotale: "Guadagno totale"
        },
        grafico: {
          energiaProdotta: "Energia prodotta ({unita})",
          ariaLabel: "Grafico dell'energia prodotta, vista {periodo}"
        },
        stati: {
          vuotoTitolo: "Dati di monitoraggio non ancora disponibili",
          vuotoDescrizione: "Il grafico verrà popolato non appena gli inverter dell'impianto inizieranno a trasmettere i dati.",
          erroreTitolo: "Impossibile caricare i dati di monitoraggio",
          riprova: "Riprova"
        },
        nonDisponibile: "N.A.",
        nonDisponibileEsteso: "Dato non disponibile"
      },
      dispositivi: {
        riepilogo: {
          titolo: "Dispositivi impianto",
          stato: "Stato dispositivi",
          totale: "Totale",
          conteggio: "{n} dispositivi | {n} dispositivo | {n} dispositivi",
          barraAria: "Distribuzione dei dispositivi per stato"
        },
        mesh: {
          titolo: "Rete mesh",
          dettaglio: "Dettaglio",
          topologia: "Topologia",
          nodi: "{n} nodi | {n} nodo | {n} nodi",
          elencoAria: "Elenco dei nodi della rete mesh",
          topologiaAria: "Topologia della rete mesh",
          legenda: "Legenda stati",
          comandiGrafico: "Comandi del grafico",
          livello: "livello {n}",
          radice: "Impianto",
          nonCollegati: "Non collegati",
          nascosti: "{n} nodi nascosti | {n} nodo nascosto | {n} nodi nascosti",
          espandiTutto: "Espandi tutto",
          comprimiTutto: "Comprimi tutto",
          espandiRamo: "Espandi ramo",
          comprimiRamo: "Comprimi ramo",
          riduci: "Riduci",
          ingrandisci: "Ingrandisci",
          adatta: "Adatta alla larghezza",
          mostraInTopologia: "Mostra nella topologia"
        },
        filtri: {
          tipologia: "Tipologia dispositivo",
          modalita: "Modalità tracker",
          stato: "Stato tracker",
          tutte: "Tutte",
          tutti: "Tutti",
          azzera: "Azzera filtri"
        },
        comandi: {
          tutti: "Comandi per tutti",
          rapidi: "Comandi rapidi"
        },
        elenco: {
          titolo: "Elenco dispositivi"
        },
        vista: {
          etichetta: "Modalità di visualizzazione",
          tabella: "Tabella",
          griglia: "Griglia"
        },
        stati: {
          ok: "Online",
          alarm: "In allarme",
          offline: "Offline",
          unknown: "Sconosciuto"
        },
        allarmi: {
          titolo: "Ultimi allarmi",
          ordina: "Ordina allarmi",
          gravita: "Gravità",
          recenti: "Recenti",
          nessuno: "Nessun allarme registrato",
          errore: "Impossibile caricare gli allarmi",
          riprova: "Riprova",
          vediTutti: "Vedi tutti ({n})",
          caricamento: "Caricamento…",
          caricaAltri: "Carica altri",
          apertoDa: "Aperto da {durata}",
          durata: {
            giorni: "{n} g",
            ore: "{n} h",
            minuti: "{n} min",
            menoDiUnMinuto: "meno di 1 min"
          }
        }
      }
    },
    misura: {
      metri_secondo: "m/s — metri al secondo",
      km_orari: "km/h — chilometri orari",
      nodi: "kn — nodi",
    },
    message: {
      conferma_elimina_selezionati:
        "Sei sicuro di voler eliminare i {count} backup selezionati?",
      conferma_elimina_backup:
        'Sei sicuro di voler eliminare il backup "{nome}"?',
      coordinate_non_trovate: "Coordinate non trovate per l'indirizzo fornito.",
      coordinate_calcolate: "Coordinate calcolate con successo.",
      conferma_chiusura_dialog: "Sei sicuro di voler chiudere la finestra?",
      id_device_obbligatorio: "ID Device obbligatorio",
      type_code_obbligatorio: "Type code obbligatorio",
      eliminazione_tipo_nodo_non_disponibile:
        "Eliminazione non disponibile per questo tipo nodo",
      conferma_eliminazione_tipo: "Confermi eliminazione {tipo}?",
      nodo_creato: "Nodo creato",
      import_mappa_completato: "Import mappa completato",
      vela_aggiornata: "Vela aggiornata",
      tracker_aggiornato: "Tracker aggiornato",
      inverter_aggiornato: "Inverter aggiornato",
      stazione_meteo_aggiornata: "Stazione meteo aggiornata",
      anemometro_aggiornato: "Anemometro aggiornato",
      direzione_vento_aggiornata: "Direzione vento aggiornata",
      entita_eliminata: "{entita} eliminato/a",
      credenziali_quadro_aggiornate: "Credenziali del quadro aggiornate",
      username_quadro_obbligatorio:
        "Username del quadro obbligatorio (minimo 3 caratteri)",
      password_quadro_obbligatoria:
        "Password del quadro non valida (minimo 3 caratteri)",
      repeater_aggiornato: "Repeater aggiornato",
      import_kml_completato: "Layer cartografico importato con successo"
    },
    datatable: {
      attiva_gridlines: "Attiva linee griglia",
      disattiva_gridlines: "Disattiva linee griglia",
      numero_impianti_associati: "Impianti associati",
      immagine_profilo: "Immagine profilo",
      creatoIl: "Creato il",
      nome_file: "Nome file",
      colonna_bloccata:
        "Colonna bloccata, non è possibile rimuoverla dalla visualizzazione",
      dimensione: "Dimensione",
      stato: "Stato",
      durata: "Durata",
      data: "Data",
      azioni: "Azioni",
      note: "Note",
      dati_non_disponibili: "Dati non disponibili",
      colonne_da_visualizzare: "Colonne da visualizzare",
      cerca: "Cerca...",
      foto_profilo: "Foto profilo",
      profilo: {
        completo: "Completo",
      },
      tutto_completo: "Completo",
      username: "Username",
      email: "Email",
      azienda: "Azienda",
      cognome: "Cognome",
      nome: "Nome",
      data_nascita: "Data di nascita",
      paese_nascita: "Paese di nascita",
      provincia_nascita: "Provincia di nascita",
      stato_nascita: "Stato di nascita",
      telefono: "Telefono",
      indirizzo: "Indirizzo",
      cap: "CAP",
      citta: "Città",
      frazione: "Frazione",
      provincia: "Provincia",
      data_ultimo_login: "Data ultimo login",
      comune_nascita: "Comune di nascita",
      codice_fiscale: "Codice fiscale",
      regione: "Regione",
      ragione_sociale: "Ragione sociale",
      partita_iva: "Partita IVA",
      referente: "Referente",
      numero_utenti_associati: "Numero utenti associati",
      logo_azienda: "Logo azienda",
      nome_impianto: "Nome impianto",
      pec: "PEC",
      impianti: "Impianti",
      nome_licenza: "Nome licenza",
      id: "ID",
    },
    header: {
      impianti_associati: "Impianti associati",
      elimina: "Elimina",
      gestisci_dipendenti_azienda: "Gestisci dipendenti azienda",
      gestisci_dipendenti_impianto: "Gestisci dipendenti impianto",
      conferma_azione: "Conferma azione",
      proprietari_impianti_associati:
        "Proprietari/Tecnici associati all'impianto",
      tecnici_impianti_associati: "Tecnici associati",
    },
    tooltip: {
      apri_impianto: "Apri impianto",
      proprietari_impianti_associati:
        "Proprietari/Tecnici associati all'impianto",
      get_setup: "Recupera i dati del form salvati localmente",
      elimina_setup_localmente: "Elimina i dati del form salvati localmente",
      salva_setup_localmente:
        "Salva i dati del form localmente (nel browser), in modo da poterli recuperare in futuro",
      chiudi: "Chiudi finestra",
      massimizza: "Massimizza/restore finestra",
      minimizza: "Minimizza finestra",
      centra_dialog: "Centra questa finestra",
      visualizza_tabs: "Visualizza dati in formato tabellare",
      visualizza_dataview: "Visualizza dati in formato dataview",
      aggiungi_elemento_creazione: "Aggiungi elemento",
      mostra_nascondi_linee_griglia: "Mostra/nascondi linee griglia",
      rigenera_password: "Rigenera password",
      revoca_token: "Revoca token",
      copia: "Copia",
      salva: "Salva",
      dettagli: "Dettagli",
      cambia_password: "Cambia password",
      cambia_colore_riga: "Cambia colore riga",
      modifica: "Modifica",
      elimina: "Elimina",
      scarica: "Scarica",
      conferma: "Conferma",
      crea: "Crea",
      ultima_volta_sincronizzati: "Data ultima sincronizzazione",
      gestisci_dipendenti_impianto:
        "Gestisci dipendenti associati a questo impianto",
      sposta_a: "Sposta a",
      sinistra: "Sinistra",
      destra: "Destra",
      gestisci_dipendenti_azienda: "Gestisci dipendenti azienda",
      tecnici_impianti: "Tecnici associati all'impianto",
      ancora_destra: "Ancora a destra",
      ancora_sinistra: "Ancora a sinistra",
      chiudi_elemento: "Chiudi elemento",
      scorciatoia_ctrl_b: "Apri/chiudi menu: CTRL + B",
    },
    file_drop: {
      rilascia: "Rilascia il file per caricarlo",
      un_solo_file: "Trascina un solo file alla volta",
    },
    firmware: {
      comprimi_filtri: "Comprimi filtri",
      espandi_filtri: "Espandi filtri",
      impianto: "Impianto",
      non_eliminabile: "Questa versione firmware non può essere eliminata",
      slot_famiglia_hw: "Firmware famiglia {famiglia_hw}",
      famiglia_hw: "Famiglia hardware {famiglia_hw}",
      n_tracker_famiglia_hw: "{n} tracker",
      n_allineati: "{allineati}/{totale} allineati",
      aggiornamento_fermo: "Aggiornamento fermo",
      aggiornato: "Aggiornato",
      fermo_cause: "Aggiornamento fermo: il tracker potrebbe non essere raggiungibile dal parent mesh, oppure aver rifiutato il firmware ed essere tornato alla versione precedente (rollback del tracker). Non è necessariamente un guasto del quadro.",
      formato_supportato: "Solo file .bin (max 50MB)",
      trascina_o_clicca: "Trascina il file qui o clicca per caricare",
      stato_pilota: "In prova",
      stato_rilasciata: "Rilasciata",
      famiglia_hw_01: "HW 01",
      famiglia_hw_02: "HW 02",
      famiglia_hw_nd: "HW n.d.",
      famiglia_hw_tutte: "Tutti",
      tab_panoramica: "Panoramica",
      tab_tracker: "Tracker",
      tab_firmware: "Firmware",
      panoramica_vuota: "Nessun tracker con una versione firmware nota",
      offline_n: "{n} offline",
      tracker_nessuno: "Nessun tracker per i filtri selezionati",
      filtro_stato: "Stato",
      raggruppa_per: "Raggruppa per",
      raggruppa_impianto: "Impianto",
      raggruppa_quadro: "Quadro",
      raggruppa_versione: "Versione",
      col_tracker: "Tracker",
      col_impianto: "Impianto",
      col_quadro: "Quadro",
      col_hardware: "Hardware",
      col_versione: "Versione attuale",
      col_target: "Versione assegnata",
      col_stato: "Stato",
      col_ultimo_contatto: "Ultimo contatto",
      stato_tracker: {
        bocciato: "Firmware rifiutato",
        instabile: "Instabile",
        sparito: "Offline dopo l'aggiornamento",
        allineato: "Aggiornato",
        da_aggiornare: "Da aggiornare",
        offline: "Offline",
        senza_target: "Nessun firmware assegnato",
        sconosciuto: "Versione sconosciuta",
      },
      stato_tracker_hint: {
        bocciato: "Il tracker ha provato questo firmware, lo ha rifiutato ed è andando in rollback.",
        instabile: "Dopo l'aggiornamento il tracker si è riavviato più volte per errori (panic o watchdog): il firmware potrebbe non funzionare.",
        sparito: "Il tracker rispondeva dopo l'assegnazione del firmware e ora è offline: potrebbe essersi bloccato durante l'aggiornamento.",
      },
      tracker_bocciati: "Rifiutato da {n} tracker",
      tracker_instabili: "{n} instabili",
      tracker_spariti: "{n} offline dopo l'aggiornamento",
      prova_su_impianto: "Prova su un impianto",
      prova_cerca_impianto: "Cerca impianto",
      prova_nessun_impianto: "Nessun impianto compatibile",
      prova_avviata: "Firmware assegnato all'impianto",
      gia_assegnato: "Già assegnato",
      impianto_riga_info: "{n} tracker · attuale {versione}",
      rilascia_a_tutti: "Rilascia a tutti",
      assegna_a_tutti: "Assegna a tutti",
      rilascia_a_tutti_titolo: "Rilasciare la versione {versione} a tutti gli impianti compatibili?",
      assegna_a_tutti_titolo: "Assegnare la versione {versione} a tutti gli impianti compatibili?",
      rilascio_nessuna_prova_completata: "Nessun impianto ha ancora completato l'aggiornamento con questa versione. Il firmware dei tracker non ha rollback: procedi solo se sei sicuro.",
      rilascio_prove_completate: "Aggiornamento completato su {n} impianti di prova su {tot}.",
      pilota_tooltip: "Ancora in prova: provala su un impianto e, se va bene, rilasciala a tutti",
      rilasciato: "Versione rilasciata",
      n_sconosciuti: "{n} tracker senza versione nota",
      completato_il: "Completato il {data}",
      completato_in: "in {durata}",
      assegna_massa: "Assegna a una selezione",
      assegna_massa_titolo: "Assegnazione firmware in massa",
      assegna_massa_sub: "Scegli gli impianti e uno o più firmware (uno per famiglia): verrà cambiata solo la famiglia del firmware scelto.",
      impianti_label: "Impianti",
      firmware_label: "Firmware",
      anteprima: "Anteprima",
      anteprima_impianti_toccati: "{n} impianti toccati",
      anteprima_tracker_toccati: "{n} tracker toccati",
      anteprima_invariati: "{n} già alla versione scelta",
      anteprima_nessuna_modifica: "Nessuna modifica da applicare",
      cambio_firmware: "Famiglia {famiglia_hw}: {da} → {a} ({n} tracker)",
      nessun_firmware_attuale: "nessuno",
      applica: "Applica",
      assegnazione_massa_ok: "Firmware assegnato",
      aggiungi_famiglia_hw: "Aggiungi firmware di un'altra famiglia",
      versione_da_header: "Versione letta dal file",
      avviso_famiglia_hw_senza_fw: "Nell'impianto ci sono {n} tracker della famiglia {famiglia_hw}: assegna un firmware {famiglia_hw}",
      avviso_famiglia_hw_senza_tracker: "Nessun tracker della famiglia {famiglia_hw} nell'impianto: questo firmware non verrà mai usato",
      avviso_famiglia_hw_flash: "La famiglia {famiglia_hw} della versione non corrisponde alla flash del file (famiglia {flash}): verifica la versione",
      avviso_header_non_riconosciuto: "Header del file non riconosciuto: non posso verificare versione e famiglia",
      avanzamento: "Avanzamento",
      tracker_da_aggiornare: "{n} da aggiornare",
      tracker_offline: "{n} offline",
      impianti_fermi: "{n} fermi",
      aggiornamento_fermo_tooltip: "Impianti con tracker online non allineati da oltre {ore} ore dall'assegnazione",
      tracker_parent_diverso: "{n} con parent di altra famiglia",
      parent_diverso_tooltip: "Il tracker chiede l'aggiornamento al parent mesh, che ha una famiglia hardware diversa: non si aggiornerà mai",
      upload_ok: "Upload completato con successo",
      eliminato: "Eliminato",
      eliminati_n: "Eliminati",
      elimina_in_uso_lista:
        "Non è possibile eliminare le versioni firmware in uso",
      conferma_elimina_selezionati:
        "Sei sicuro di voler eliminare le versioni firmware selezionate?",
      conferma_elimina:
        "Sei sicuro di voler eliminare la versione firmware selezionata?",
      carica_titolo: "Carica nuova versione firmware",
      versione: "Versione",
      descrizione: "Descrizione",
      file: "File",
      empty_iniziale: "Nessuna versione firmware caricata",
      carica_primo: "Carica la prima versione di firmware per iniziare",
      empty_filtrato: "Nessuna versione disponibile per i filtri selezionati",
      reset_filtri: "Reset filtri",
      metadati: "Metadati",
      impianti_associati: "Impianti associati",
      timeline_assegnazione: "Timeline assegnazione",
      timeline_vuota: "Nessuna assegnazione disponibile",
      data_da: "Data da",
      data_a: "Data a",
      nessuna_versione_trovata: "Nessuna versione trovata",
      dimensione: "Dimensione",
      caricato_il: "Caricato il",
      caricato_da: "Caricato da",
      scarica: "Scarica",
      solo_in_uso: "Solo in uso",
      solo_non_in_uso: "Solo non in uso",
      filtro_in_uso: "Filtra per in uso",
      impianti: "Impianti",
      risultato: "Risultato",
      risultati: "Risultati",
    },
    summary: {
      errore: "Errore",
      successo: "Successo",
      eliminato: "Eliminato",
      creato: "Creato",
      aggiornato: "Aggiornato",
      backup_avviato: "Backup avviato",
      backup_completato: "Backup completato",
      backup_fallito: "Backup fallito",
      avviso: "Avviso",
      informazione: "Informazione",
      dato_ripristinato: "Dato ripristinato con successo!",
    },
    dialog: {
      configura_licenza_per_impianto: "Configura licenza per impianto",
      selezionati: "Selezionati",
      data_attivazione: "Data attivazione",
      licenze_per_impianto: "Licenze per impianto",
      licenza: "Licenza",
      scadenza_non_richiesta: "Scadenza non richiesta",
      abilita_email_scadenza_licenze:
        "Abilita email per ricevere le scadenze delle licenze",
      informativa_codice_fiscale:
        "Inserendo il codice fiscale, alcuni campi verranno compilati automaticamente.",
      invia_credenziali: "Invia credenziali tramite email al nuovo utente",
      password: "Password",
      password_non_valida: "Password non valida",
      email_non_valida: "Indirizzo email non valido",
      seleziona_azienda: "Seleziona azienda",
      nessun_elemento_aperto_dialog:
        "Nessun elemento aperto in questa finestra",
      suggerimenti_dialog_vuota:
        "Per iniziare, puoi aprire un elemento esistente cliccando sul bottone 'Dettagli' sulla destra della tabella, oppure crearne uno nuovo usando la Toolbar qui sopra.\nSe in precedenza hai salvato un setup, puoi recuperarlo sempre dalla Toolbar.",
      dati_anagrafici: "Dati anagrafici",
      domicilio_residenza: "Domicilio/Residenza",
      dati_accesso: "Dati di accesso",
      campo_obbligatorio: "Campo obbligatorio",
      minimo_2_caratteri: "Minimo 2 caratteri",
      minimo_3_caratteri: "Minimo 3 caratteri",
      carica_immagine: "Carica immagine",
      immagine_profilo: "Immagine profilo",
      formati_supportati: "Formati: png, jpg, jpeg, webp. Max 5MB.",
      dati_impianto: "Dati impianto",
      riferimento_anagrafica: "Riferimento anagrafica",
      codice_fiscale_non_valido: "Codice fiscale non valido",
      localizzazione_impianto: "Localizzazione impianto",
      seleziona_impianto: "Seleziona impianto",
    },
    impostazioni: {
      email_comunicazioni_licenze: "Email per comunicazioni licenze",
      impostazioni_generali: "Impostazioni generali",
      modifica_impostazioni_descrizione:
        "Modifica le impostazioni generali dell'applicazione",
      manutenzione: "Manutenzione",
      generali: "Generali",
      impostazioni_email_help_body:
        "Inserisci gli indirizzi email separandoli con Invio o virgola.",
      ultimo_aggiornamento: "Ultimo aggiornamento",
    },
    in_corso: "In corso",
    fallito: "Fallito",
    note: "Note",
    nome_file: "Nome file",
    dimensione: "Dimensione",
    eliminato: "Eliminato",
    abilita_dueeffea: "Abilita autenticazione a due fattori",
    disabilita_dueeffea: "Disabilita autenticazione a due fattori",
    dueeffea_attivato_con_successo:
      "Autenticazione a due fattori attivata con successo",
    errore_generazione_qr_code: "Errore nella generazione del QR Code",
    utente_super_admin: "Utente Super Amministratore",
    numero_utenti_associati: "Numero di utenti associati",
    immagine_personalizzata: "Immagine personalizzata",
    immagine_default: "Immagine di default",
    imposta_logo_azienda: "Imposta logo azienda",
    logo_azienda: "Logo azienda",
    immagine_default_evocleaners: "Immagine di default per Evocleaners",
    ragione_sociale_gia_esistente_nel_database:
      "Ragione sociale già esistente nel database",
    email_gia_esistente_nel_database: "E-mail già esistente nel database",
    suggerimento_immagine_default_evocleaners:
      "Immagine di default mostrata per gli Evocleaners senza immagine profilo caricata. Se vuota, verrà mostrata un'icona generica, altrimenti verrà impostata l'immagine caricata qui.",
    filtri_statistiche_azienda_macchina_periodo:
      "Statistiche per azienda, macchina e periodo",
    lista_missioni: "Lista missioni",
    utente_azienda_esterna: "Utente di un'altra azienda",
    tu: "Te stesso",
    icona: "Icona",
    campi_mancanti: "Campi mancanti",
    nessuna_missione_trovata: "Nessuna missione trovata",
    nome_dispositivo: "Nome dispositivo",
    missioni_correlate_ricerca: "Missioni correlate alla ricerca",
    aggiorna_elenco_email: "Aggiorna elenco email",
    scannerizza_per_dueffea:
      "Scannerizza il QR Code per abilitare l'accesso tramite Google Authenticator o Passwords di Apple.",
    notifiche_push_abilitate: "Notifiche push abilitate",
    tempo_accensione: "Tempo accensione",
    dispositivi_associati: "Dispositivi associati",
    missione_iniziata_Il: "Missione iniziata il",
    tempo_valvola_aperta: "Tempo valvola aperta",
    dati_aggiornati_in_automatico: "Dati aggiornati in automatico",
    aggiorna_i_dati_manualmente: "Aggiorna i dati manualmente",
    pacchetti_in_attesa: "Pacchetti in attesa",
    quando_ricevuta_comunicazione_dalla_macchina:
      "Quando ricevuta comunicazione dalla macchina",
    aggiorna_in_automatico: "Aggiorna i dati in automatico",
    attendi_aggiornamento_manualmente: "Attendi aggiornamento manuale dei dati",
    trasparente: "Trasparente",
    bianco: "Bianco",
    grigio_chiaro: "Grigio chiaro",
    argento: "Argento",
    marrone: "Marrone",
    oro: "Oro",
    giallo: "Giallo",
    verde_lime: "Verde lime",
    verde: "Verde",
    verde_scuro: "Verde scuro",
    turchese: "Turchese",
    ciano: "Ciano",
    blu: "Blu",
    success: "Successo",
    blu_scuro: "Blu scuro",
    viola: "Viola",
    rosa: "Rosa",
    rosso: "Rosso",
    rosso_scuro: "Rosso scuro",
    arancione: "Arancione",
    grigio: "Grigio",
    menu_privacy: "Privacy",
    menu_quadro: "Quadro",
    data_lettura: "Data lettura",
    lettura_email_eseguita_con_successo: "Lettura email eseguita con successo",
    visualizza_resoconto_letture: "Visualizza resoconto letture",
    forza_lettura_email: "Forza lettura email",
    apri_inbox_evocleaner: "Apri Inbox Evocleaner",
    visualizza_inbox: "Visualizza Inbox",
    visualizza_tabella: "Visualizza tabella",
    inbox_evocleaner: "Inbox Evocleaner",
    cerca_evocleaner: "Cerca evocleaner...",
    cerca_oggetto_email: "Cerca oggetto email...",
    aggiorna: "Aggiorna",
    nessuna_email: "Nessuna email disponibile",
    nessuna_email_trovata: "Nessuna email trovata",
    nessun_evocleaner_trovato: "Nessun evocleaner trovato",
    ultima_email: "Ultima email",
    ultime_email: "Ultime email",
    dettagli_email: "Dettagli email",
    altri_campi: "Altri campi",
    seleziona_evocleaner: "Seleziona un evocleaner",
    nessuna_email_per_evocleaner: "Nessuna email per questo evocleaner",
    evocleaners_con_email: "evocleaner con email",
    email_totali: "email totali",
    ultima_esecuzione: "Ultima esecuzione",
    prossima_esecuzione: "Prossima esecuzione",
    esito: "Esito",
    resoconto_letture_email: "Resoconto letture email",
    eseguito_da_nome: "Eseguito da",
    data_esecuzione: "Data esecuzione",
    push_notifications_enabled: "Notifiche push attive",
    push_notifications_disabled: "Notifiche push disattivate",
    push_notifications_detail_on: "Riceverai notifiche push istantanee",
    push_notifications_detail_off: "Non riceverai notifiche push",
    attive: "Attive",
    non_attive: "Non attive",
    le_notifiche_push_non_sono_supportate:
      "Le notifiche push non sono supportate",
    le_notifiche_push_su_ios_richiesto_safari:
      "Su dispositivi iOS, le notifiche push sono supportate solo in Safari (iOS 16.4+).",
    notifiche_push: "Notifiche Push",
    notifiche_sottotitolo:
      "Configura come ricevere notifiche da EvoSense per dispositivi e aggiornamenti",
    notifiche_push_ios_attivare_titolo: "Per attivare le notifiche:",
    notifiche_push_ios_step1: "1. Apri questa pagina in Safari",
    notifiche_push_ios_step2:
      "2. Aggiorna a iOS 16.4 o superiore se necessario",
    notifiche_push_ios_step3: "3. Torna qui per attivare le notifiche",
    notifiche_push_browser_non_supportato:
      "Il tuo browser non supporta le notifiche push. Prova ad aggiornare il browser o utilizzane uno diverso.",
    notifiche_push_bloccate_descrizione:
      "Le notifiche sono state bloccate. Per attivarle:",
    notifiche_push_bloccate_step1:
      "1. Clicca sull'icona del lucchetto nella barra degli indirizzi",
    notifiche_push_bloccate_step2: '2. Seleziona "Consenti" per le notifiche',
    notifiche_push_bloccate_step3: "3. Ricarica la pagina",
    notifiche_push_richiesta_descrizione:
      "Abilita le notifiche per ricevere aggiornamenti in tempo reale",
    notifiche_push_bottone_abilita: "Abilita",
    notifiche_push_bottone_test: "Test",
    notifiche_push_bottone_test_titolo: "Invia notifica di test",
    notifiche_push_bottone_attiva: "Attiva",
    notifiche_push_bottone_disattiva: "Disattiva",
    notifiche_push_configurate_titolo: "Notifiche push configurate!",
    notifiche_push_configurate_descrizione:
      "Riceverai notifiche push istantanee sui tuoi dispositivi, missioni e aggiornamenti di sistema.",
    notifiche_push_permesso_concesso:
      "Permesso concesso! Ora puoi attivare le notifiche push",
    notifiche_push_permesso_negato:
      "Permesso negato - Non è possibile attivare le notifiche",
    notifiche_push_permesso_errore: "Errore nella richiesta del permesso",
    notifiche_push_attivate_successo:
      "Notifiche attivate! Riceverai aggiornamenti da EvoSense sui tuoi dispositivi",
    notifiche_push_attivate_errore: "Impossibile attivare le notifiche",
    notifiche_push_disattivate_successo:
      "Notifiche disattivate - Non riceverai più notifiche push",
    notifiche_push_disattivate_errore: "Impossibile disattivare le notifiche",
    notifiche_push_test_successo:
      "Test inviato! Controlla le notifiche del tuo dispositivo",
    notifiche_push_test_errore: "Impossibile inviare la notifica di test",
    notifiche_email_test_successo:
      "Email di test inviata! Controlla la tua casella di posta",
    notifiche_email_test_errore: "Errore nell'invio dell'email di test",
    notifiche_email_preferenze_errore:
      "Impossibile caricare le preferenze email: {error}",
    notifiche_email_attivate_successo: "Notifiche email attivate!",
    notifiche_email_disattivate_successo: "Notifiche email disattivate",
    notifiche_email_impostazioni_errore:
      "Impossibile aggiornare le impostazioni email",
    nessun_dispositivo_registrato: "Nessun dispositivo registrato",
    rimuovi_dispositivo_corrente_avviso:
      "Attenzione: stai per rimuovere il dispositivo corrente. Procedendo, effettuerai il logout dall'applicazione e dovrai nuovamente verificare il dispositivo.",
    dispositivo_corrente: "Dispositivo corrente",
    codice_inviato_via_email: "Codice inviato via email",
    mesi: "Mesi",
    conferma_rimozione_dispositivo_nome:
      "Confermi la rimozione del dispositivo",
    salvataggio_dispositivo_titolo: "Stiamo salvando il tuo dispositivo…",
    salvataggio_dispositivo_sottotitolo:
      "Così al prossimo accesso sarà più veloce e immediato",
    salvataggio_dispositivo_descrizione_1:
      "Stiamo registrando questo dispositivo per riconoscerlo automaticamente.",
    salvataggio_dispositivo_descrizione_2:
      "È un passaggio rapido: ti eviterà verifiche ripetute e renderà l’accesso più fluido.",
    salvataggio_dispositivo_hint:
      "Non chiudere la pagina: mancano solo pochi secondi.",
    codice_non_valido: "Codice non valido",
    prosegui: "Prosegui",
    verifica_metodi_dispositivo:
      "È richiesta la verifica del dispositivo per confermare l'accesso.",
    verifica_metodi_dispositivo_descrizione:
      "Per motivi di sicurezza, è necessario verificare il dispositivo da cui stai effettuando l'accesso. Scegli uno dei metodi di verifica disponibili per procedere con il login.",
    visualizza_informativa_privacy: "Visualizza informativa privacy",
    credits: "Credits",
    visualizza_credits: "Visualizza credits",
    resetta_filtri: "Resetta filtri",
    g_speed: "Velocità G",
    storico_missioni: "Storico missioni",
    singola_missione: "Singola missione",
    anima_percorso: "Anima percorso",
    timeline_on: "Timeline on",
    mostra_intero: "Mostra intero",
    copia_id: "Copia ID",
    esporta_csv: "Esporta CSV",
    esporta_gpx: "Esporta GPX",
    status_code: "Codice stato",
    modifica_note: "Modifica note",
    menu_guida: "Guida",
    visualizza_guida: "Visualizza guida",
    visualizza_note: "Visualizza note",
    punti: "Punti",
    distanza_totale_km: "Distanza totale (km)",
    km_h: "Km/h",
    mph: "Mph",
    menu_profilo: "Profilo",
    menu_comandi_manuali_attivi: "Comandi manuali attivi",
    emails: "Emails",
    consumo_acqua_media_stimata: "Consumo acqua media stimata",
    ore_accensione: "Ore accensione",
    blocca: "Blocca",
    ore_valvola_aperta: "Ore valvola aperta",
    sblocca: "Sblocca",
    ip: "Indirizzo IP",
    confermi_modifica_cella: "Confermi la modifica della cella?",
    click_cella_per_edit: "Clicca sulla cella per modificare",
    user_agent: "User Agent",
    imei_modem_saet: "IMEI Modem S.A.E.T.",
    token_last8: "Ultimi 8 caratteri del token",
    latency_ms: "Latenza (ms)",
    payload_bytes: "Byte del payload",
    db_ops: "Operazioni DB",
    error_code: "Codice errore",
    error_message: "Messaggio errore",
    requested_action: "Azione richiesta",
    mission_id: "ID Missione",
    em_local: "EM Local",
    em_remote: "EM Remote",
    distance_delta_km: "Delta distanza (km)",
    meta: "Meta",
    imsi: "IMSI",
    apri_dettaglio: "Apri dettaglio",
    mesi_dall_ultima_manutenzione: "Mesi dall'ultima manutenzione",
    conferma_sblocco_obbligo_manutenzione:
      "Confermi sia stata effettuata la manutenzione sulla macchina?",
    ricevuto_dal_cloud: "Ricevuto dal cloud",
    dispositivi_collegati_descrizione:
      "Numero di dispositivi attualmente collegati",
    sblocca_macchina: "Sblocca la macchina",
    spiegazione_sblocco_macchina:
      "Per sbloccare la macchina è necessario che questa sia accesa e connessa alla Web App tramite la scheda prodotta da S.a.e.t. s.r.l.",
    dueeffea: "Autenticazione a due fattori",
    bloccato: "Bloccato",
    dispositivi: "Dispositivi",
    non_bloccato: "Non bloccato",
    bloccato_per_obbligo_manutenzione: "Bloccato per obbligo manutenzione",
    mesi_passati_da_ultima_manutenzione: "Mesi passati da ultima manutenzione",
    mesi_rimanenti: "Mesi rimanenti",
    immagine: "Immagine",
    macchina_bloccata_obbligo_manutenzione:
      "Macchina bloccata per obbligo manutenzione",
    richiedi_sblocco: "Richiedi sblocco",
    stato_macchina_per_manutenzione: "Stato macchina per manutenzione",
    manutenzione: "Manutenzione",
    evocleaner_bloccato_per_obbligo_manutenzione:
      "Evocleaner bloccato per obbligo manutenzione",
    carica_immagine: "Carica immagine",
    rimuovi: "Rimuovi",
    salva: "Salva",
    ripristina: "Ripristina",
    ultimo_aggiornamento: "Ultimo aggiornamento",
    impostazioni_email_help_body:
      "Inserisci gli indirizzi email separandoli con Invio o virgola.",
    formati_supportati: "Formati: png, jpg, jpeg, webp. Max 1MB.",
    immagine_selezionata_salva_per_applicare:
      "Immagine selezionata. Premi Salva per applicare.",
    data_ultima_manutenzione: "Data ultima manutenzione",
    generali: "Generali",
    suggerimento_contattare_m2:
      "Lista di emails che ricevono le comunicazioni di scadenza della licenza oltre ai proprietari degli impianti.",
    ore_per_notifica_manutenzione:
      "Numero di ore che fanno scattare la notifica di manutenzione",
    suggerimento_ore_per_notifica_manutenzione:
      "Numero di ore che fanno scattare la notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina.",
    suggerimento_ore_per_manutenzione:
      "La macchina, appena connessa, verrà bloccata se il numero di ore di accensione raggiunge questo valore. Verrà inoltre inviata una notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina. La macchina potrà essere sbloccata solo dopo aver eseguito la manutenzione da parte di un tecnico autorizzato.",
    mesi_per_notifica_manutenzione:
      "Numero di mesi che fanno scattare la notifica di manutenzione",
    suggerimento_mesi_per_notifica_manutenzione:
      "Numero di mesi che fanno scattare la notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina.",
    mesi_per_manutenzione: "Numero di mesi che fanno scattare la manutenzione",
    suggerimento_mesi_per_manutenzione:
      "La macchina, appena connessa, verrà bloccata se il numero di mesi dall'ultima manutenzione raggiunge questo valore. Verrà inoltre inviata una notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina. La macchina potrà essere sbloccata solo dopo aver eseguito la manutenzione da parte di un tecnico autorizzato.",
    suggerimento_comunicazioni_manutenzione:
      "Indirizzo email alla quale verrà inviata la comunicazione di manutenzione necessaria della macchina. La comunicazione verrà anche automaticamente inviata a tutti gli utenti associati all'azienda proprietaria della macchina.",
    email_comunicazioni_manutenzione: "Email comunicazioni manutenzione",
    resoconto_ultima_missione: "Resoconto ultima missione",
    focus_macchina: "Focus macchina",
    vai_a_dettaglio_macchina: "Vai al dettaglio macchina",
    ultima_missione_descrizione:
      "Ultima missione della {seriale} presso {azienda}.",
    altre_missioni_nel_periodo:
      "Altre {count} missioni nel periodo selezionato.",
    missioni_medie_giornaliere: "Missioni medie/giorno",
    giorno_piu_attivo: "Giorno più attivo",
    giorno_meno_attivo: "Giorno meno attivo",
    variazione_medio_periodo: "Trend rispetto all'inizio periodo",
    azienda_non_disponibile: "Azienda non disponibile",
    missioni_x: "{count} missioni",
    resoconto_periodo: "Resoconto periodo",
    ultima_macchina: "Ultima macchina",
    nessuna_missione_nel_periodo: "Nessuna missione nel periodo selezionato.",
    andamento_missioni: "Andamento missioni",
    andamento_missioni_descrizione:
      "Andamento delle missioni nel periodo selezionato.",
    top_macchine_per_ore: "Top macchine per ore",
    top_macchine_descrizione:
      "Le 5 macchine con il maggior numero di ore di lavoro.",
    seleziona_periodo: "Seleziona periodo",
    seleziona_periodo_rapido: "Periodo rapido",
    tutte_le_aziende: "Tutte le aziende",
    tutte_le_macchine: "Tutte le macchine",
    dettaglio_missioni: "Dettaglio missioni",
    dettaglio_macchine: "Dettaglio macchine",
    riduci: "Riduci",
    espandi: "Espandi",
    km_totali: "Km totali",
    oggetto_tradotto: "Oggetto tradotto",
    corpo_tradotto: "Corpo tradotto",
    oggetto_originale: "Oggetto originale",
    corpo_originale: "Corpo originale",
    manutenzione_ok: "Manutenzione in ordine",
    manutenzione_da_programmare: "Manutenzione da programmare",
    manutenzione_urgente: "Manutenzione urgente",
    ore_usate_di: "ore usate di",
    ore: "ore",
    ore_rimanenti: "ore rimanenti",
    totale_ore_accensione_per_manutenzione:
      "Totale ore accensione per manutenzione",
    totale_ore_accensione: "Totale ore accensione",
    nessuna_risposta_dispositivo: "Nessuna risposta dal dispositivo",
    attesa_ack_dispositivo: "Attesa conferma dal dispositivo",
    attesa_ack_dispositivo_descrizione:
      "In attesa della conferma dal dispositivo",
    nessuna_risposta_dispositivo_descrizione:
      "Nessuna risposta ricevuta dal dispositivo",
    comando_remoto_inviato: "Comando remoto inviato al dispositivo",
    visualizza_impostazioni: "Visualizza impostazioni",
    email_inviata_con_successo: "Email inviata con successo!",
    super_amministratore: "Super Amministratore",
    comando_remoto_eseguito_descrizione: "Comando remoto eseguito con successo",
    ore_per_manutenzione:
      "Numero di ore che fanno scattare l'obbligo di manutenzione",
    notifiche_credenziali_evocleaners:
      "Indirizzi mail alla quale vengono inviate le credenziali di accesso Wss dei nuovi Evocleaner creati",
    suggerimento_notifiche_credenziali_evocleaners:
      "Dopo aver inserito l'indirizzo mail, premere INVIO per aggiungerlo alla lista.",
    email_comunicazioni_envirologic:
      "Indirizzo mail che riceve le comunicazioni Envirologic",
    foto_profilo: "Foto profilo",
    controlla_casella_mail:
      "È stato inviato un codice via email all'indirizzo associato al tuo account",
    passa_a_tema_chiaro: "Passa a tema chiaro",
    em_stop_attivo_tooltip: "La macchina risulta già fermata da remoto",
    em_stop_non_attivo_tooltip: "La macchina non risulta fermata da remoto",
    comando_remoto_blocco_ack_ok:
      "Comando di blocco remoto eseguito con successo",
    comando_remoto_sblocco_ack_ok:
      "Comando di sblocco remoto eseguito con successo",
    ack_ricevuto: "Conferma ricevuta dalla macchina",
    errore_aggiornamento_stato_em_stop:
      "Errore durante l'aggiornamento dello stato di blocco remoto",
    tema: "Tema",
    lingua: "Lingua",
    seleziona_lingua: "Seleziona la lingua",
    cambio_lingua: "Cambio lingua",
    passa_a_tema_scuro: "Passa a tema scuro",
    visualizza_log_sistema: "Visualizza log sistema",
    visualizza_comunicazioni: "Visualizza comunicazioni",
    evento: "Evento",
    risposta: "Risposta",
    socket_autenticazione_ricevuta: "Autenticazione WebSocket ricevuta",
    stato_connessione: "Stato connessione",
    online: "Online",
    offline: "Offline",
    aggiorna_stato_connessione: "Aggiorna stato connessione",
    dispositivi_attivi: "Dispositivi attivi",
    totale_pacchetti: "Totale pacchetti",
    ultimo_pacchetto: "Ultimo pacchetto",
    ultima_attivita: "Ultima attività",
    nessun_dispositivo_attivo: "Nessun dispositivo attivo",
    apri_monitor_connessioni: "Visualizza dispositivi",
    dispostivo_con_seriale: "Dispositivo con seriale",
    autenticato_con_successo: "autenticato con successo",
    ricevuto_status: "Ricevuto status dal dispositivo",
    dettaglio: "Dettaglio",
    blocca_macchina: "Blocca la macchina",
    azienda: "Azienda",
    seriale: "Seriale",
    mappa: "Mappa",
    premi_per_visualizzare: "Premi per visualizzare",
    username_wss: "Username per comunicazione WebSocket",
    password_wss: "Password per comunicazione WebSocket",
    conferma_rimozione_foto_profilo:
      "Confermi la rimozione della foto profilo?",
    rimuovi_foto_profilo: "Rimuovi foto profilo",
    dispositivo_rimosso: "Dispositivo rimosso con successo",
    cambia_foto_profilo: "Cambia foto profilo",
    dati_macchina: "Dati macchina",
    ultima_settimana: "Ultima settimana",
    notifiche: "Notifiche",
    ultimo_mese: "Ultimo mese",
    mese_scorso: "Mese scorso",
    sempre: "Sempre",
    metri: "Metri",
    ore_totali: "Ore totali",
    nessuna_manutenzione_registrata: "Nessuna manutenzione registrata.",
    macchine_attive: "Macchine attive",
    distanza_totale: "Distanza totale",
    missioni_totali: "Missioni totali",
    macchina: "Macchina",
    dati_accesso_websocket: "Dati di accesso WebSocket",
    info_creazione_credenziali_websocket:
      "Le credenziali, una volta create, verranno inviate via mail ai collaboratori di S.A.E.T. S.r.l. per la configurazione del dispositivo. Sono essenziali per la comunicazione tra l'applicazione e il robot EvoCleaner.",
    info_modifica_credenziali_websocket:
      "La password, una volta associata è stata criptata e non è più visibile. In caso di modifica, la nuova password verrà inviata via mail ai collaboratori di S.A.E.T. S.r.l. per la riconfigurazione del dispositivo.",
    tema_chiaro: "Tema Chiaro",
    tema_scuro: "Tema Scuro",
    calcola_coordinate: "Calcola coordinate",
    login_non_ancora_effettuato: "Login non ancora effettuato",
    dipendenti_azienda: "Dipendenti azienda",
    visualizza_profilo_utente: "Visualizza profilo utente",
    mappa_aziende: "Mappa aziende",
    mappa_impianti: "Mappa impianti",
    ricarlica_coordinate: "Ricalcola coordinate",
    esempio_indirizzo: "Esempio: Piazza Annibale Galateri, 9",
    inserire_indirizzo_completo:
      "Inserisci un indirizzo completo per calcolare le coordinate",
    archiviazione_eseguita: "Archiviazione eseguita con successo!",
    proprio_ora: "Proprio ora",
    secondi_fa: "{value} secondi fa",
    minuti_fa: "{value} minuti fa",
    ore_fa: "{value} ore fa",
    giorni_fa: "{value} giorni fa",
    menu_notifiche: "Notifiche / Annunci",
    impostazioni_turno: "Impostazioni turno",
    menu_configura_orari: "Configura orari",
    conferma_archivia:
      "Sei sicuro di voler archiviare gli elementi selezionati?",
    mostra_nascondi_linee_griglia: "Mostra/Nascondi linee griglia",
    manca_id_elemento: "Manca l'ID dell'elemento",
    pec_non_valida: "PEC non valida",
    dati_aziendali: "Dati aziendali",
    contatti: "Contatti",
    sede: "Sede",
    disabilitato: "Disabilitato",
    abilitato: "Abilitato",
    facoltativo: "Facoltativo",
    nessun_file: "Nessun file selezionato",
    generazione_pdf_in_corso: "Generazione PDF in corso...",
    install_pwa: {
      title: "Installa l’app",
      subtitle:
        "Scarica la nostra web app per un’esperienza più veloce e comoda",
      follow_guide: "Segui la guida qui sotto",
      install_now: "Installa ora",
      close: "Chiudi",
      close_and_dont_show: "Chiudi e non mostrare più",
      login_auto: {
        title: "Login automatico",
        step1: "Installando la PWA, la sessione sarà riconosciuta",
        step2: "Non servirà accedere di nuovo",
        step3: "L'app ti autenticherà ogni volta che la apri",
      },
      desktop: {
        title: "Desktop",
        step1: "Apri questo sito su Chrome o Edge.",
        step2:
          "Clicca sull’icona <i class='fas fa-display-arrow-down'></i> nella barra degli indirizzi.",
        step3: "Conferma su “Installa”.",
      },
      android: {
        title: "Android",
        step1: "Apri il sito su Chrome.",
        step2: "Tocca il menu <i class='fas fa-ellipsis-vertical'></i>.",
        step3: "Seleziona “Aggiungi a schermata Home”.",
        step4: "Conferma su “Installa”.",
      },
      ios: {
        title: "iOS",
        step1: "Apri il sito in Safari.",
        step2: "Tocca <i class='fas fa-arrow-up-from-square'></i>.",
        step3: "Seleziona “Aggiungi alla schermata Home”.",
        step4: "Conferma su “Aggiungi”.",
      },
    },
    totale_elementi: "Totale elementi",
    comune_nascita: "Comune di nascita",
    dati_bancari: "Dati bancari",
    dati_personali: "Dati personali",
    seleziona_azienda: "Seleziona azienda",
    ragione_sociale: "Ragione sociale",
    dati_accesso: "Dati di accesso",
    domicilio_residenza: "Domicilio/Residenza",
    selezionati: "Selezionati",
    pagina: "Pagina",
    risultati: "Risultati",
    nome: "Nome",
    creato: "Creato",
    modificato: "Modificato",
    ultima_modifica: "Ultima modifica",
    password_non_valida:
      "La password deve contenere almeno 12 caratteri, una lettera maiuscola, una minuscola, un numero e un carattere speciale",
    errore: "Errore",
    minimo_12_caratteri: "Minimo 12 caratteri richiesti",
    cambia_colore_riga: "Cambia colore riga",
    partita_iva_non_valida: "Partita IVA non valida",
    aggiungi_preferito: "Aggiungi ai preferiti",
    apri_popup_esterno: "Apri popup esterno",
    regione: "Regione",
    localita: "Località",
    nazione: "Nazione",
    provincia: "Provincia",
    referente: "Referente",
    menu_permessi: "Permessi",
    menu_resoconto: "Resoconto",
    menu_categorie: "Categorie",
    menu_rilevazione_presenze: "Rilevazione presenze",
    progetto_aggiornato: "Il progetto è stato aggiornato!",
    testo_aggiornamento_app:
      "Per continuare, puoi ricaricare la pagina oppure reinstallare la PWA",
    descrizione_orario_turno_rotazione:
      "Inserire ora di inizio e di fine turno",
    descrizione_orario_turno_fisso: "Inserire ora di inizio e di fine turno",
    info_tipologia_orario_turno:
      "Il tipo del turno stabilisce come vengono calcolate le ore di lavoro e in che modo il turno viene assegnato se si sceglie di assegnare i turni automaticamente.",
    durata_turno: "Durata turno",
    tipo_orario_turno: "Tipo orario turno",
    info_durata_turno:
      "La durata del turno serve a stabilire quante ore di lavoro il dipendente deve raggiungere in questo turno.sono escluse le ore di pausa non retribuite.",
    descrizione_orario_turno_selezionato:
      "Inserire ora di inizio e di fine turno",
    orario_turno: "Orario del turno",
    descrizione_orario_turno: "Descrizione orario del turno",
    descrizione_orario_turno_libero:
      "Questo turno può iniziare e finire in qualsiasi momento della giornata, ma devono essere lavorate un totale di {ore} ore.",
    info_nome_turni:
      "Il nome del turno deve essere univoco e facilmente identificabile. Viene utilizzato per rappresentare il turno nelle varie visualizzazioni,ricerca e report.",
    info_sigla_turni:
      "La sigla del turno viene utilizzata per abbreviare il suo nome e renderlo riconoscibile nelle modalità di visualizzazione in cui lo spazio è limitato, come le tabelle e le estrazioni, questa deve essere univoca.",
    inizio: "Inizio",
    fine: "Fine",
    durata: "Durata",
    info_nome_gruppi:
      "Nel campo 'Nome' deve essere inserito il nome che si vuole assegnare al gruppo che si sta creando. Il nome si trova nella tabella dei dipendenti, nella sezione 'Dipendenti', nella sezione 'Gruppi', cliccando su 'PRESENZE GRUPPO' e nella sezione 'Calendario', dove è presente un sistema che filtra per il calendario in base al gruppo selezionato.Selezionare un colore aiuta a identificare più facilmente il gruppo all'interno dell'applicazione.",
    menu_turni: "Turni",
    menu_impostazioni: "Impostazioni",
    aiuto: "Aiuto",
    turni_assegnati: "Turni assegnati",
    info_turni_assegnati:
      "Nel campo 'Turni Assegnati' si devono inserire i turni che è possibile assegnare ai membri del gruppo che si sta creando, spuntando le caselle vicino ai turni interessati. Il primo pulsante a destra del campo permette di filtrare i turni per trovarli più facilmente; il secondo pulsante permette di resettare questi filtri. I turni assegnati al gruppo si trovano nella sezione 'Gruppi' della barra laterale, cliccando su 'PRESENZE MEMBRI'.",
    info_bollatura_attiva:
      "Spuntando la casella 'Rilevazione presenze attiva' i membri del gruppo sono abilitati a timbrare al chiosco. Si può verificare se questo campo è spuntato, nella sezione 'Gruppi' della barra laterale, cliccando sul gruppo interessato e cliccando su 'PRESENZE MEMBRI'.",
    info_bollatura_remota_attiva:
      "Spuntando la casella 'Rilevazione remota presenze attiva' i membri del gruppo sono abilitati a timbrare remotamente, tramite l'app, fornendo le coordinate GPS. Si può verificare se questo campo è spuntato, nella sezione 'Gruppi' della barra laterale, cliccando sul gruppo interessato e cliccando su 'PRESENZE MEMBRI'.",
    turni_info:
      "Nel campo 'Giorni lavorativi' si devono inserire i giorni in cui è possibile assegnare turni ai membri del gruppo che si sta creando, spuntando una casella per ogni giorno lavorativo.\nI giorni lavorativi del gruppo si trovano nella sezione 'Gruppi' della barra laterale, cliccando su 'PRESENZE  MEMBRI'.",
    presenze_membri: "Presenze membri",
    nome_gruppo_esistente: "Nome gruppo già esistente nel database",
    errore_creazione_gruppo: "Errore durante la creazione del gruppo",
    errore_aggiornamento_gruppo: "Errore durante l'aggiornamento del gruppo",
    gruppo_creato: "Gruppo creato con successo!",
    gruppo_aggiornato: "Gruppo aggiornato con successo!",
    turni: "Turni",
    rilevazioni_presenze: "Rilevazioni presenze",
    giorni_lavorativi: "Giorni lavorativi",
    dispositivo_di_sicurezza: "Dispositivo di sicurezza",
    telefono_non_valido: "Telefono non valido",
    email_non_valida: "Email non valida",
    bollatura_attiva: "Bollatura attiva",
    bollatura_remota_attiva: "Bollatura remota attiva",
    richiesta_ferie_nuova: "Richiesta ferie nuova",
    richiesta_ferie_modificata: "Richiesta ferie modificata",
    richiesta_rimborso_nuova: "Richiesta rimborso nuova",
    richiesta_rimborso_aggiornata: "Richiesta rimborso aggiornata",
    richiesta_file_nuova: "Richiesta file nuova",
    file_ricevuti: "File ricevuti",
    rapporto_assenze: "Rapporto assenze",
    rapporto_inattivita: "Rapporto inattività",
    licenza_non_valida: "Licenza non valida",
    licenza: "Licenza",
    accedi: "Accedi",
    nome_licenza: "Nome licenza",
    durata_mesi: "Durata (mesi)",
    creata_il: "Creata il",
    aborto: "Aborto",
    quanti_aborti: "Quanti aborti",
    tipologia_transazione: "Tipologia transazione",
    giftcard: "Giftcard",
    firma_non_presente: "Firma non presente",
    credito_attuale: "Credito attuale",
    aggiunta: "Aggiunta",
    sottrazione: "Sottrazione",
    credito_residuo_dopo_operazione: "Credito residuo dopo operazione",
    calcolo_automatico_del_nuovo_saldo: "Calcolo automatico del nuovo saldo",
    paese_nascita: "Comune di nascita",
    campo_obbligatorio: "Campo obbligatorio",
    importo: "Importo",
    conferma_inserimento_transazione: "Conferma inserimento transazione",
    saldo_pre_transazione: "Saldo pre-transazione",
    saldo_post_transazione: "Saldo post-transazione",
    resoconto_transazioni: "Resoconto transazioni",
    aggiungi_transazione: "Aggiungi transazione",
    registra_firma: "Registra firma",
    attendendo_firma_dispositivo: "Attendere firma dispositivo...",
    cambia_firma: "Cambia firma",
    nessuna_transazione: "Nessuna transazione",
    nessuna_transazione_giftcard_registrata:
      "Nessuna transazione giftcard registrata",
    inserimento_eseguito: "Inserimento eseguito con successo!",
    stampa: "Stampa",
    menu_gruppi: "Gruppi",
    tipo: "Tipo",
    a: "a",
    aggiungi: "Aggiungi",
    aggiungi_note: "Aggiungi note",
    aggiorna_tabella: "Aggiorna la tabella",
    anamnesi: "Anamnesi",
    anno: "Anno",
    annulla: "Annulla",
    annulla_modifica: "Annulla modifica",
    autenticazione_2FA: "Autenticazione 2FA",
    avvia_timer: "Avvia timer",
    avviso_date_con_date_disabilitate:
      "In caso il range di date selezionato comprenda delle date disabilitate, il sistema andrà a generare tante associazioni quanti sono i range di date che vengono trovati.",
    azioni: "Azioni",
    benvenuto_descrizione: "Gestione e pianificazione commesse",
    benvenuto_utente: "Benvenuto",
    recapito_emergenza: "Contatto d'emergenza",
    calcola_data_fine: "Calcola data fine stimata",
    calendario: "Calendario",
    cambia_immagine: "Cambia immagine",
    cambia_tema: "Cambia tema",
    campo_richiesto: "Campo richiesto",
    caricamento_dati: "Caricamento dei dati in corso...",
    categorie: "Categorie",
    categoria: "Categoria",
    tipologia: "Tipologia Operatori",
    cerca: "Cerca...",
    cerca_in_tutti_i_campi: "Cerca in tutti i campi...",
    aliquota_iva: "Aliquota IVA",
    descrizione_aliquota_iva: "Descrizione Aliquota IVA",
    prezzo_lordo: "Prezzo Lordo",
    prezzo_di_acquisto: "Prezzo di Acquisto",
    giacenza: "Giacenza",
    extra: "Extra",
    paziente: "Paziente",
    registra_nuovo_paziente: "Registra nuovo paziente",
    ora: "Ora",
    medico: "Medico",
    struttura: "Struttura",
    tipologia_visita: "Tipologia Visita",
    data_creazione: "Data Creazione",
    udm: "Unità di Misura",
    chiudi: "Chiudi",
    cliente: "Cliente",
    codice: "Codice",
    codice_email: "Codice via email",
    partita_iva: "Partita IVA",
    codice_sdi: "Codice SDI",
    pec: "PEC",
    peso: "Peso",
    attuale_peso: "Attuale Peso",
    altezza: "Altezza",
    altezza_precisa: "Altezza in cm",
    circonferenza_polso: "Circonferenza polso in cm",
    circonferenza_addome: "Circonferenza addome in cm",
    gruppo_sanguigno: "Gruppo sanguigno",
    sport: "Fai sport",
    sport_quali: "Quali sport?",
    sport_frequenza: "Frequenza sportiva",
    regime_alimentare: "Regime alimentare",
    regime_alimentare_altro: "Altro regime alimentare",
    alimentazione_e_idratazione: "Alimentazione e idratazione",
    rapporto_corpo_desc: "Hai un buon rapporto con il tuo corpo?",
    rapporto_corpo: "Rapporto con il corpo",
    capelli_desc: "I capelli hanno subito trattamento colorante, tinta, altro?",
    capelli_descrizione: "Descrizione trattamento capelli",
    acqua: "Acqua",
    iban: "IBAN",
    bic_swift: "BIC/SWIFT",
    nominativo_conto: "Nominativo conto",
    rs_banca: "Banca",
    paese_banca: "Paese banca",
    codice_abi: "Codice ABI",
    iban_valido: "IBAN valido",
    iban_non_valido: "IBAN non valido",
    banca_rilevata: "Banca rilevata automaticamente",
    banca_non_trovata: "Banca non trovata per questo IBAN",
    verifica_iban: "Verifica IBAN",
    validazione_iban_in_corso: "Validazione IBAN in corso...",
    codice_autenticazione: "Codice di autenticazione",
    codice_inviato: "Codice inviato! Controlla la tua email per continuare.",
    codice_obbligatorio: "Il codice è obbligatorio!",
    codice_recupera_password_verificato:
      "Codice verificato correttamente, procedi con l'inserimento della nuova password",
    codice_testo:
      "Inserisci il codice che ti è stato inviato tramite e-mail prima della scadenza del tempo",
    colore: "Colore",
    collaboratori_esterni: "Collaboratori esterni",
    commessa: "Commessa",
    esporta_excel: "Esporta excel",
    transazioni_disponibili_dopo_creazione:
      "Le transazioni risulteranno disponibili dopo la creazione",
    inserisci_saldo_iniziale_o_lascia_vuoto:
      "Al momento, inserisci il saldo iniziale del paziente oppure lascia vuoto per impostare €0,00",
    commessa_duplicata: "Commessa duplicata con successo!",
    commessa_eliminata: "Commessa eliminata con successo!",
    commessa_ricevuta: "Commessa ricevuta",
    commessa_utente_aggiornata: "Commessa aggiornata con successo!",
    commesse_importate: "Commesse importate con successo",
    concludi: "Concludi",
    conferma: "Conferma",
    conferma_eliminazione: "Sicuro di voler eliminare i dati selezionati?",
    conferma_eliminazione_transazione:
      "Sicuro di voler eliminare la transazione? Così facendo verrà solamente eliminata la transazione, il credito residuo non verrà modificato.",
    costo_finale: "Costo finale",
    crea: "Crea",
    creatoIl: "Creato il",
    creazione_eseguita: "Creazione eseguita con successo!",
    data: "Data",
    data_fine: "Data fine",
    data_fine_maggiore_data_inizio:
      "La data di fine deve essere maggiore della data di inizio",
    data_fine_stimata: "Data fine stimata",
    data_inizio: "Data inizio",
    data_intervento: "Data intervento",
    data_nascita: "Data di nascita",
    luogo_nascita: "Luogo di nascita",
    provincia_nascita: "Provincia di nascita",
    stato_nascita: "Paese di nascita",
    dati_non_disponibili: "Dati non disponibili",
    error_titolo_404: "HTTP Error 404 - Not Found",
    error_titolo_401: "HTTP Error 401 - Not Authorized",
    error_titolo_generale: "HTTP General Error",
    da_pianificare: "Da pianificare",
    denominazione: "Denominazione",
    descrizione: "Descrizione",
    dettagli_base: "Dettagli base",
    error_torna_pagina_iniziale: "Torna alla pagina iniziale",
    error_effettua_login: "Torna indietro",
    favorite_page_pagina_rimossa: "Pagina rimossa dai preferiti",
    ferma_timer: "Ferma timer",
    file_e_documenti: "File e documenti",
    file_troppo_grande: "File troppo grande",
    fornitura: "Fornitura",
    genera_password: "Genera password",
    grafico: "Grafico",
    id: "ID",
    immagine_profilo: "Immagine profilo",
    immagine_profilo_aggiornata: "Immagine profilo aggiornata con successo!",
    importa: "Importa",
    inattivita_descrizione_1: "È stata rilevata un'inattività prolungata.",
    inattivita_descrizione_2: "Per motivi di sicurezza sei stato disconnesso.",
    inattivita_titolo: "Inattività rilevata!",
    indirizzo_ip: "Indirizzo IP",
    indirizzo_luogo_intervento: "Indirizzo luogo intervento",
    informazione: "Informazione",
    inserisci_mail_valida: "Inserisci una mail valida",
    invia_credenziali: "Invia credenziali tramite e-mail",
    invia_file: "Invia file",
    invia_rapportino: "Invia rapportino",
    inviata_amministrazione: "Inviata all'amministrazione",
    inviata_cliente: "Inviata al cliente",
    km_percorsi: "Km percorsi",
    livello: "Livello",
    lista: "Lista",
    totale_utenti: "Totale Utenti",
    completa_profilo: "Completa tutti i campi per continuare",
    login_aggiorna_accedi: "Aggiorna e accedi",
    login_attendi: "Attendi...",
    login_attendi_riprova: "Attendi per riprovare!",
    login_benvenuto: "Benvenuto!",
    login_campo_non_sicuro: "Campo non sicuro!",
    login_campi_obbligatori:
      "Inserire sia username che password per continuare",
    login_codice_scaduto: "Codice scaduto! riprova per continuare",
    login_conferma_password: "Conferma password",
    login_nuova_password: "Nuova password",
    login_controlla_mail: "Controllare le email per continuare",
    login_effetta_accesso: "Effettua l'accesso",
    login_email_reset_pass_inviata:
      "Email per reset password inviata all'utente specificato.",
    login_livello_sicurezza_password: "Livello di sicurezza password",
    login_password: "Password",
    modifica_password: "Modifica Password",
    login_password_dimenticata: "Password dimenticata?",
    login_password_non_uguali: "Le password non corrispondono",
    login_reset_password: "Resetta la password",
    login_scegli_autenticazione: "Seleziona il metodo di autenticazione",
    login_submit_text: "Accedi",
    login_suggerimenti_password: "Suggerimenti password",
    login_suggerimenti_password_1:
      "La password deve contenere almeno una lettera minuscola",
    login_suggerimenti_password_2:
      "La password deve contenere almeno una lettera maiuscola",
    login_suggerimenti_password_3:
      "La password deve contenere almeno un numero",
    login_suggerimenti_password_4:
      "La password deve contenere almeno uno carattere speciale",
    login_suggerimenti_password_5:
      "La password deve contenere almeno 8 caratteri",
    login_timeout_codice: "Codice di verifica scaduto",
    login_troppe_richieste: "Hai effettuato troppe richieste!",
    login_usa_password: "Usa la tua password",
    login_username: "Username",
    login_username_reset_password:
      "Inserisci l'username per cui si vuole richiedere il reset password nel campo 'username'.",
    login_utente_non_trovato: "Impossibile trovare l'utente inserito!",
    login_tagline: "Sistema di gestione pannelli fotovoltaici",
    login_sottotitolo: "Inserisci le tue credenziali per continuare",
    login_feature_2fa: "Autenticazione 2FA & WebAuthn",
    login_feature_interfaccia: "Interfaccia reattiva",
    login_feature_report: "Report e analisi",
    login_feature_monitoring: "Monitoraggio impianti in tempo reale",
    login_feature_security: "Accessi protetti e tracciati",
    login_welcome_heading: "Benvenuto nel tuo cruscotto solare.",
    login_welcome_subtitle:
      "Accedi per monitorare produzione, performance e stato degli impianti fotovoltaici.",
    login_kpi_mwh: "Energia prodotta",
    login_kpi_impianti: "Impianti monitorati",
    login_kpi_uptime: "Affidabilità",
    login_footer_supporto: "Supporto tecnico",
    idle_inattivita_rilevata: "Inattività rilevata",
    idle_descrizione_1:
      "La sessione è scaduta per inattività. Effettua nuovamente l'accesso per continuare.",
    logout_conferma_disconnessione: "Conferma",
    logout_disconnetti: "Disconnetti",
    logout_disconnessione: "Disconnessione",
    logout_messaggio_disconnessione:
      "Sicuro di voler effettuare la disconnessione?",
    luogo_intervento: "Luogo intervento",
    menu_categorie_commesse: "Categorie commesse",
    menu_tipologia_operatori: "Tipologia Operatori",
    menu_clienti: "Clienti",
    menu_appuntamenti: "Appuntamenti",
    menu_dashboard: "Dashboard",
    menu_strutture: "Strutture",
    menu_occupazione: "Occupazione",
    menu_priorita_commesse: "Priorità commesse",
    menu_prodotti: "Prodotti",
    menu_rapportini: "Rapportini",
    menu_rapportini_nuovo: "Crea nuovo",
    menu_rapportini_nuovo_rapportino: "Nuovo rapportino",
    menu_rapportini_resoconto: "Resoconto",
    menu_macro_gruppi: "Macro Gruppi",
    menu_pazienti: "Pazienti",
    menu_sconti: "Sconti",
    menu_tag_commesse: "Tag commesse",
    menu_utilita_calendario_eventi: "Calendario eventi",
    menu_utilita: "Utilità",
    menu_utilita_archivio: "Archivio",
    menu_utilita_chat: "Chat",
    messaggio_conferma_eliminazione_selezionati: "Dati eliminati con successo!",
    messaggio_conferma_ripristino_selezionati:
      "Dati ripristinati con successo!",
    messaggio_duplicazione: "Duplicare la commessa?",
    messaggio_eliminazione: "Eliminare la commessa?",
    messaggio_eliminazione_selezionati:
      "Sicuro di voler eliminare i dati selezionati?",
    messaggio_ripristina_selezionati:
      "Sicuro di voler ripristinare i dati selezionati?",
    abitudini_vita: "Abitudini di vita",
    messaggio_eliminato: "Messaggio eliminato",
    dieta_libera_varia: "Dieta libera e varia",
    dieta_controllata: "Controllata per",
    digestione: "Digestione regolare",
    medico_curante: "Medico curante",
    storia_malattie_paziente: "Storia delle malattie del paziente",
    malattie_cuore: "Malattie del cuore",
    malattie_cuore_descrizione: "Descrizione malattie del cuore",
    pressione: "Pressione",
    allergie: "Allergie",
    quali_allergie: "Quali allergie?",
    diabete: "Diabete",
    tipologia_diabete: "Tipologia diabete",
    epatite_virale: "Epatite virale",
    tipologia_epatite: "Tipologia epatite",
    malattie_fegato: "Malattie del fegato",
    malattie_fegato_descrizione: "Descrizione malattie del fegato",
    malattie_renali: "Malattie renali",
    malattie_renali_descrizione: "Descrizione malattie renali",
    malattie_tiroide: "Malattie della tiroide",
    malattie_tiroide_descrizione: "Descrizione malattie della tiroide",
    malattie_stomaco_tubo_digerente:
      "Malattie dello stomaco o del tubo digerente",
    malattie_stomaco_tubo_digerente_descrizione:
      "Descrizione malattie dello stomaco o del tubo digerente",
    malattie_polmonari: "Malattie polmonari",
    malattie_polmonari_descrizione: "Descrizione malattie polmonari",
    malattie_veneree: "Malattie veneree",
    malattie_veneree_descrizione: "Descrizione malattie veneree",
    malattie_nervose_depressive: "Malattie nervose e depressive",
    malattie_nervose_depressive_descrizione:
      "Descrizione malattie nervose e depressive",
    malattie_oculari: "Malattie oculari",
    malattie_oculari_descrizione: "Descrizione malattie oculari",
    malattie_sangue_emorragie: "Malattie del sangue ed emorragie",
    malattie_sangue_emorragie_descrizione:
      "Descrizione malattie del sangue ed emorragie",
    malattie_non_elencate: "Malattie non elencate",
    alitosi: "Alitosi",
    conseguenze_particolari:
      "Conseguenze particolari in seguito all'assunzione di anestetici, antibiotici, analgesici o altri farmaci ?",
    esami_radiografici: "Esami radiografici",
    terapia_irradiante: "Terapia irradiante",
    esami_radiografici_descrizione: "Descrizione esami radiografici",
    terapia_irradiante_descrizione: "Descrizione terapia irradiante",
    malattie_gravi_interventi_chirurgici:
      "Malattie gravi e/o interventi chirurgici",
    malattie_gravi_interventi_chirurgici_descrizione:
      "Descrizione malattie gravi e/o interventi chirurgici",
    menu_tipologie_visite: "Tipologie visite",
    alvo: "Alvo regolare",
    per_uomini: "Per gli uomini",
    sonno: "Sonno regolare",
    seleziona_elementi_da_esportare: "Seleziona gli elementi da esportare",
    pdf_generato_correttamente: "PDF generato correttamente",
    fumo: "Fumo",
    fame_nervosa_desc: "Soffri di fame nervosa?",
    stitichezza_desc: "Soffri di stitichezza?",
    stitichezza: "Stitichezza",
    fame_nervosa: "Fame nervosa",
    tipo_acqua: "Tipo di acqua",
    litri_giorno: "Litri di acqua al giorno",
    andropausa: "Andropausa",
    andropausa_anni: "Anni di andropausa",
    seleziona_alimenti_preferiti:
      "Seleziona alimenti preferiti (possibili più scelte)",
    quanto_fumo: "Quantità giornaliera",
    tempo_fumo: "Da quanto tempo?",
    numero_caffe: "Numero di caffè giornalieri",
    caffe: "Caffè",
    alcol: "Alcolici",
    quali_alcol: "Quali alcolici?",
    farmaci: "Assume farmaci e/o droghe?",
    quali_farmaci: "Quali farmaci e/o droghe?",
    tempo_farmaci: "Da quanto tempo?",
    perche_farmaci: "Perché?",
    antitetanica: "Antitetanica",
    ultimo_antitetanica: "Data ultima somministrazione",
    professione: "Professione",
    per_donne: "Per le donne",
    menarca_anni: "Menarca",
    menarca_anni_testo: "Anni",
    ultimo_ciclo: "Ultimo ciclo",
    ciclo_regolare: "Ciclo regolare",
    gravidanze: "Gravidanze",
    numero_gravidanze: "Numero di gravidanze",
    modifica: "Modifica",
    mostra_ore: "Visualizza il monte ore",
    nessuna_chat_selezionata: "Nessuna chat selezionata",
    nessun_dato: "Nessun dato presente",
    nessun_dato_disponibile: "Nessun dato disponibile",
    nessun_dato_disponibile_descrizione:
      "Non sono presenti evocleaners per i filtri impostati. Prova a modificare i parametri di ricerca o crea un nuovo elemento.",
    seleziona_anamnesi: "Seleziona anamnesi",
    chiudi_anamnesi: "Chiudi anamnesi",
    seleziona_icd9: "Seleziona ICD9",
    ICD9: "ICD9",
    anamnesi_salvata: "Anamnesi salvata con successo!",
    data_evento: "Data evento",
    appunti: "Appunti",
    familiare: "Familiare",
    seleziona_familiare: "Seleziona familiare",
    diagnosi: "Diagnosi",
    annotazioni: "Annotazioni",
    nessuna_email_cliente: "Nessuna email presente per il cliente selezionato",
    nessun_cliente_selezionato: "Nessun cliente selezionato",
    nessun_dato_archiviato:
      "Non è presente alcun dato contrassegnato come archiviato",
    nominativo: "Nominativo",
    nominativo_cliente: "Nominativo cliente",
    nominativo_dipendente: "Nominativo dipendente cliente",
    sesso: "Sesso",
    citta: "Città",
    frazione: "Frazione / Località",
    codice_fiscale: "Codice Fiscale",
    indirizzo: "Indirizzo",
    non_programmato: "Non programmato",
    note_amministrative: "Note amministrative",
    note_intervento: "Note intervento",
    numero: "Numero",
    numero_missioni: "Numero missioni",
    numero_documento: "Numero documento",
    oggi: "Oggi",
    compila_tutti_i_campi_obbligatori: "Compila tutti i campi obbligatori",
    occupazione: "Occupazione",
    ore_effettive: "Ore effettive",
    ore_lavorate: "Ore lavorate",
    ore_lavorate_breve: "ore lav.",
    ore_lavorate_breve_header: "Ore lav.",
    ore_lavorate_effettive: "Ore lavorate effettive",
    ore_lavorate_effettive_breve_header: "Ore eff.",
    ore_viaggio: "Ore viaggio",
    modifica_referto: "Modifica referto",
    oppure: "Oppure",
    parametri: "Parametri",
    pdf_generato_con_successo: "PDF generato con successo",
    errore_generazione_pdf: "Errore durante la generazione del PDF",
    password: "Password",
    password_aggiornata: "Password aggiornata con successo!",
    password_cambiata: "Password cambiata con successo!",
    password_gia_usata:
      "La password è già stata utilizzata in precedenza! Inserirne un'altra per continuare.",
    percentuale_completamento: "Progresso",
    pianificazione: "Pianificazione",
    prodotti: "Prodotti",
    qrcode: "QR Code",
    prodotto: "Prodotto",
    prodotti_relativi_ordine: "Prodotti relativi all'ordine",
    prodotti_utilizzati: "Prodotti utilizzati",
    profilo_aggiornato: "Profilo aggiornato con successo!",
    profilo: {
      completo: "Completo",
    },
    tutto_completo: "Tutto completo",
    rapportini: "Rapportini",
    referti: "Referti",
    oggetto: "Oggetto",
    menu_referti_nuovo: "Nuovo Referto",
    menu_referti_aggiorna: "Aggiorna Referto",
    menu_referti_visualizza: "Visualizza Referti",
    menu_referti_resoconto: "Resoconto Referti",
    oggetto_referto: "Oggetto Referto",
    menu_referti: "Referti",
    nuovo_referto_medico: "Nuovo Referto Medico",
    data_referto: "Data Referto",
    esame_obiettivo: "Esame Obiettivo",
    terapia_prescritta: "Terapia Prescritta",
    note_aggiuntive: "Note Aggiuntive",
    firma: "Firma",
    firma_referto: "Firma referto",
    salva_bozza: "Salva Bozza",
    bozza: "Bozza",
    consegnato: "Consegnato",
    salva_referto: "Salva Referto",
    nuovo_referto: "Nuovo Referto",
    rapportino_inviato: "Rapportino inviato con successo!",
    rapportino_ricevuto: "Rapportino ricevuto",
    relazione_intervento: "Relazione intervento",
    resoconto: "Resoconto",
    riprendi_timer: "Riprendi timer",
    dipendenti: "Collaboratori",
    seleziona: "Seleziona",
    seleziona_foto: "Seleziona foto",
    settimana: "Settimana",
    settimana_attuale: "Settimana attuale",
    standard: "Standard",
    stato: "Stato",
    successo: "Successo",
    su: "su",
    su_cosa_hai_lavorato: "Su cosa hai lavorato?",
    tempo_rimanente: "Tempo rimanente",
    termina_modifica: "Termina prima la modifica in corso!",
    testo_copiato: "Testo copiato negli appunti",
    titolo_cambio_password: "Cambio password",
    torna_indietro: "Torna indietro",
    totale_ore: "Totale ore",
    trasferta: "Trasferta",
    tutti_i_campi_devono_essere_compilati:
      "Tutti i campi obbligatori devono essere compilati",
    url: "URL",
    username: "Username",
    utenti: "Utenti",
    verifica_campi: "Verifica i campi inseriti",
    visualizzi_da: "Visualizzi da",
    zero_ore_lavorate_breve: "0 ore lav.",
    allergie_intolleranze: "Allergie e intolleranze",
    insorgenza_malattia: "Insorgenza malattia",
    modalita_insorgenza: "Modalità insorgenza",
    sintomatologia: "Sintomatologia",
    fattori_scatenanti: "Fattori scatenanti",
    fattori_allevianti: "Fattori allevianti",
    farmaci_assunti: "Farmaci assunti",
    terapie_precedenti: "Terapie precedenti",
    disturbi_associati: "Disturbi associati",
    paziente_gia_presente: "Paziente già presente",
    paziente_aggiornato: "Paziente aggiornato",
    paziente_aggiunto: "Paziente aggiunto",
    dati_importati_con_successo: "Dati importati con successo",
    errore_importazione: "Errore durante l'importazione",
    formato_file_non_supportato: "Formato file non supportato",
    seleziona_file_excel: "Seleziona file Excel",
    anteprima_dati: "Anteprima dati",
    conferma_importazione: "Conferma importazione",
    pazienti_da_importare: "Pazienti da importare",
    pazienti_importati: "Pazienti importati",
    pazienti_aggiornati: "Pazienti aggiornati",
    processing_import: "Elaborazione importazione in corso...",
    file_non_valido: "File non valido",
    dati_non_validi: "Dati non validi nel file",
    conferma_creazione_commessa_con_padre:
      "Sei sicuro di voler creare una commessa figlia? Se la commessa padre ha una pianificazione, questa verrà eliminata.",
    utenti_in_carico: "Utenti in carico",
    lascia_incarico: "Lascia incarico",
    conferma_lascia_incarico:
      "Sei sicuro di voler lasciare l'incarico di questa commessa?",
    conferma_presa_in_carico:
      "Sei sicuro di voler prendere in carico questa commessa?",
    commessa_presa_in_carico: "Commessa presa correttamente in carico!",
    no_utente_in_carico:
      "Nessun utente ha ancora preso in carico questa commessa",
    prendi_in_carico: "Prendi in carico",
    conferma_svuotamento_tabella: "Sei sicuro di voler svuotare la tabella?",
    svuotamento_tabella: "Svuotamento tabella",
    svuota_tabella: "Svuota tabella",
    codice_otp: "Codice OTP",
    codice_otp_testo:
      "Inserisci il codice OTP generato dalla tua app di autenticazione.",
    troppi_errori_verifica_codice:
      "Troppi errori nella verifica del codice, stai per essere riportato alla pagina del login.",
    codice_inserito_errato: "Il codice inserito non è corretto, riprova.",
    prezzo_totale: "Prezzo totale",
    tentativi_rimanenti: "Tentativi rimanenti: ",
    periodo: "Periodo",
    mostra_utenti_selezionati: "Mostra utenti",
    nascondi_utenti_selezionati: "Nascondi utenti",
    visualizza: "Visualizza",
    crea_copia: "Crea copia",
    ricorda_calcola_prezzi:
      "Ricorda di calcolare i prezzi se non l'hai ancora fatto!",
    modifica_copia: "Modifica copia",
    totale: "Totale",
    genera_pdf: "Genera PDF",
    desideri_generare_pdf: "Desideri generare il PDF",
    creato_con_successo: "Creato con successo",
    nessuna_commessa: "Nessuna commessa presente",
    collaboratori: "Collaboratori",
    copia_rapportino: "Copia rapportino",
    denominazione_commessa: "Denominazione commessa",
    chiudi_righe: "Chiudi righe",
    firma_cliente_mancante: "Firma del cliente mancante",
    firma_tecnico_mancante: "Firma del tecnico mancante",
    configurazione_tabella_salvata: "Configurazione tabella salvata",
    errore_salvataggio_configurazione:
      "Errore durante il salvataggio della configurazione",
    sconti: "Sconti",
    mostra_sconti: "Mostra sconti",
    installa_pwa: "Installa app",
    dialog_recuperato: "Finestra recuperata",
    passato_a_dataview: "Passato alla visualizzazione tramite 'Griglia'",
    passato_a_tabs: "Passato alla visualizzazione tramite 'Tabs'",
    ultima_volta_sincronizzati: "Dati sincronizzati l'ultima volta il",
    minimizza_mobile: "Minimizza",
    massimizza_mobile: "Massimizza",
    mostra_eventi_click: "Mostra eventi al click",
    mostra_eventi_hover: "Mostra eventi al hover",
    riapri_dialog: "Riapri finestra",
    setup_salvato: "Dati del form salvati localmente",
    setup_rimosso: "Dati del form rimossi localmente",
    elimina_setup_localmente: "Elimina i dati del form salvati localmente",
    visualizza_tabs: "Passa alla visualizzazione tramite 'Tabs'",
    visualizza_dataview: "Passa alla visualizzazione tramite 'Griglia'",
    no_dato_trovato: "Nessun dato trovato",
    disancora_elemento: "Disancora elemento",
    ancora_destra: "Ancora a destra",
    chiudi_elemento: "Chiudi elemento",
    ricarica: "Ricarica",
    cap: "CAP",
    email: "Email",
    telefono: "Telefono",
    minimo_2_caratteri: "Minimo 2 caratteri",
    minimo_3_caratteri: "Minimo 3 caratteri",
    nome_impianto: "Nome impianto",
    conferma_azione: "Conferma azione",
    sposta_a: "Sposta a",
    destra: "Destra",
    sinistra: "Sinistra",
    elimina: "Elimina",
    eliminazione_dati: "Eliminazione di dati",
    dato_ricaricato: "Dato ricaricato con successo!",
    categoria_utente: "Categoria utente",
    duefa: "App di autenticazione",
    password_temporanea: "Password temporanea",
    setup_non_trovato: "Non hai nessun dato del form salvato localmente",
    salva_setup_localmente: "Salva setup localmente",
    aggiornamento_eseguito: "Aggiornamento eseguito",
    licenza_aggiornata: "Licenza aggiornata",
    dueeffea_disabilitato_con_successo:
      "Autenticazione a due fattori disabilitata con successo",
    nessun_elemento_selezionato_per_esportazione:
      "Nessun elemento selezionato per l'esportazione",
    errori: {
      generico: "Si è verificato un errore",
      id_mancante: "ID mancante",
      file_mancante: "File mancante",
      versione_mancante: "Versione mancante",
      firmware_project_name_errato: "Il file non è un firmware dei tracker (nome progetto \"{nome}\", atteso \"SolarTracker\")",
      nessun_impianto_selezionato: "Seleziona almeno un impianto",
      troppi_impianti_selezionati: "Troppi impianti selezionati (massimo 500)",
      nessun_firmware_selezionato: "Seleziona almeno un firmware",
      parametri_non_validi: "Parametri non validi",
      versione_diversa_da_header: "La versione indicata è diversa da quella contenuta nel file",
      versione_formato_non_valido: "Formato versione non valido (atteso NN.NN.NN, es. 01.01.14)",
      firmware_senza_famiglia_hw: "Il firmware non ha una famiglia hardware (versione non nel formato NN.NN.NN)",
      firmware_famiglia_hw_duplicata: "Si può assegnare un solo firmware per famiglia hardware",
      formato_non_supportato: "Formato file non supportato",
      file_troppo_grande: "File troppo grande",
      versione_gia_esistente: "Versione firmware già esistente",
      firmware_non_trovato: "Versione firmware non trovata",
      firmware_in_uso:
        "Non è possibile eliminare una versione firmware in uso",
      blob_mancante: "Contenuto del firmware non disponibile",
      download_fallito: "Download fallito",
      impianto_non_trovato: "Impianto non trovato",
    },
    colori: {
      trasparente: "Trasparente",
      bianco: "Bianco",
      grigio_chiaro: "Grigio chiaro",
      argento: "Argento",
      marrone: "Marrone",
      oro: "Oro",
      giallo: "Giallo",
      lime: "Lime",
      verde: "Verde",
      verde_scuro: "Verde scuro",
      turchese: "Turchese",
      ciano: "Ciano",
      blu: "Blu",
      blu_scuro: "Blu scuro",
      viola: "Viola",
      rosa: "Rosa",
      rosso: "Rosso",
      rosso_scuro: "Rosso scuro",
      arancione: "Arancione",
      grigio: "Grigio",
    },
    setup_ripristinato: "Dati ripristinati, salvare per confermare",
    avviso: "Avviso",
    tooltip_password_temporanea:
      "La password temporanea sarà disponibile per il login solo una volta: una volta effettuato il primo accesso, l'utente verrà obbligato a cambiarla!",
    creazione_gia_in_corso: "Creazione già in corso!",
    archivia: "elimina",
    seleziona_file: "Seleziona file",
    importazione_dati: "Importazione di dati",
    importazione_dati_riuscita: "Importazione di dati riuscita!",
    importazione_dati_fallita: "Importazione di dati fallita!",
    importazione_dati_errore: "Errore durante l'importazione dei dati!",
    importazione_in_corso: "Importazione in corso...",
    elementi_importati: "Elementi importati",
    sigla: "Sigla",
    descma: "Descma",
    cod_fornitore: "Cod. fornitore",
    cod_prodotto: "Cod. prodotto",
    prezzo_netto: "Prezzo netto",
    prezzo_listino: "Prezzo di listino",
    stato_prodotto: "Stato prodotto",
    barcode: "Barcode",
    unita_misura: "Unità di misura",
    serie_vendita: "Serie vendita",
    cod_numerico: "Cod. numerico",
    qta_min_acquistabile: "Qta. min. acquistabile",
    gruppo_1: "Gruppo 1",
    gruppo_2: "Gruppo 2",
    gruppo_3: "Gruppo 3",
    moltipli_prezzo: "Moltipl. prezzo",
    moltipli_prezzo_netto: "Moltipl. prezzo netto",
    iva: "Iva",
    preferiti: "Preferiti",
    dettagli: "Dettagli",
    cvs_headers_errore: "Errore nel file inserito! Headers mancanti",
    desc_serie_vendita: "Descrizione serie vendita",
    data_validita: "Data validità",
    sconto1: "Sconto 1",
    sconto2: "Sconto 2",
    sconto3: "Sconto 3",
    sconto4: "Sconto 4",
    sconto5: "Sconto 5",
    seleziona_righe_pdf:
      "Seleziona prima le righe tramite la casella sulla sinistra della tabella da includere nel PDF",
    seleziona_righe_prima:
      "Per poter eliminare degli elementi, prima seleziona delle righe tramite la casella sulla sinistra della tabella!",
    data_non_valida: "Data non valida",
    prezzo_ora: "Prezzo ora",
    commessa_padre: "Commessa padre",
    alta: "Alta",
    media: "Media",
    bassa: "Bassa",
    priorita: "Priorità",
    dal: "Dal",
    al: "Al",
    no_categoria: "Nessuna categoria",
    note_per_dipendenti: "Note per le dipendenti",
    descrizione_commessa: "Descrizione commessa",
    commessa_principale: "Commessa principale",
    utenti_creatori: "Utenti creatori",
    unione_filtri: "Unione filtri",
    applica_filtri: "Applica filtri",
    filtri: "Filtri",
    filtra: "Filtra",
    filtro_attivo: "filtro attivo",
    filtri_attivi: "filtri attivi",
    tutti: "Tutti",
    ha: "Ha",
    non_ha: "Non ha",
    em_stop_remoto: "EM stop remoto",
    em_stop_locale: "EM stop locale",
    consumo_acqua: "Consumo acqua",
    durata_min_minuti: "Durata min (min)",
    durata_max_minuti: "Durata max (min)",
    consumo_acqua_stimato_min_l: "Consumo acqua stimato min (L)",
    consumo_acqua_stimato_max_l: "Consumo acqua stimato max (L)",
    e: "E",
    amministratore: "Amministratore",
    se_null_imposta_inizio:
      "Se lasciato vuoto, verrà automaticamente impostato come un'evento con durata solo un giorno (quello selezionato come inizio)",
    vai_a_profilo: "Vai al profilo",
    commessa_da_pianificare: "La commessa non è ancora stata pianificata.",
    commessa_gia_pianificata: "La commessa è già stata pianificata.",
    pianifica: "Pianifica",
    firma_cliente: "Firma cliente",
    firma_tecnico: "Firma tecnico",
    pulisci: "Pulisci",
    totale_imponibile_iva_esclusa: "Totale imponibile iva esclusa",
    prezzo_orario: "Prezzo orario",
    nessun_prodotto_utilizzato: "Nessun prodotto utilizzato",
    aggiungi_un_prodotto_per_cominciare: "Aggiungi un prodotto per cominciare",
    nessun_utente_associata: "Nessuna utente associata",
    aggiungi_una_utente_per_cominciare: "Aggiungi una utente per cominciare",
    ditta_installatrice: "Ditta installatrice",
    prezzo_calcolato: "Prezzo calcolato",
    quantita: "Quantità",
    calcola: "Calcola",
    tipologia_lavoro_svolto: "Tipologia lavoro svolto",
    mostra_prodotti_selezionati: "Mostra prodotti",
    nascondi_prodotti_selezionati: "Nascondi prodotti",
    mostra_dipendenti_selezionate: "Mostra dipendenti",
    nascondi_dipendenti_selezionate: "Nascondi dipendenti",
    sei_sicuro_di_voler_rimuovere_prodotto:
      "Sei sicuro di voler rimuovere il prodotto",
    sei_sicuro_di_voler_rimuovere_utente:
      "Sei sicuro di voler rimuovere la utente",
    si: "Si",
    no: "No",
    attenzione: "Attenzione",
    numero_rapportini: "Numero rapportini",
    mese: "Mese",
    denominazione_cliente: "Denominazione cliente",
    visualizza_firme: "Visualizza firme",
    pdf_rapportino: "PDF rapportino",
    visualizza_rapportino_pdf: "Visualizza PDF rapportino",
    scarica_rapportino_pdf: "Scarica PDF rapportino",
    elimina_rapportino_pdf: "Elimina PDF rapportino",
    generazione_pdf: "Generazione PDF in corso...",
    generazione_pdf_completata: "Generazione PDF completata con successo!",
    programmata: "Programmata",
    completata: "Completata",
    info_commesse_pianificazione: "INFO COMMESSE",
    modifica_creazione: "Creazione e Modifica",
    visualizza_commesse: "Visualizzazione Commesse",
    step_commesse: "Step delle Commesse",
    pianificazione_commesse: "Pianificazione Commesse",
    descrizione_modifica_creazione:
      "Qui puoi creare nuove commesse e modificarle facilmente.",
    descrizione_visualizzazione:
      "Accedi alla lista delle commesse per una panoramica completa.",
    descrizione_step:
      " Ogni commessa è suddivisa in vari step che possono essere monitorati.",
    conferma_pianifica: "Vuoi pianificare la commessa appena creata?",
    descrizione_pianificazione:
      "La pianificazione di una commessa consiste nella organizzazione di tutte le attività necessarie per completarla in modo efficiente.",
    popup_modifica_creazione:
      "\n              <p><strong>Premendo il tasto \"+\" in alto a destra si possono inserire nuove commesse con relativi dati:</strong></p>\n              <ul>\n                <li><strong>Nome:</strong> Identificativo univoco della commessa per facilitarne la gestione e il riconoscimento.</li>\n                <br>\n                <li><strong>Cliente:</strong> Nome del cliente per cui viene creata la commessa.</li>\n                <br>\n                <li><strong>Commessa padre:</strong> Opzione per creare gerarchie tra commesse, assegnando una commessa principale (utile per suddividere progetti più complessi).</li>\n                <br>\n                <li><strong>Priorità:</strong> Indica l'urgenza della commessa, scegliendo tra Alta, Media o Bassa per facilitare l'organizzazione delle attività.</li>\n                <br>\n                <li><strong>Descrizione:</strong> Testo libero in cui specificare dettagli e informazioni fondamentali sul contenuto della commessa.</li>\n                <br>\n                <li><strong>Note:</strong> Sezione per aggiungere annotazioni, commenti o eventuali informazioni aggiuntive utili alla gestione della commessa.</li>\n              </ul>\n              ",
    popup_visualizza_commesse:
      "\n                <p><strong>Visualizzazione delle Commesse</strong></p>\n                <p>Le commesse vengono organizzate e visualizzate con criteri chiari e strutturati per garantire una gestione efficace e intuitiva.\n                La visualizzazione può avvenire in base a diversi parametri:</p>\n                <ul>\n                  <li>\n                    <strong>Nome:</strong> Le commesse vengono identificate attraverso il loro nome univoco, consentendo una ricerca immediata e precisa.\n                    Questo criterio è utile per chi gestisce numerose commesse e ha bisogno di riconoscerle facilmente.\n                  </li>\n                  <br>\n                  <li>\n                    <strong>Priorità:</strong> Ogni commessa è classificata in base al livello di urgenza, che può essere <strong>Alta</strong>, <strong>Media</strong> o <strong>Bassa</strong>.\n                    Questo filtro permette di organizzare le attività in modo efficace, dando precedenza alle commesse più importanti o urgenti.\n                  </li>\n                  <br>\n                  <li>\n                    <strong>Data di Creazione:</strong> Le commesse vengono elencate in ordine cronologico, permettendo di identificare rapidamente le più recenti\n                    oppure di consultare quelle meno recenti per eventuali revisioni o aggiornamenti. Questo metodo di visualizzazione è utile per tracciare\n                    l’evoluzione delle attività nel tempo.\n                  </li>\n                </ul>\n                ",
    popup_step_commesse:
      '\n                <p><strong>Visualizzazione delle Gerarchie delle Commesse</strong></p>\n                <p>Premendo il tasto "<strong>></strong>", sarà possibile espandere e visualizzare la struttura gerarchica delle commesse.</p>\n                <ul>\n                  <li><strong>Commesse principali:</strong> Verranno inizialmente mostrate in un elenco compatto per una visualizzazione più chiara.</li>\n                  <br>\n                  <li><strong>Commesse subordinate:</strong> Cliccando sul pulsante di espansione, si potranno vedere le commesse collegate a ciascuna commessa principale.</li>\n                  <br>\n                  <li><strong>Organizzazione intuitiva:</strong> Grazie a questa struttura, è possibile gestire progetti complessi suddividendo le attività in sezioni più chiare e facilmente navigabili.</li>\n                </ul>\n                ',
    popup_pianifazione_commesse:
      "\n            <p><strong>Pianificazione della Commesse</strong></p>\n            <p>La pianificazione di una commessa è essenziale per garantire un'organizzazione chiara e una gestione efficiente delle attività. Ogni commessa viene strutturata in base a diversi parametri fondamentali:</p>\n            <ul>\n              <li><strong>Commessa principale:</strong> Identificativo della commessa principale, utile per creare una gerarchia tra le attività e suddividere progetti più complessi.</li>\n              <br>\n              <li><strong>Data di inizio e fine:</strong> Ogni commessa è programmata con una data di inizio e una data di completamento, permettendo di stabilire scadenze e monitorare i progressi nel tempo.</li>\n              <br>\n              <li><strong>Collaboratori:</strong> La commessa può essere assegnata a uno o più collaboratori, facilitando il lavoro di squadra e la distribuzione dei compiti tra i vari membri del team.</li>\n              <br>\n              <li><strong>Stato della commessa:</strong> Ogni commessa può trovarsi in uno dei seguenti stati:</li>\n              <ul>\n                <li><strong>In corso:</strong> La commessa è attiva e le attività sono in fase di sviluppo.</li>\n                <br>\n                <li><strong>Completata:</strong> Tutte le attività sono state concluse con successo.</li>\n                <br>\n                <li><strong>Non completata:</strong> La commessa è stata interrotta o non è stata portata a termine secondo la pianificazione iniziale.</li>\n                <br>\n              </ul>\n            </ul>\n          <p>Grazie a questa struttura organizzativa, la pianificazione delle commesse diventa più chiara e permette un controllo preciso su ogni fase del lavoro.</p>\n          ",
    mostra_commesse: "Mostra",
    funzionamento_filtri: "Funzionamento filtri",
    descrizione_filtri:
      '\n           <h2>1. Filtro Collaboratori <i class="fal fa-solid fa-users"></i></h2>\n            <p>Permette di selezionare uno o più utenti per visualizzare solo gli elementi (progetti, attività, dipendenti) a cui partecipano.</p>\n            <p><strong>Logica Oppure:</strong> Mostra gli elementi con almeno uno dei collaboratori selezionati (es. Marco oppure Luca).</p>\n            <p><strong>Logica E:</strong> Mostra solo gli elementi dove tutti i collaboratori selezionati sono presenti (es. Marco e Luca insieme).</p>\n\n            <h2>2. Filtro Categorie <i class="fal fa-solid fa-list"></i></h2>\n            <p>Filtra per tipologia di contenuto (es. Marketing, Formazione...). Supporta selezione singola o multipla.</p>\n            <p><strong>Logica consigliata:</strong> Oppure. Esempio: selezionando “Marketing” e “Vendite” si vedono gli elementi che appartengono a una delle due.</p>\n\n            <h2>3. Filtro Utenti Creatore <i class="fa-solid fa-user-tie"></i></h2>\n            <p>Filtra in base a chi ha creato l’elemento (es. “mostra tutte le dipendenti create da Marco”).</p>\n\n            <h2>Logica E vs Oppure <i class="fal fa-solid fa-gears"></i></h2>\n            <ul>\n              <li><strong>Collaboratori:</strong> E = tutti presenti / Oppure = almeno uno presente</li>\n              <li><strong>Categorie:</strong> E = tutte / Oppure = una qualsiasi</li>\n              <li><strong>Clienti:</strong> E = tutti  / Oppure = uno qualsiasi</li>\n              <li><strong>Creatori:</strong> E = poco sensato / Oppure = uno qualsiasi</li>\n            </ul>\n            <p><strong>Nota:</strong> la logica Oppure è la più intuitiva e raccomandata nella maggior parte dei casi.</p>\n',
    sconto_percentuale: "Sconto percentuale",
    recupera_password: "Recupera password",
    inserisci_Username: "Inserisci lo username",
    inserisci_Username_per_recupero_passoword:
      "Inserisci il tuo username per effettuare la richiesta di recupero della password",
    verifica_il_codice: "Verifica il codice",
    codice_tramite_email:
      "Inserisci il codice che ti è stato inviato tramite e-mail",
    resetta_password: "Resetta la password",
    generatore_password:
      "Utilizza il generatore per creare una password robusta e sicura. Riceverai un'e-mail con la nuova password.",
    torna_al_login: "Torna al login",
    missioni_macchina: "Missioni macchina",
    ultima_missione_ricevuta: "Ultima missione ricevuta",
    totale_missioni_label: "Totale missioni: {count}",
    mission: "Mission",
    messaggi: "Messaggi",
    distanza_km: "Distanza (km)",
    velocita_media: "Velocità media",
    em_stop_label: "EM stop",
    velocita: "Velocità",
    percorso: "Percorso",
    missioni: "Missioni",
    tot_breve: "Tot",
    seriale_mancante: "Seriale mancante",
    confermi_em_stop_remoto: "Confermi EM Stop remoto?",
    confermi_sblocco_remoto: "Confermi sblocco remoto?",
    conferma_em_stop: "Conferma EM Stop",
    conferma_sblocco: "Conferma sblocco",
    em_stop_inviato: "EM Stop inviato",
    sblocco_inviato: "Sblocco inviato",
    socket_non_disponibile: "Socket non disponibile",
    errore_invio: "Errore invio",
    max_label: "max:",
    msg_abbrev: "msg",
    paginazione: "Paginazione",
    color_trasparente: "Trasparente",
    color_bianco: "Bianco",
    color_grigio_chiaro: "Grigio chiaro",
    color_argento: "Argento",
    color_marrone: "Marrone",
    color_oro: "Oro",
    color_giallo: "Giallo",
    color_lime: "Lime",
    color_verde: "Verde",
    color_verde_scuro: "Verde scuro",
    color_turchese: "Turchese",
    color_ciano: "Ciano",
    color_blu: "Blu",
    color_blu_scuro: "Blu scuro",
    color_viola: "Viola",
    color_rosa: "Rosa",
    color_rosso: "Rosso",
    color_rosso_scuro: "Rosso scuro",
    color_arancione: "Arancione",
    color_grigio: "Grigio",
    abilita_2fa: "Abilita 2FA",
    rigenera_qr: "Rigenera QR",
    attendi_reindirizzamento:
      "Attendi il reindirizzamento alla verifica del dispositivo...",
    primo_login_potrebbe_impiegarci_un_po:
      "Il primo login potrebbe impiegarci un po' di più del solito.",
    device_types: {
      sconosciuto: "Sconosciuto",
      tracker: "Tracker",
      tracker_meteo: "Tracker meteo",
      anemometro: "Anemometro",
      sensore_direzione_vento: "Sensore direzione vento",
      stazione_meteo: "Stazione meteo",
      inverter: "Inverter",
      repeater: "Repeater",
      tracker_repeater: "Tracker repeater",
    },
    conn_types: {
      wifi: "WiFi",
      rs485: "RS485",
      ethernet: "Ethernet",
    },
    mappa_impianto: {
      titolo_dialog: "Mappa impianto",
      titolo_wizard: "Import mappa impianto",
      tooltip_apri_mappa: "Mappa impianto",
      tooltip_importa_csv: "Importa CSV",
      aggiungi_nodo: "Aggiungi nodo",
      credenziali: "Credenziali",
      credenziali_modifica_hint:
        "Lascia il campo password vuoto per mantenere quella attuale. La password viene salvata cifrata sul server.",
      step_upload: "1. Upload e preview",
      step_credenziali: "2. Credenziali quadri",
      label_file_csv: "File CSV",
      hint_separatori:
        "Separatore di campo: ; — separatore decimale: , o . — encoding: UTF-8.",
      dropzone_hint: "Oppure trascinalo qui",
      warning_mappa_esistente:
        "L'impianto ha già dei quadri. Durante il parsing i QL già presenti verranno esclusi automaticamente dal CSV; saranno importati solo i quadri nuovi.",
      riepilogo: "Riepilogo",
      quadri_distinti: "Quadri distinti",
      label_tracker: "Tracker",
      label_inverter: "Inverter",
      label_weather_station: "Weather station",
      label_devices: "Dispositivi",
      label_quadro: "Quadro",
      label_tipo: "Tipo",
      label_vele_dedup: "Vele (dedup)",
      genera_username_bulk: "Genera username",
      genera_password_bulk: "Genera password",
      apply_stesse_credenziali:
        "Applica le stesse credenziali a tutti i quadri",
      col_codice_locale: "Codice locale",
      col_numero_dispositivi: "# dispositivi",
      col_username: "Username",
      col_password: "Password",
      label_codice_locale: "Codice locale",
      label_username: "Username",
      label_password: "Password",
      label_password_optional: "Password (lascia vuoto per non modificare)",
      label_nome: "Nome",
      label_marca: "Marca",
      label_modello: "Modello",
      label_id_device: "id_device",
      label_conn: "Conn (int)",
      label_larghezza: "Larghezza (m)",
      label_lunghezza: "Lunghezza (m)",
      label_distanza: "Distanza linee (m)",
      label_altezza: "Altezza (m)",
      label_latitudine: "Latitudine",
      label_longitudine: "Longitudine",
      label_axis_azimuth: "Azimut Asse tracker (°)",
      label_slope_tilt: "Inclinazione Terreno (°)",
      label_slope_azimuth: "Direzione Pendenza Azimut (°)",
      placeholder_auto: "auto",
      placeholder_nessuna: "Nessuna",
      placeholder_cerca: "Cerca per nome o id_device...",
      titolo_crea_quadro: "Crea Quadro",
      titolo_modifica_quadro: "Modifica Quadro",
      titolo_crea_vela: "Crea Vela",
      titolo_modifica_vela: "Modifica Vela",
      titolo_crea_tracker: "Crea Tracker",
      titolo_modifica_tracker: "Modifica Tracker",
      titolo_crea_inverter: "Crea Inverter",
      titolo_modifica_inverter: "Modifica Inverter",
      titolo_crea_weather_station: "Crea Weather Station",
      titolo_modifica_weather_station: "Modifica Weather Station",
      titolo_crea_device: "Crea Dispositivo",
      titolo_modifica_device: "Modifica Dispositivo",
      vista_geografica: "Vista geografica",
      vista_albero: "Vista albero",
      btn_aggiorna: "Aggiorna",
      reset_view_graph: "Reset vista",
      hint_interazione:
        'Click su un nodo per modificarlo · "+" per aggiungere un figlio',
      seleziona_file: "Seleziona file CSV",
      cambia_file: "Cambia file",
      context_edit: "Modifica",
      context_show_only_this: "Mostra solo questo",
      context_show_selected: "Mostra selezionati",
      section_dati_quadro: "Dati quadro",
      section_dati_vela: "Dati vela",
      section_dimensioni: "Dimensioni",
      section_coordinate: "Coordinate",
      nessun_dato_titolo: "Nessun dato",
      nessun_dato:
        "Nessun dato disponibile. Importa la mappa o crea manualmente i quadri.",
      conferma_eliminazione: "Confermi l'eliminazione?",
      conferma_eliminazione_quadro_cascade:
        "Confermi l'eliminazione del quadro? Verranno eliminati anche tutti i dispositivi e le vele collegate.",
      import_completato: "Import completato",
      salvato: "Salvato",
      vela_standalone: "(standalone)",
      caricamento: "Caricamento in corso...",
      crea_figlio: "Crea figlio",
      quale_tipo_nodo: "Quale tipo di nodo vuoi aggiungere al quadro?",
      altro: "Altro...",
      tipo_nodo: "Tipo nodo",
      quale_tipo_nodo_specifico: "Inverter, Weather Station o Vela?",
      err_parsing: "Errore parsing CSV: {msg}",
      err_colonne_mancanti: "Colonne mancanti: {cols}",
      err_csv_vuoto: "Il CSV è vuoto.",
      err_riga_type: "Riga {row}: Type non valido ({type})",
      err_riga_id_mancante: "Riga {row}: campo Id mancante",
      err_riga_id_ql: "Riga {row}: ID QL non valido",
      err_riga_duplicato:
        "Riga {row}: id_device duplicato ({id}) nello stesso quadro",
      err_riga_tracker_no_vela: "Riga {row}: tracker senza ID Vela valido",
      err_tutte_righe_escluse:
        "Nessuna riga importata: tutte le righe del CSV puntano a quadri già definiti nell'impianto (QL {quadri}). L'import serve solo per la prima inizializzazione dei quadri. Per modificare la mappa usa l'interfaccia. Per reinizializzare tutto l'impanto, eliminalo e creane uno nuovo.",
      regole_titolo: "Regole di importazione",
      regole_formato_titolo: "Formato del file",
      regole_separatore: "Separatore di campo: ; (punto e virgola)",
      regole_encoding: "Encoding: UTF-8",
      regole_decimali:
        "Separatore decimale: virgola (,) o punto (.) — accettati entrambi, normalizzati internamente.",
      regole_intestazione:
        "Prima riga: intestazione obbligatoria con i nomi esatti delle colonne sottoelencate.",
      regole_colonne_titolo: "Colonne attese (in ordine)",
      regole_type_titolo: "Tipi di nodo (campo Type)",
      regole_richiede_vela: "richiede vela",
      regole_conn_titolo: "Tipi di connessione (campo Conn)",
      regole_vincoli_titolo: "Vincoli di importazione",
      regole_tracker_vela:
        "Tracker (Type 1, 2): obbligatori ID Vela, Nome Vela, Larg./Lung./Dist./Alt. Vela, Lat, Long.",
      regole_device_no_vela:
        "Dispositivi (Type 3+): le colonne vela devono essere vuote.",
      regole_id_univoco:
        "Id univoco per ciascun quadro: nessun id_device duplicato nello stesso ID QL.",
      regole_id_ql_locale:
        "ID QL è locale all'impianto: impianti diversi possono avere lo stesso ID QL. Se un ID QL è già presente nell'impianto corrente, tutte le sue righe vengono escluse dall'import.",
      regole_vela_dedup:
        "Vele deduplicate per (ID QL, ID Vela): in caso di valori discordanti tra righe vince la prima riga incontrata.",
      info_aiuto: "Aiuto",
      filtra_per_tipo: "Filtra per tipo",
      filtri_attivi: "Filtri attivi",
      esci_focus: "Esci dal focus",
      focus_subtree: "Focus sottoalbero",
      focus_mode_single: "Solo questo",
      focus_mode_multi: "Selezionati",
      focus_mode_subtree: "Sottoalbero",
      elementi: "elementi",
      info_titolo: "Scorciatoie e strumenti",
      info_mouse: "Mouse",
      info_tastiera: "Tastiera",
      info_strumenti: "Strumenti disponibili",
      info_click: "modifica il nodo (rename rapido per tracker/device/vela)",
      info_ctrl_click: "aggiungi/togli dalla selezione multipla",
      info_right_click: "apri menu contestuale (modifica, elimina, focus)",
      info_hover: "anteprima dettagliata del nodo",
      info_scroll: "zoom · drag su area vuota: pan",
      info_slash: "focus sul campo ricerca",
      info_fit: "adatta la mappa allo schermo",
      info_esc: "esci dal focus o chiudi il tooltip",
      info_del: "elimina il nodo selezionato",
      info_layout:
        "Layout: radiale, gerarchico (layered) o force-directed via ELK.",
      info_collapse:
        "Riduci/espandi singole famiglie (tracker, device, vela) o tutte insieme.",
      info_filter:
        "Filtra i nodi per type_code: ogni chip nasconde o riattiva quella classe.",
      info_breadcrumb:
        "Il breadcrumb mostra la catena del focus: click su un livello per ricentrarlo.",
      info_url:
        "Lo stato (quadro, layout, focus, filtri) è salvato in URL: condividilo per riaprirlo identico.",
      titolo_upload_kml: "Importa Layer Mappa (KML)",
      info_kml: "Carica un file in formato .kml per aggiornare la visualizzazione topografica dell'impianto.",
      label_file_kml: "File KML",
      seleziona_file: "Seleziona file",
      layer_attivo_titolo: "Layer cartografico presente",
      layer_attivo_desc: "Questo impianto ha già un file Kml configurato. Caricandone uno nuovo, verrà sovrascritto.",
      delete_kml_completato: "Layer cartografico eliminato con successo",
      ultimo_caricamento: "Ultimo caricamento:",
      upload_info: "Caricando un nuovo file, la mappa attuale verrà sostituita."
    },
    mappa_import_pending: {
      banner: {
        titolo: "{n} import mappa in attesa di revisione",
        titolo_generico: "Import mappa in attesa di revisione",
        bottone_rivedi: "Rivedi",
      },
      dialog: {
        titolo: "Revisione import mappa",
        riepilogo_inseriti: "inseriti",
        riepilogo_aggiornati: "aggiornati",
        riepilogo_eliminati: "eliminati",
        sezione_vele: "Vele",
        sezione_trackers: "Tracker",
        sezione_devices: "Dispositivi",
        colonna_prima: "Attuale",
        colonna_dopo: "Da importare",
        etichetta_nuovo: "Nuovo",
        etichetta_eliminato: "Eliminato",
        etichetta_mac: "MAC",
        etichetta_id: "ID",
        nessuna_modifica: "Nessuna modifica ai campi",
      },
      button: {
        accetta: "Accetta",
        rifiuta: "Rifiuta",
      },
      toast: {
        accettato: "Import mappa accettato e applicato",
        rifiutato: "Import mappa rifiutato",
      },
    },
    monitoraggio: {
      titolo_dialog: "Monitoraggio impianto",
      tooltip_apri: "Apri monitoraggio impianto",
      adatta_schermo: "Adatta allo schermo",
      aggiorna: "Aggiorna",
      aggiornato: "Aggiornato",
      alimentazione: "Alimentazione",
      allarmi_attivi: "Allarmi attivi",
      angoli: "Angoli",
      angolo_attuale: "Angolo attuale",
      angolo_tabella: "Angolo tabella",
      angolo_target: "Angolo target",
      batteria: "Batteria",
      caricamento: "Caricamento...",
      cerca: "Cerca",
      direzione_vento: "Direzione vento",
      modalita: "Modalità",
      nessun_dato: "Nessun dato",
      rete: "Rete",
      seleziona_quadro: "Seleziona quadro",
      stato: "Stato",
      tensione: "Tensione",
      tracker_senza_vela: "Tracker senza vela",
      velocita_vento: "Velocità vento",
      vento: "Vento",
      vista_albero: "Vista albero",
      vista_griglia: "Vista griglia",
    },
    errore_generico: "Si è verificato un errore",
    login_campo_obbligatorio: "Compila tutti i campi per continuare",
    tema_scuro_suggerimento_eyebrow: "Suggerimento",
    tema_scuro_suggerimento_titolo: "Vuoi attivare il tema scuro?",
    tema_scuro_suggerimento_messaggio:
      "Abbiamo notato che il tuo sistema usa il tema scuro. Puoi attivarlo anche qui per un'esperienza più riposante.",
    pwa_nuovi_contenuti_disponibili:
      "Nuovi contenuti disponibili. Si prega di aggiornare la pagina.",
    wss_log: {
      ultimo_evento: "Ultimo evento: ",
      impianto: "Impianto",
      seleziona_impianto: "Seleziona un impianto",
      seleziona_impianto_prima: "Seleziona prima un impianto",
      seleziona_quadro: "Seleziona un quadro per visualizzare i log",
      nessun_quadro: "Nessun quadro disponibile",
      nessun_evento: "Nessun evento",
      nessun_evento_periodo: "Nessun evento nel periodo selezionato",
      intervallo: "Intervallo",
      categoria: "Categoria",
      categorie: "Categorie",
      livelli: "Livelli",
      cerca: "Cerca",
      cerca_placeholder: "Cerca per evento, codice o messaggio…",
      data_ora: "Data e ora",
      evento: "Evento",
      messaggio: "Messaggio",
      esito: "Esito",
      successo: "Successo",
      fallimento: "Fallimento",
      codice_errore: "Codice errore",
      durata_ms: "Durata (ms)",
      dettaglio_errore: "Dettaglio errore",
      copia_dettaglio_errore: "Copia dettaglio errore",
      dettaglio_errore_copiato: "Dettaglio errore copiato negli appunti",
      metadata: "Metadata",
      token: "Token",
      concern: {
        comunicazione: "Comunicazione",
        connessione: "Connessione",
        tutto: "Tutto",
        label: "Label",
      },
      categoria_label: {
        connection: "Connessione",
        plant_map: "Mappa impianto",
        tracker_status: "Stato tracker",
        tracker_config: "Configurazione tracker",
        manual_command: "Comando manuale",
        firmware: "Firmware",
        inverter_status: "Stato inverter",
      },
      livello_label: {
        info: "Info",
        warn: "Avviso",
        error: "Errore",
      },
      range: {
        "1h": "Ultima ora",
        "24h": "Ultime 24 ore",
        "7d": "Ultimi 7 giorni",
        "30d": "Ultimi 30 giorni",
      },
      eventi: {
        status_push_processed: "Status push processato",
        auth_success: "Autenticazione riuscita",
        auth_failed: "Autenticazione fallita",
        connection_opened: "Connessione aperta",
        connection_closed: "Connessione chiusa",
        token_invalid: "Token non valido",
        protocol_error: "Errore di protocollo",
        map_request_received: "Richiesta mappa ricevuta",
        map_csv_generated: "CSV mappa generato",
        map_csv_generation_failed: "Generazione CSV mappa fallita",
        map_push_received: "Push mappa ricevuto",
        map_push_applied: "Push mappa applicato",
        map_version_mismatch: "Versione mappa non allineata",
        map_crc_mismatch: "CRC mappa non corrispondente",
        status_push_failed: "Status push fallito",
        conf_received: "Configurazione ricevuta",
        conf_received_unknown_device: "Configurazione da dispositivo sconosciuto",
        conf_push_ack: "Ack push configurazione",
        manual_cmd_response: "Risposta comando manuale",
        manual_cmd_res_no_id: "Risposta comando manuale senza ID",
        manual_cmd_res_unknown_id: "Risposta comando manuale con ID sconosciuto",
        fw_request_received: "Richiesta firmware ricevuta",
        fw_file_generated: "File firmware generato",
        fw_generation_failed: "Generazione firmware fallita",
        fw_no_version: "Nessuna versione firmware disponibile",
        fw_blob_missing: "Blob firmware mancante",
        fw_download_ok: "Download firmware riuscito",
        fw_crc_mismatch: "CRC firmware non corrispondente",
        fw_download_failed: "Download firmware fallito",
        fw_write_failed: "Scrittura firmware fallita",
        fw_bad_version: "Versione firmware non valida per il tracker",
        ql_upload: "Upload quick log",
        ql_upload_unauthorized: "Upload quick log non autorizzato",
        ql_upload_forbidden: "Upload quick log vietato",
        ql_upload_invalid_csv: "CSV quick log non valido",
        ql_upload_unsupported_media: "Formato quick log non supportato",
        ql_upload_merge_error: "Errore di merge quick log",
        ql_upload_pending: "Upload mappa in attesa di revisione",
        ql_upload_diff_error: "Errore nel calcolo del diff mappa",
      },
      stato_label: {
        offline: "Offline",
        online: "Online",
        unknown: "Non riconosciuto",
      },
      errori_24h: "Errori (24h)",
      non_riconosciuto: "non riconosciuto",
      quadro_non_riconosciuto:
        "QL non censito in questo impianto: eventi di autenticazione falliti prima di risolvere un quadro esistente",
      evento_non_verificato:
        "Non verificato: nessuna autenticazione riuscita, l'associazione a questo quadro si basa solo sul codice dichiarato",
    },
    allarmi: {
      nome_tracker: "Tracker",
      id_tracker: "ID Tracker",
      titolo_sezione: "Storico Allarmi",
      colonna_data_apertura: "Data Apertura",
      colonna_data_chiusura: "Data Chiusura",
      colonna_durata: "Durata",
      colonna_codice: "Codice",
      colonna_titolo: "Titolo",
      colonna_descrizione: "Descrizione",
      colonna_severity: "Severity",
      colonna_stato: "Stato",
      stato_aperto: "Aperto",
      stato_chiuso: "Chiuso",
      filtro_severity: "Filtra per Severity",
      filtro_tutti: "Tutti",
      filtro_warn: "Warning",
      filtro_error: "Errore",
      filtro_critical: "Critico",
      paginazione_di: "di",
      paginazione_righe: "righe",
      bottone_esporta_xls: "Esporta XLS",
      nessun_allarme: "Nessun allarme registrato",
      errore_caricamento: "Errore nel caricamento allarmi",
      errore_esportazione: "Errore durante l'esportazione",
      esportazione_completata: "File esportato con successo",
      esportazione_troncata: "Esportazione troncata: troppi risultati",
      filtro_stato: "Filtra per stato",
      filtro_data_da: "Data da",
      filtro_data_a: "Data a",
      filtro_ricerca: "Ricerca",
      filtro_ricerca_placeholder: "Cerca per codice",
      filtro_ricerca_placeholder_impianto:
        "Cerca per codice, nome o ID tracker",
      nessun_risultato_filtri: "Nessun allarme corrisponde ai filtri",
      azione_pulisci_filtri: "Pulisci filtri",
      colonna_dispositivo: "Dispositivo",
      colonna_nome_dispositivo: "Nome dispositivo",
      colonna_tipo_dispositivo: "Tipo dispositivo",
      filtro_tipo_dispositivo: "Filtra per tipo dispositivo",
      nome: "Nome",
    },
    menu_alarm_codes: "Codici allarme",
    alarm_codes: {
      titolo_crea: "Nuovo codice allarme",
      titolo_modifica: "Modifica codice allarme",
      sezione_dati_base: "Dati base",
      sezione_traduzioni: "Traduzioni",
      titolo: "Titolo",
      descrizione: "Descrizione",
      colonna: {
        code: "Codice",
        severity: "Severità",
        category: "Categoria",
        is_blocking: "Bloccante",
        title: "Descrizione breve",
      },
      severity_options: {
        warn: "Avviso",
        error: "Errore",
        critical: "Critico",
      },
      filtro: {
        search_placeholder: "Cerca per codice, descrizione, categoria…",
        severity_placeholder: "Filtra per severità",
        category_placeholder: "Filtra per categoria",
      },
      codice: "Codice",
      messaggi: {
        create_ok: "Codice allarme creato",
        edit_ok: "Codice allarme aggiornato",
        delete_ok: "Codice allarme eliminato",
      },
      errore: {
        code_obbligatorio: "Il codice è obbligatorio",
        code_duplicato: "Esiste già un codice allarme con questo numero",
        code_non_trovato: "Codice allarme non trovato",
        severity_non_valida: "Severità non valida",
        titolo_obbligatorio: "La descrizione breve in italiano è obbligatoria",
        in_uso:
          "Impossibile eliminare: codici referenziati da allarmi storici ({codes})",
        nessun_codice: "Nessun codice selezionato per l'eliminazione",
      },
    },
    username_gestito_da_admin:
      "Lo username è gestito dagli amministratori e non è modificabile.",
    errore_durante_upload: "Errore durante il caricamento",
    foto_profilo_aggiornata: "Foto profilo aggiornata",
    copia_fingerprint: "Copia fingerprint",
    inserisci_una_password: "Inserisci una password",
    password_debole: "Debole",
    password_media: "Media",
    password_forte: "Forte",
    password_non_combaciano: "Le password non combaciano",
    dueeffea_attiva: "2FA attiva",
    dueeffea_qr_solo_attivazione:
      "Per sicurezza il QR code viene mostrato solo al momento dell'attivazione. Se hai cambiato telefono o app, disabilita e riabilita la 2FA per generarne uno nuovo.",
    dueeffea_non_attiva: "2FA non attiva",
    dueeffea_descrizione:
      "Aggiungi un ulteriore livello di sicurezza al tuo account tramite autenticazione a due fattori.",
    errore_disabilitazione_dueeffea:
      "Errore durante la disabilitazione della 2FA",
    attivo: "Attivo",
    non_attivo: "Non attivo",
    mai_collegato: "Mai collegato",
    conferma_mario: "Conferma",
    nessuna_foto_profilo: "Nessuna foto profilo",
    anteprima_immagine: "Anteprima immagine",
    anteprima_logo: "Anteprima logo",
    cambia_password: "Cambia password",
    cognome: "Cognome",
    colonna_bloccata: "Colonna bloccata",
    conferma_chiusura_dialog:
      "Ci sono modifiche non salvate. Chiudere comunque?",
    crea_backup: "Crea backup",
    creazione_non_riesciuta: "Creazione non riuscita",
    dati_anagrafici: "Dati anagrafici",
    errore_logout: "Errore durante il logout",
    errore_comando_remoto: "Errore comando remoto",
    errore_comando_remoto_descrizione:
      "Si è verificato un errore durante l'invio del comando remoto.",
    nessun_impianto_associato: "Nessun impianto associato",
    nessuna: "Nessuna",
    perpetua: "Perpetua",
    sblocco: "Sblocco",
    scarica: "Scarica",
    singolo: "Singolo",
    timeline_off: "Timeline disattivata",
    async_ops: {
      session: {
        waiting: "In attesa",
        ok: "Completata",
        error: "Completata con errori",
        timeout: "Timeout",
        partial: "Completata parzialmente",
      },
      dialog: {
        titolo: "Operazioni in corso",
        operazioni_attive: "Operazioni attive",
        nessuna_operazione_attiva: "Nessuna operazione attiva",
        nessuna_operazione_attiva_sottotitolo:
          "Le operazioni in background appariranno qui.",
        avanzamento_totale: "Avanzamento totale",
        pulisci_completate: "Pulisci completate",
        rimuovi: "Rimuovi",
      },
      pill: {
        sessioni: "Sessioni",
        in_attesa: "In attesa",
        progresso: "Progresso",
        espandi: "Espandi",
        trascina: "Trascina",
        tutti_completati: "Tutti completati",
      },
    },
    inverter: {
      allarmi: "Allarmi",
      anagrafica: "Anagrafica inverter",
      apri_anagrafica: "Apri anagrafica",
      apri_dettagli: "Apri dettagli",
      confronto_inverter: "Confronto inverter",
      corrente_dc: "Corrente DC",
      cos_phi: "Cos φ",
      cos_phi_medio: "Cos φ medio",
      dettaglio_impianto: "Dettaglio impianto",
      dettaglio_inverter: "Dettaglio inverter",
      energia_oggi: "Energia oggi",
      energia_periodo: "Energia del periodo",
      energia_prodotta: "Energia prodotta",
      energia_totale: "Energia totale",
      errore_caricamento_telemetria: "Errore nel caricamento della telemetria",
      gauge_aria: "Potenza attuale {valore} su un massimo di {massimo}",
      gauge_escluso_singolo: "{nome} non è conteggiato nella potenza massima: {motivo}",
      gauge_esclusi_multipli: "{n} inverter non conteggiati nella potenza massima",
      gauge_fondo_scala_non_disponibile: "Potenza massima non disponibile: nessun inverter è agganciato a un modello con potenza AC massima nota",
      gauge_mai_aggiornato: "Mai aggiornato",
      gauge_non_aggiornati_multipli: "{n} inverter non aggiornati da più di 15 minuti",
      gauge_non_aggiornato_singolo: "{nome} non è aggiornato da più di 15 minuti (ultimo dato: {ultimo})",
      gauge_percentuale: "{percentuale}% della potenza massima ({massimo})",
      grafico_dc: "Andamento lato DC",
      grafico_energia: "Andamento energia",
      grafico_potenza: "Andamento potenza",
      grafico_potenza_impianto: "Potenza di impianto",
      in_allarme: "In allarme",
      motivo_modello_ambiguo: "il modello corrisponde a più marche e nessuna coincide con quella dell'inverter",
      motivo_modello_assente: "l'inverter non ha un modello impostato",
      motivo_modello_non_trovato: "nessun modello anagrafico corrisponde a questo inverter",
      motivo_modello_senza_potenza: "il modello anagrafico non ha una potenza AC massima impostata",
      online: "Online",
      periodo_giorno: "Giorno",
      periodo_settimana: "Settimana",
      periodo_mese: "Mese",
      picco_oggi: "Picco di oggi",
      picco_periodo: "Picco del periodo",
      potenza_ac: "Potenza AC",
      potenza_attuale: "Potenza attuale",
      potenza_dc: "Potenza DC",
      riepilogo_giornata: "Riepilogo della giornata",
      serie_troncata: "Serie troncata: sono mostrati solo i primi punti del periodo selezionato",
      tensione_dc: "Tensione DC",
      ultimo_aggiornamento: "Ultimo aggiornamento",
    },
    inverter_granularita: {
      raw: "Dati grezzi",
      quindici_minuti: "15 minuti",
      giornaliera: "Giornaliera",
    },
    inverter_status: {
      run: "In produzione",
      off: "Spento",
      nd: "N/D",
    },
  },
  en: {
    menu_tabs: {
      panoramica: "Overview",
      dispositivi: "Devices",
      area_tecnica: "Technical Area",
      anagrafica: "Plant Record"
    },
    tracker_feedback: {
      titolo: "Tracker feedback",
      colonna: {
        tracker: "Tracker",
        id_device: "Device ID",
        esito: "Result",
      },
      esito: {
        ok: "OK",
        timeout: "Timeout",
        refused: "Refused",
        attesa: "Pending",
      },
    },
    operation: "Operation",
    menu_strumenti_log_config_tracker: "Configuration log",
    log_config_tracker: {
      statistiche: "Statistics",
      colonna: {
        createdAt: "Sent at",
        impianto: "Plant",
        utente: "User",
        dst: "Recipients",
        tracker_count: "Tracker count",
        ack_status: "Ack status",
        latency: "Ack latency",
        request_id: "Request ID",
        azioni: "Actions",
        operation: "Operation",
      },
      filtro: {
        titolo: "Filters",
        periodo: "Period",
        impianto: "Plant",
        utente: "User",
        dst: "Recipients",
        status: "Ack status",
        request_id: "Request ID",
        attesa_oltre: "Pending for more than (min)",
      },
      dst: {
        tutti: "All",
        selezione: "Selection",
      },
      status: {
        ok: "OK",
        error: "Error",
        pending: "Pending",
        attesa_da: "Pending for {min}m",
      },
      button: {
        confronta: "Compare",
        reset_filtri: "Reset filters",
      },
      tooltip: {
        confronta_disabled: "Select exactly 2 rows to compare",
      },
      toast: {
        errore_caricamento: "Error loading configuration log",
      },
      stats: {
        totale: "Total pushes",
        per_status: "By ack status",
        top_impianti: "Top plants",
        periodo: "All time",
        top_comandi: "Top commands",
      },
      titolo_confronto: "Configuration comparison",
      confronto: {
        label_a: "Config A",
        label_b: "Config B",
        chiave: "Key",
        campo: "Field",
        config_differenti: "Config differences",
        scalar_differenti: "Field differences",
        nessuna_differenza_config: "No differences in the pushed configuration",
        nessuna_differenza_scalare: "No field differences",
        solo_in_a: "Only in A",
        solo_in_b: "Only in B",
        comuni: "Common",
        changed: "Changed",
        tracker_target: "Target trackers",
        esiti_per_quadro: "Results per board",
      },
      titolo_dettaglio: "Configuration push detail",
      dettaglio: {
        informazioni_generali: "General information",
        config_inviata: "Pushed configuration",
        tracker_destinatari: "Target trackers",
        matrice_quadri: "Results per board",
        json_grezzi: "Raw data",
      },
      operation: {
        push: "Push",
      },
    },
    ultimo_comando_remoto: "Last remote command",
    feedback_ultimo_comando_remoto: "Feedback on last remote command",
    impianto: "Plant",
    attivazione_licenza: "License activation",
    scadenza_licenza: "License expiry",
    elenco_impianti_associati: "Associated plants",
    utente_nome: "User",
    tracker_count: "Tracker",
    request_id: "Request Id",
    mostra_dettagli: "View details",
    codice_univoco: "Unique code",
    archivio_elimina_selezionati: "Delete selected",
    menu_strumenti_archivio: "Archive",
    attuale: "Current",
    completato: "Completed",
    passo: "Step",
    versioni_firmware: "Firmware versions",
    impianti: {
      scegli_versione_fw: "Choose firmware version",
      versione_firmware: "Firmware version",
    },
    comandi_manuali: {
      wizard: {
        step_impianto: "Select Plant",
        placeholder_impianto: "Choose a plant...",
        step_mode: "Operating Mode",
        step_target: "Set Target Angle",
        range_target: "Value must be between -55° and +55°",
        step_destinatari: "Select Recipients",
        tutti_tracker: "All trackers in the plant",
        lista_tracker: "Select specific trackers",
        carica_da_gruppo: "Load from a preset group...",
        filtro_tracker: "Filter trackers by name or ID...",
        step_riepilogo: "Command Summary",
        modalita_compatta: "Compact mode",
        modalita_guidata: "Guided",
        modalita_expert: "Expert",
        lista_sub: "Pick individual trackers or load a group",
        selezionati: "selected",
      },
      toolbar: {
        titolo: "Device control",
        tracker_disponibili: "trackers available",
        tracker_lower: "trackers",
        pannello_completo: "Full panel",
        preset_rapidi: "Quick presets",
        stop_tutti: "Stop all",
        auto_tutti: "Auto all",
        manuale: "Manual",
        preset_orizzontale: "Horizontal (0°)",
        preset_est: "(east)",
        preset_ovest: "(west)",
        angolo_personalizzato: "Custom angle…",
        gruppi_salvati: "Saved groups",
        apri_per_gruppo: "Open the panel with this group preselected",
        invio_rapido: "Quick send",
        azione: "Action",
      },
      mode: {
        stop: "STOP",
        stop_desc: "Immediately stop tracker movement",
        manual: "Manual",
        manual_desc: "Move trackers to a specific target angle",
        auto: "Automatic",
        auto_desc: "Restore automatic solar tracking",
      },
      col: {
        nome: "Tracker Name",
        id_device: "Device ID",
      },
      label: {
        impianto: "Plant",
        mode: "Mode",
        target: "Target Angle",
        destinatari: "Recipients",
      },
      button: {
        conferma_invia: "Confirm & Send",
      },
      confirm: {
        titolo: "Warning: Send Command",
        warning_movimento:
          "You are about to send a manual command that will move physical devices. Please ensure there are no ongoing maintenance operations.",
        riepilogo:
          "Send {mode} mode{target} to {n} devices on plant '{impianto}'.",
      },
      await: {
        titolo: "Pending commands",
        tracker_inviati: "Trackers sent",
        tracker_non_raggiunti: "Unreachable trackers",
        risposte_ricevute: "Responses received",
        in_attesa: "Waiting for response...",
        in_attesa_breve: "waiting",
        quadro: "Cabinet",
      },
      dialog: {
        nessun_comando_attivo: "No active command",
        nessun_comando_attivo_sottotitolo:
          "Commands sent to trackers will appear here while awaiting confirmation.",
        sessioni_attive: "Active sessions",
        pulisci_completati: "Clear completed",
        rimuovi_comando: "Remove command",
      },
      pill: {
        in_attesa: "Commands running",
        tutti_completati: "All completed",
        quadri: "cabinets",
        sessioni: "sessions",
        trascina: "Drag to move",
        espandi: "Expand window",
      },
      session: {
        completata: "Session completed",
        in_corso: "Session in progress",
        completata_label: "Completed",
        live: "Live",
        comando: "Command",
        progresso_quadri: "Cabinets progress",
        quadri_attesi: "Awaiting cabinets",
        tracker_anonimo: "Tracker",
        senza_risposta_label: "No response",
      },
      descrizione: {
        stop: "Stop · {n} trackers",
        manual: "Manual {target}° · {n} trackers",
        auto: "Auto · {n} trackers",
        generico: "Command · {n} trackers",
      },
    },
    log_comandi_manuali: {
      titolo_dettaglio: "Command Detail",
      titolo_confronto: "Command Comparison",
      tooltip: {
        confronta_disabled: "Select exactly 2 commands to compare",
      },
      button: {
        confronta: "Compare",
        reset_filtri: "Reset filters",
      },
      toast: {
        errore_caricamento: "Error loading commands",
      },
      filtro: {
        titolo: "Filters",
        impianto: "Plant",
        utente: "User",
        mode: "Mode",
        status: "Status",
        periodo: "Period",
        target_min: "Min target (°)",
        target_max: "Max target (°)",
        request_id: "Request ID",
        attesa_oltre: "Pending over (min)",
      },
      colonna: {
        createdAt: "Sent at",
        impianto: "Plant",
        utente: "User",
        mode: "Mode",
        target: "Target",
        tracker_count: "Trackers",
        response_status: "Response status",
        latency: "Latency",
        request_id: "Request ID",
        azioni: "Actions",
        quadro: "Control unit",
        tracker_richiesti: "Requested trackers",
        esito_invio: "Send result",
        ack_status: "ACK status",
        ack_at: "ACK received",
        errore: "Error",
      },
      mode: {
        stop: "Stop",
        manual: "Manual",
        auto: "Auto",
      },
      status: {
        ok: "OK",
        error: "Error",
        pending: "Pending",
        attesa_da: "Pending {min}m",
        no_response: "No response",
        offline: "Offline",
      },
      dst_all: {
        tutti: "All",
        selezione: "Selection",
      },
      stats: {
        totale: "Total commands",
        per_mode: "By mode",
        per_status: "By status",
        top_impianti: "Top plants",
        periodo: "All periods",
      },
      dettaglio: {
        informazioni_generali: "General information",
        matrice_quadri: "Control units / results matrix",
        timeline_ack: "ACK timeline",
        json_grezzi: "Raw JSON",
        errore_globale: "Global error",
        nessuna_risposta: "No response received",
        evento_invio_label: "Command sent",
        delta_dopo_invio: "after send",
      },
      confronto: {
        riepilogo: "Summary",
        scalar_differenti: "Different scalar fields",
        tracker_richiesti: "Requested trackers",
        esiti_per_quadro: "Results by control unit",
        risposte_quadri: "Control unit responses",
        campo: "Field",
        label_a: "Command A",
        label_b: "Command B",
        nessuna_differenza_scalare: "No differences in scalar fields",
        solo_in_a: "Only in A",
        solo_in_b: "Only in B",
        comuni: "Common",
        changed: "Changed",
      },
      statistiche: "Statistics",
    },
    trackers: {
      config: {
        error: {
          payload_invalido: "Invalid payload",
          permesso_negato: "Permission denied",
          tracker_non_appartiene_impianto:
            "The tracker does not belong to the selected plant",
          config_invalida: "Invalid configuration",
        },
      },
      send_manual_cmd: {
        error: {
          payload_invalido: "Invalid payload",
          target_fuori_range: "Target value out of range",
          permesso_negato: "Permission denied",
          tracker_non_appartiene_impianto:
            "The tracker does not belong to the selected plant",
          request_id_esauriti:
            "Too many pending commands on this plant: try again in a minute",
        },
        toast: {
          socket_non_connesso: "Socket not connected. Unable to send command.",
          tracker_non_raggiunti:
            "Some trackers did not respond to the command. Check the status of the trackers and try again.",
        },
        socket_non_connesso: "Socket not connected. Unable to send command.",
        tracker_non_raggiunti:
          "Some trackers did not respond to the command. Check the status of the trackers and try again.",
        inviato: "Command sent successfully",
        pill: {
          descrizione: "{n} panels awaiting response",
        },
      },
    },
    tracker_config: {
      gruppo: {
        batteria: "Battery",
        vento: "Wind",
        angoli: "Angles",
        mesh: "Mesh",
      },
      enum: {
        abilitato: "Enabled",
        disabilitato: "Disabled",
        est: "East",
        ovest: "West",
        segno_neg: "Negative (-1)",
        segno_pos: "Positive (+1)",
      },
      campo: {
        currentThreshold: {
          label: "Motor alarm current threshold",
          desc: "Current threshold for the motor overcurrent alarm.",
        },
        trackerSide: {
          label: "Controller side",
          desc: "Tracker controller side (east/west).",
        },
        socLow: {
          label: "Battery alarm threshold",
          desc: "Battery state-of-charge alarm threshold.",
        },
        socHigh: {
          label: "Battery recovery threshold",
          desc: "Recovery threshold for the battery float alarm.",
        },
        powerGood: {
          label: "Power good",
          desc: "Panel power stability time.",
        },
        maxChargerCurrent: {
          label: "Max charger current",
          desc: "Maximum charger current threshold.",
        },
        windSpeedEn: {
          label: "Wind speed sensor",
          desc: "Enable the wind speed sensor.",
        },
        windDirEn: {
          label: "Wind direction sensor",
          desc: "Enable the wind direction sensor.",
        },
        windSpeedAdd: {
          label: "Speed sensor address",
          desc: "Modbus address of the wind speed sensor.",
        },
        windDirAdd: {
          label: "Direction sensor address",
          desc: "Modbus address of the wind direction sensor.",
        },
        windDirOffset: {
          label: "Wind direction offset",
          desc: "Wind direction sensor offset (degrees ×10, from 0.0 to 360.0).",
        },
        windThresholdOffset: {
          label: "Wind threshold offset",
          desc: "Offset applied to the wind alarm threshold.",
        },
        eastAngleSign: {
          label: "East angle sign",
          desc: "Sign of the east-side angles (-1 or +1).",
        },
        angleLower: {
          label: "Minimum angle",
          desc: "Minimum tracker movement angle.",
        },
        angleUpper: {
          label: "Maximum angle",
          desc: "Maximum tracker movement angle.",
        },
        motorPhase: {
          label: "Motor phase",
          desc: "Motor phase (east/west).",
        },
        meshId: {
          label: "Mesh ID",
          desc: "Alphanumeric mesh identifier.",
        },
        windSpeedMeanT: {
          label: "Wind sampling period",
          desc: "Sampling period for the wind measurement.",
        },
        missingWeatherTime: {
          label: "Weather station timeout",
          desc: "Tolerance time for a missing weather station.",
        },
        meshDownTime: {
          label: "Mesh timeout",
          desc: "Tolerance time for missing mesh communication.",
        },
        PowerFromPanel: {
          label: "Enable MPPT",
          desc: "Power from the solar panel (MPPT) instead of the mains.",
        },
      },
      invia: {
        corrente: "Send to this",
        gruppo: "Send to group",
        tutti: "Send to all",
      },
      gruppo_dialog: {
        titolo: "Select target trackers",
      },
      modifiche_conteggio: "{n} unsent changes",
      nessuna_modifica: "No changes",
      reset_tutto: "Reset all",
      contesto: {
        tracker: "Tracker",
      },
      errore: {
        tracker_non_trovato: "Tracker not found",
        titolo: "Unable to load configuration",
        richiesta_fallita: "Configuration request failed.",
        tracker_non_raggiunto: "The tracker is unreachable.",
        nessuna_risposta: "No response from the tracker. Try again.",
      },
      toast: {
        inviato: "Configuration sent successfully!",
        ack_errore: "The tracker reported a configuration error.",
        nessun_invio: "No tracker reached: configuration not sent.",
      },
      confirm: {
        titolo: "Confirm configuration send",
        messaggio:
          "You are about to send {n} changes to {dest} devices. Confirm?",
      },
      session: {
        titolo: "Tracker configuration session",
        destinatari: "Recipients",
        progresso: "Progress",
        campi_modificati: "Modified fields",
        campi_conteggio: "{n} fields",
        errore_label: "Error",
      },
      pill: {
        descrizione: "{n} fields to {dest} recipients",
      },
    },
    caricamento: "Loading...",
    menu_versioni_firmware: "Firmware versions",
    menu_strumenti_log_comandi_manuali: "Manual commands log",
    gruppi_tracker: {
      tooltip: {
        elimina_selezionati: "Select a plant first to delete groups",
      },
      placeholder: {
        ricerca: "Search group...",
        scegli_impianto: "Choose a plant",
      },
      label: {
        impianto: "Plant",
        nome: "Group name",
        descrizione: "Description",
        colore: "Color",
        personalizzato: "Custom",
        nessun_gruppo_presente: "No groups available for this plant",

      },
      col: {
        nome: "Name",
        descrizione: "Description",
        num_membri: "Members",
        azioni: "Actions",
        id_device: "Device ID",
      },
      confirm: {
        elimina_titolo: "Confirm deletion",
        elimina_messaggio: 'Are you sure you want to delete group "{nome}"?',
      },
      dialog: {
        titolo_nuovo: "New tracker group",
        titolo_modifica: "Edit tracker group",
      },
      banner: {
        overline: "Group",
        placeholder_nome: "Group name...",
        membri: "Members",
      },
      section: {
        dati: "Group data",
        membri: "Members",
      },
      empty: {
        no_impianto_title: "No plant selected",
        no_impianto_hint: "Select a plant to view available trackers",
      },
      error: {
        nome_richiesto: "Name is required",
        almeno_un_tracker: "Select at least one tracker",
        salvataggio_fallito: "Error saving the group",
        nome_duplicato: "A group with this name already exists",
        payload_invalido: "Invalid payload",
        permesso_negato: "Permission denied",
        tracker_non_appartiene_impianto:
          "One or more trackers do not belong to the selected plant",
        colore_invalido: "Invalid color",
      },
      seleziona_impianto: "Select a plant to view the groups",
    },
    modelli_inverter: {
      tooltip: {
        elimina_selezionati: "Archive selected models",
      },
      placeholder: {
        ricerca: "Search inverter model...",
      },
      label: {
        marca: "Brand",
        modello: "Model",
        potenza_ac_max: "Max AC power",
        mppt_indipendenti: "Independent MPPTs",
        ingressi_per_mppt: "Inputs per MPPT",
        tensione_dc_min: "Min DC voltage",
        tensione_dc_max: "Max DC voltage",
        efficienza_max: "Max efficiency",
        link_produttore: "Manufacturer website link",
        apri_link: "Open product page",
        anteprima_immagine: "Image preview",
      },
      col: {
        marca: "Brand",
        modello: "Model",
        immagine: "Image",
        potenza_ac_max: "Max AC power",
        mppt_indipendenti: "Independent MPPTs",
        ingressi_per_mppt: "Inputs per MPPT",
        tensione_dc_min: "Min DC voltage",
        tensione_dc_max: "Max DC voltage",
        efficienza_max: "Max efficiency",
        link_produttore: "Manufacturer link",
        apri: "Open",
        azioni: "Actions",
      },
      section: {
        dati: "Model data",
        dati_tecnici: "Technical data",
        immagine: "Model image",
      },
      dialog: {
        titolo_nuovo: "New inverter model",
        titolo_modifica: "Edit inverter model",
      },
      confirm: {
        elimina_titolo: "Confirm archiving",
        elimina_messaggio: 'Are you sure you want to archive model "{nome}"?',
      },
      error: {
        nome_richiesto: "Name is required",
        nome_duplicato: "An inverter model with this name already exists",
        modello_duplicato:
          "An inverter model with this brand and model already exists",
        marca_non_valida: "Invalid brand",
        modello_non_valido: "Invalid model",
        potenza_non_valida: "Invalid max AC power",
        mppt_non_valido: "Invalid number of MPPTs/inputs",
        tensione_non_valida:
          "Invalid DC voltage range: the minimum cannot exceed the maximum",
        efficienza_non_valida: "Invalid max efficiency (0-100%)",
        link_non_valido: "Invalid link: it must start with http:// or https://",
        payload_invalido: "Invalid payload",
        permesso_negato: "Permission denied",
        salvataggio_fallito: "Error saving the model",
      },
    },
    utenti_api: {
      placeholder: {
        ricerca: "Search API user...",
      },
      button: {
        kit_integratore: "Integrator kit",
      },
      tooltip: {
        kit_integratore:
          "Download the guide and examples to hand over to the integrator along with the credentials",
      },
      col: {
        nome: "Name",
        username: "Username",
        attivo: "Active",
        permesso_comandi: "Commands",
        impianti: "Plants",
        token_attivi: "Active tokens",
        ultimo_login: "Last login",
        ultimo_cambio_password: "Last password change",
        azioni: "Actions",
      },
      label: {
        nessun_utente: "No API users",
        attivo: "Active",
        disattivo: "Inactive",
        comandi_abilitati: "Commands enabled",
        sola_lettura: "Read only",
        mai: "Never",
        nome: "Name",
        username: "Username",
        password: "Password",
        permesso_comandi: "Allowed to send commands",
        ip_ammessi: "Allowed IPs",
        impianti: "Assigned plants",
      },
      sezione: {
        anagrafica: "Details",
        accesso: "Access",
        impianti: "Plants",
      },
      hint: {
        ip_ammessi:
          "IPv4/IPv6 addresses or CIDR subnets, press Enter to add them. If empty, access is allowed from any IP.",
      },
      dialog: {
        titolo_crea: "New API user",
        titolo_modifica: "Edit API user",
        titolo_password: "API user password",
        avviso_password:
          "Copy the password now: once this window is closed it will no longer be visible.",
      },
      confirm: {
        permesso_comandi_titolo: "Enable commands?",
        permesso_comandi_messaggio:
          "With this permission the API user will be able to send commands that move the trackers of the assigned plants. Continue?",
        rigenera_password_titolo: "Regenerate the password?",
        rigenera_password_messaggio:
          "A new password will be generated for {nome}: the current one will stop working and all active tokens will be revoked.",
        revoca_token_titolo: "Revoke the tokens?",
        revoca_token_messaggio:
          "All active tokens of {nome} will be revoked: the portal will have to log in again.",
        elimina_titolo: "Delete the API user?",
        elimina_messaggio:
          "The API user {nome} will be deleted and their tokens revoked: the portal will no longer be able to access the API.",
        elimina_selezionati_messaggio:
          "The selected API users ({n}) will be deleted and their tokens revoked: the portals will no longer be able to access the API.",
      },
      toast: {
        creato: "API user created",
        aggiornato: "API user updated",
        eliminato: "Deletion completed",
        token_revocati: "Tokens revoked",
        password_copiata: "Password copied to clipboard",
        password_rigenerata: "New password generated",
        copia_non_riuscita: "Copy failed: copy the password manually",
        kit_non_scaricato: "Integrator kit download failed",
      },
      error: {
        payload_invalido: "Invalid data",
        nome_non_valido: "Name is required, up to 255 characters",
        username_non_valido:
          "Username of 3 to 100 characters: letters, digits, dot, hyphen or underscore",
        username_duplicato: "Username already in use",
        ip_non_valido: "Invalid IP address or subnet",
        impianti_non_validi: "One or more plants are not valid",
        utente_non_trovato: "API user not found",
      },
    },
    primevue: {
      accept: "Yes",
      addRule: "Add Rule",
      am: "AM",
      apply: "Apply",
      cancel: "Cancel",
      choose: "Choose",
      chooseDate: "Choose Date",
      chooseMonth: "Choose Month",
      chooseYear: "Choose Year",
      clear: "Clear",
      completed: "Completed",
      contains: "Contains",
      custom: "Custom",
      dateAfter: "Date is after",
      dateBefore: "Date is before",
      dateFormat: "mm/dd/yy",
      dateIs: "Date is",
      dateIsNot: "Date is not",
      dayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      emptyFilterMessage: "No results found",
      emptyMessage: "No available options",
      emptySearchMessage: "No results found",
      emptySelectionMessage: "No selected item",
      endsWith: "Ends with",
      equals: "Equals",
      fileChosenMessage: "{0} files",
      fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      filter: "Filter",
      firstDayOfWeek: 0,
      gt: "Greater than",
      gte: "Greater than or equal to",
      lt: "Less than",
      lte: "Less than or equal to",
      matchAll: "Match All",
      matchAny: "Match Any",
      medium: "Medium",
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthNamesShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      nextDecade: "Next Decade",
      nextHour: "Next Hour",
      nextMinute: "Next Minute",
      nextMonth: "Next Month",
      nextSecond: "Next Second",
      nextYear: "Next Year",
      noFileChosenMessage: "No file chosen",
      noFilter: "No Filter",
      notContains: "Not contains",
      notEquals: "Not equals",
      now: "Now",
      passwordPrompt: "Enter a password",
      pending: "Pending",
      pm: "PM",
      prevDecade: "Previous Decade",
      prevHour: "Previous Hour",
      prevMinute: "Previous Minute",
      prevMonth: "Previous Month",
      prevSecond: "Previous Second",
      prevYear: "Previous Year",
      reject: "No",
      removeRule: "Remove Rule",
      searchMessage: "{0} results are available",
      selectionMessage: "{0} items selected",
      showMonthAfterYear: false,
      startsWith: "Starts with",
      strong: "Strong",
      today: "Today",
      upload: "Upload",
      weak: "Weak",
      weekHeader: "Wk",
      licenze: {
        errors: {
          notifiche_non_consentite_perpetua:
            "Notifications are not allowed for perpetual licenses",
          tipologia_periodo_non_valida: "Invalid period type",
          valore_notifica_non_valido: "Invalid notification value",
          valore_notifica_oltre_limite:
            "Notification value exceeds allowed limit",
          notifiche_duplicate: "Duplicate notifications (period type + value)",
          campi_obbligatori_mancanti: "Required fields are missing",
          durata_mesi_non_valida: "Invalid duration in months",
          chiave_duplicata: "Duplicate value is not allowed",
          id_non_valido: "Invalid ID",
          licenza_non_trovata: "License not found",
        },
      },
      aria: {
        cancelEdit: "Cancel Edit",
        close: "Close",
        collapseLabel: "Collapse",
        collapseRow: "Row Collapsed",
        editRow: "Edit Row",
        expandLabel: "Expand",
        expandRow: "Row Expanded",
        falseLabel: "False",
        filterConstraint: "Filter Constraint",
        filterOperator: "Filter Operator",
        firstPageLabel: "First Page",
        gridView: "Grid View",
        hideFilterMenu: "Hide Filter Menu",
        jumpToPageDropdownLabel: "Jump to Page Dropdown",
        jumpToPageInputLabel: "Jump to Page Input",
        lastPageLabel: "Last Page",
        listLabel: "Option List",
        listView: "List View",
        moveAllToSource: "Move All to Source",
        moveAllToTarget: "Move All to Target",
        moveBottom: "Move Bottom",
        moveDown: "Move Down",
        moveToSource: "Move to Source",
        moveToTarget: "Move to Target",
        moveTop: "Move Top",
        moveUp: "Move Up",
        navigation: "Navigation",
        next: "Next",
        nextPageLabel: "Next Page",
        nullLabel: "Not Selected",
        otpLabel: "Please enter one time password character {0}",
        pageLabel: "Page {page}",
        passwordHide: "Hide Password",
        passwordShow: "Show Password",
        previous: "Previous",
        prevPageLabel: "Previous Page",
        removeLabel: "Remove",
        rotateLeft: "Rotate Left",
        rotateRight: "Rotate Right",
        rowsPerPageLabel: "Rows per page",
        saveEdit: "Save Edit",
        scrollTop: "Scroll Top",
        selectAll: "All items selected",
        selectLabel: "Select",
        selectRow: "Row Selected",
        showFilterMenu: "Show Filter Menu",
        slide: "Slide",
        slideNumber: "{slideNumber}",
        star: "1 star",
        stars: "{star} stars",
        trueLabel: "True",
        unselectAll: "All items unselected",
        unselectLabel: "Unselect",
        unselectRow: "Row Unselected",
        zoomImage: "Zoom Image",
        zoomIn: "Zoom In",
        zoomOut: "Zoom Out",
      },
    },
    mappa: "Map",
    setup_non_trovato: "You do not have any form data saved locally",
    salva_setup_localmente: "Save setup locally",
    aggiornamento_eseguito: "Update completed",
    licenza_aggiornata: "License updated",
    dueeffea_disabilitato_con_successo:
      "Two-factor authentication disabled successfully",
    nessun_elemento_selezionato_per_esportazione:
      "No item selected for export",
    errori: {
      generico: "An error occurred",
      id_mancante: "Missing ID",
      file_mancante: "Missing file",
      versione_mancante: "Missing version",
      firmware_project_name_errato: "The file is not a tracker firmware (project name \"{nome}\", expected \"SolarTracker\")",
      nessun_impianto_selezionato: "Select at least one plant",
      troppi_impianti_selezionati: "Too many plants selected (maximum 500)",
      nessun_firmware_selezionato: "Select at least one firmware",
      parametri_non_validi: "Invalid parameters",
      versione_diversa_da_header: "The given version differs from the one inside the file",
      versione_formato_non_valido: "Invalid version format (expected NN.NN.NN, e.g. 01.01.14)",
      firmware_senza_famiglia_hw: "The firmware has no hardware family (version not in NN.NN.NN format)",
      firmware_famiglia_hw_duplicata: "Only one firmware per hardware family can be assigned",
      formato_non_supportato: "Unsupported file format",
      file_troppo_grande: "File too large",
      versione_gia_esistente: "Firmware version already exists",
      firmware_non_trovato: "Firmware version not found",
      firmware_in_uso: "Cannot delete a firmware version that is in use",
      blob_mancante: "Firmware content not available",
      download_fallito: "Download failed",
      impianto_non_trovato: "Plant not found",
    },
    colori: {
      trasparente: "Transparent",
      bianco: "White",
      grigio_chiaro: "Light grey",
      argento: "Silver",
      marrone: "Brown",
      oro: "Gold",
      giallo: "Yellow",
      lime: "Lime",
      verde: "Green",
      verde_scuro: "Dark green",
      turchese: "Turquoise",
      ciano: "Cyan",
      blu: "Blue",
      blu_scuro: "Dark blue",
      viola: "Purple",
      rosa: "Pink",
      rosso: "Red",
      rosso_scuro: "Dark red",
      arancione: "Orange",
      grigio: "Grey",
    },
    codice_fiscale_non_valido: "Invalid tax code",
    partita_iva_non_valida: "Invalid VAT number",
    inclinazione: "Inclination",
    batteria: "Battery",
    segnale: "Signal",
    versione_software: "Software version",
    versione_hardware: "Hardware version",
    username_gia_esistente_nel_database:
      "Username already exists in the database",
    menu_amministratori: "Administrators",
    menu_aziende: "Companies",
    menu_missioni: "Missions",
    menu_anagrafiche: "Records",
    menu_strumenti_backup: "Backup",
    menu_strumenti_log: "System Log",
    menu_strumenti_manutenzioni: "Maintenance",
    menu_strumenti_statistiche: "Statistics",
    menu_strumenti: "Tools",
    menu_emails_envirologic: "Envirologic Emails",
    menu_evocleaners: "Evocleaners",
    menu_utenti: "Users",
    menu_strumenti_comunicazioni: "Communications",
    menu_proprietario: "Owners",
    menu_impianti: "Plants",
    menu_amministratore: "Admins",
    menu_tecnico: "Technicians",
    menu_licenze: "Licenses",
    menu_cerca_nel_menu: "Search in menu...",
    menu_strumenti_log_connessioni: "Connection logs",
    menu_strumenti_database: "Database",
    menu_centraline_connesse: "Connected units",
    toolbar: {
      contrai_sidebar_tabelle: "Reduce sidebar tables",
      espandi_sidebar_tabelle: "Expand sidebar tables",
    },
    file_drop: {
      rilascia: "Drop the file to upload it",
      un_solo_file: "Drop only one file at a time",
    },
    firmware: {
      comprimi_filtri: "Collapse filters",
      espandi_filtri: "Expand filters",
      impianto: "Plant",
      non_eliminabile:
        "Cannot delete firmware versions that are currently in use",
      slot_famiglia_hw: "Firmware family {famiglia_hw}",
      famiglia_hw: "Hardware family {famiglia_hw}",
      n_tracker_famiglia_hw: "{n} trackers",
      n_allineati: "{allineati}/{totale} up to date",
      aggiornamento_fermo: "Update stalled",
      aggiornato: "Up to date",
      fermo_cause: "Update stalled: the tracker may not be reachable from its mesh parent, or it may have rejected the firmware and gone back to the previous version (tracker rollback). It is not necessarily a fault of the panel.",
      formato_supportato: ".bin files only (max 50MB)",
      trascina_o_clicca: "Drag the file here or click to upload",
      stato_pilota: "In trial",
      stato_rilasciata: "Released",
      famiglia_hw_01: "HW 01",
      famiglia_hw_02: "HW 02",
      famiglia_hw_nd: "HW n/a",
      famiglia_hw_tutte: "All",
      tab_panoramica: "Overview",
      tab_tracker: "Trackers",
      tab_firmware: "Firmware",
      panoramica_vuota: "No trackers with a known firmware version",
      offline_n: "{n} offline",
      tracker_nessuno: "No trackers for the selected filters",
      filtro_stato: "Status",
      raggruppa_per: "Group by",
      raggruppa_impianto: "Plant",
      raggruppa_quadro: "Panel",
      raggruppa_versione: "Version",
      col_tracker: "Tracker",
      col_impianto: "Plant",
      col_quadro: "Panel",
      col_hardware: "Hardware",
      col_versione: "Current version",
      col_target: "Assigned version",
      col_stato: "Status",
      col_ultimo_contatto: "Last contact",
      stato_tracker: {
        bocciato: "Firmware rejected",
        instabile: "Unstable",
        sparito: "Offline after the update",
        allineato: "Up to date",
        da_aggiornare: "To update",
        offline: "Offline",
        senza_target: "No firmware assigned",
        sconosciuto: "Unknown version",
      },
      stato_tracker_hint: {
        bocciato: "The tracker tried this firmware and rejected it: it went back to the previous version (rollback). The firmware probably does not work.",
        instabile: "After the update the tracker restarted several times because of errors (panic or watchdog): the firmware may not work.",
        sparito: "The tracker was responding after the firmware was assigned and is now offline: it may have hung during the update.",
      },
      tracker_bocciati: "Rejected by {n} trackers",
      tracker_instabili: "{n} unstable",
      tracker_spariti: "{n} offline after the update",
      prova_su_impianto: "Try on one plant",
      prova_cerca_impianto: "Search plant",
      prova_nessun_impianto: "No compatible plant",
      prova_avviata: "Firmware assigned to the plant",
      gia_assegnato: "Already assigned",
      impianto_riga_info: "{n} trackers · current {versione}",
      rilascia_a_tutti: "Release to all",
      assegna_a_tutti: "Assign to all",
      rilascia_a_tutti_titolo: "Release version {versione} to all compatible plants?",
      assegna_a_tutti_titolo: "Assign version {versione} to all compatible plants?",
      rilascio_nessuna_prova_completata: "No plant has completed the update with this version yet. Tracker firmware has no rollback: go ahead only if you are sure.",
      rilascio_prove_completate: "Update completed on {n} trial plants out of {tot}.",
      pilota_tooltip: "Still in trial: try it on one plant and, if it works, release it to all",
      rilasciato: "Version released",
      n_sconosciuti: "{n} trackers with unknown version",
      completato_il: "Completed on {data}",
      completato_in: "in {durata}",
      assegna_massa: "Assign to a selection",
      assegna_massa_titolo: "Bulk firmware assignment",
      assegna_massa_sub: "Choose the plants and one or more firmware versions (one per family): only the family of the chosen firmware will change.",
      impianti_label: "Plants",
      firmware_label: "Firmware",
      anteprima: "Preview",
      anteprima_impianti_toccati: "{n} plants affected",
      anteprima_tracker_toccati: "{n} trackers affected",
      anteprima_invariati: "{n} already at the chosen version",
      anteprima_nessuna_modifica: "No changes to apply",
      cambio_firmware: "Family {famiglia_hw}: {da} → {a} ({n} trackers)",
      nessun_firmware_attuale: "none",
      applica: "Apply",
      assegnazione_massa_ok: "Firmware assigned",
      aggiungi_famiglia_hw: "Add firmware of another family",
      versione_da_header: "Version read from the file",
      avviso_famiglia_hw_senza_fw: "The plant has {n} trackers of family {famiglia_hw}: assign a {famiglia_hw} firmware",
      avviso_famiglia_hw_senza_tracker: "No trackers of family {famiglia_hw} in the plant: this firmware will never be used",
      avviso_famiglia_hw_flash: "Version family {famiglia_hw} does not match the file flash size (family {flash}): check the version",
      avviso_header_non_riconosciuto: "File header not recognised: cannot verify version and family",
      avanzamento: "Progress",
      tracker_da_aggiornare: "{n} to update",
      tracker_offline: "{n} offline",
      impianti_fermi: "{n} stalled",
      aggiornamento_fermo_tooltip: "Plants with online trackers not aligned for more than {ore} hours since assignment",
      tracker_parent_diverso: "{n} with parent of another family",
      parent_diverso_tooltip: "The tracker asks its mesh parent for the update, but the parent has a different hardware family: it will never update",
      upload_ok: "Firmware version uploaded successfully",
      eliminato: "Deleted",
      eliminati_n: "Deleted",
      elimina_in_uso_lista:
        "Cannot delete firmware versions that are currently in use",
      conferma_elimina_selezionati:
        "Are you sure you want to delete the selected firmware versions?",
      conferma_elimina:
        "Are you sure you want to delete this firmware version?",
      carica_titolo: "Upload firmware version",
      versione: "Version",
      descrizione: "Description",
      file: "File",
      empty_iniziale: "No firmware versions uploaded yet",
      carica_primo: "Upload the first firmware version to get started",
      empty_filtrato: "No firmware versions found with the applied filters",
      reset_filtri: "Reset filters",
      metadati: "Metadata",
      impianti_associati: "Associated plants",
      timeline_assegnazione: "Assignment timeline",
      timeline_vuota: "No assignments available",
      data_da: "Date from",
      data_a: "Date to",
      nessuna_versione_trovata: "No versions found",
      dimensione: "Size",
      caricato_il: "Uploaded on",
      caricato_da: "Uploaded by",
      scarica: "Download",
      solo_in_uso: "In use only",
      solo_non_in_uso: "Not in use only",
      filtro_in_uso: "Filter by usage",
      impianti: "Plants",
      risultato: "Result",
      risultati: "Results",
    },
    database_console: {
      export_troncato:
        "Export truncated: only the first {n} rows were exported",
      blocco_sola_lettura:
        "Read-only mode is active: write queries are blocked",
      indici: "Indexes",
      recenti: "Recent queries",
      preferiti: "Favorites",
      usa: "Use",
      ordine_non_stabile:
        "Order is not stable: results may differ between executions",
      nessuno: "None",
      salva_preferito: "Save current query to favorites",
      nome_preferito: "Favorite name",
      struttura: "Table structure",
      tabelle: "Tables",
      cerca_tabella: "Search table...",
      nessuna_tabella: "No table found",
      nessun_risultato: "No results",
      editor_placeholder: "Write your SQL query here...",
      scorciatoia_esegui: "Ctrl/Cmd + Enter to run",
      errore_query: "Error running the query",
      righe_restituite: "{n} rows returned",
      righe_interessate: "{n} rows affected",
      istruzioni:
        "Select a table or write an SQL query and press Run to see the results.",
      colonne: "Columns",
      tipo: "Type",
      copia_cella: "Copy value",
      cella_copiata: "Value copied to clipboard",
      copia_riga: "Copy row (JSON)",
      riga_copiata: "Row copied to clipboard",
      conferma_write: "This query modifies data. Do you want to run it?",
      conferma_write_senza_where:
        "WARNING: UPDATE/DELETE without WHERE clause — ALL rows will be affected. Run anyway?",
      chiave_primaria: "Primary key",
      colonna: "Column",
      conferma_ddl: "Confirm execution of this DDL command?",
      default_col: "Default",
      esegui_select: "Run SELECT",
      nullable: "Nullable",
      per_eseguire: "to run",
      pk_fk: "PK / FK",
      righe_stimate: "Estimated rows",
      sola_lettura: "Read only",
      sola_lettura_tooltip: "Read-only mode: only SELECT queries are allowed.",
      stringa_vuota: "(empty string)",
      svuota_recenti: "Clear recent",
      timeout_hint: "The query exceeded the maximum execution time.",
      troncato: "Result truncated",
    },
    menu_recenti: "Recent",
    impianto_gia_associato_dal_proprietario:
      "This plant has already been associated by the owner. Contact support for assistance.",
    licenze: {
      archiviazione: {
        tutte_con_impianti:
          "No license can be archived: all the selected ones have associated plants",
        alcune_con_impianti:
          "Some selected licenses have associated plants and will not be archived",
      },
      errors: {
        id_non_valido: "Invalid license ID",
        licenza_non_trovata: "License not found",
        campi_obbligatori_mancanti: "Missing required fields",
        durata_mesi_non_valida: "Invalid duration in months",
        tipologia_periodo_non_valida: "Invalid period type",
        chiave_duplicata: "A license with this key already exists",
        notifiche_duplicate: "Duplicate notifications found",
        notifiche_non_consentite_perpetua:
          "Expiration notifications are not allowed on perpetual licenses",
        valore_notifica_non_valido: "Invalid notification value",
        valore_notifica_oltre_limite:
          "The notification value exceeds the license duration",
        destinatari_amministrazione_non_configurati:
          "Administration recipients are not configured",
        cambio_tipologia_con_associazioni_non_consentito:
          "Cannot change the type: the license has associated plants",
      },
      notifiche_scadenza: "License expiration notifications",
      note: "Note",
      inserisci_durata: "Enter duration in months",
      durata_mesi: "Duration (months)",
      tipo: "Type",
      nome_licenza: "License name",
      notifica_amministrazione: "Notify administration",
      invia_preavviso: "Send pre-expiration notice",
      tipologia_periodo: "Periodicity of notifications",
      riepilogo: "Summary",
      aggiungi_notifica: "Add notification",
      auto_fix_notifiche:
        "Automatically fix out-of-range notifications on save.",
      filtro: {
        periodo: "Period",
        tipo: "Type",
        durata_min: "Minimum duration",
        durata_max: "Maximum duration",
        reset: "Reset",
      },
      impianti_associati: "Associated plants",
    },
    detail: {
      creazione_eseguita: "Creation completed successfully!",
      modifica_eseguita: "Modification completed successfully!",
      aggiornamento_eseguito: "Update completed successfully!",
      manca_id_elemento: "Element ID is missing",
      nessun_elemento_selezionato_per_esportazione:
        "No items selected for export",
    },
    button: {
      esporta: "Export",
      repeater: "Repeater",
      esegui: "Run",
      modifica: "Edit",
      tabella: "Table",
      ricarica: "Reload",
      reset_filtri: "Reset filters",
      elimina_selezionati: "Delete selected",
      crea_backup: "Create backup",
      elimina: "Delete",
      annulla: "Cancel",
      scarica: "Download",
      aggiorna_tabella: "Update table",
      aggiorna: "Update",
      pagina: "Page",
      conferma: "Confirm",
      crea: "Create",
      imposta_logo_azienda: "Set company logo",
      rimuovi: "Remove",
      avanti: "Next",
      indietro: "Back",
      genera_password: "Generate password",
      cambia_password: "Change password",
      ricalcola_coordinate: "Recalculate coordinates",
      calcola_coordinate: "Calculate coordinates",
      mostra_dettagli: "Show details",
      salva: "Save",
      ripristina: "Restore",
      riprova: "Retry",
      invia: "Send",
      importa: "Import",
      chiudi: "Close",
      visualizza: "View",
      aggiungi_nodo: "Add node",
      aggiungi_kml: "Manage KML File",
      anemometro: "Anemometer",
      direzionevento: "Wind direction",
      importa_csv: "Import CSV",
      inverter: "Inverter",
      meteo: "Weather station",
      tracker_meteo: "Weather Tracker",
      quadro: "Switchboard",
      ripristina_vista: "Reset view",
      tracker: "Tracker",
      vela: "Sail",
      vento: "Wind",
      elimina_quadro: "Delete switchboard",
      modifica_credenziali: "Edit credentials",
      no_grazie: "No thanks",
      attiva_tema_scuro: "Enable dark theme",
      tutti: "All",
      nessuno: "None",
      nuovo: "New",
    },
    label: {
      seleziona_quadro: "Seleziona quadro",
      dettagli: "Dettagli",
      direzionevento: "Vento",
      anemometro: "Anemometro",
      dispositivo: "Dispositivo",
      inverter: "Inverter",
      tipo: "Tipo",
      vela: "Vela",
      gruppo: "Gruppo",
      tracker: "Tracker",
      adatta_vista: "Fit view",
      totale_elementi: "Totale elementi",
      tracker_associati: "Tracker associati",
      azioni: "Azioni",
      dettagli_vela: "Dettagli Vela",
      altezza: "Height",
      caricamento: "Loading...",
      codice_locale: "Local code",
      codice_locale_auto: "Local code will be generated automatically",
      conn_type: "Connection type",
      distanza: "Distance",
      filtra_componenti: "Filter components",
      filtri_tipo: "Type filters",
      id_device: "Device ID",
      id_mac_device: "Device MAC",
      impianto: "Plant",
      larghezza: "Width",
      latitudine: "Latitude",
      longitudine: "Longitude",
      lunghezza: "Length",
      marca: "Brand",
      misure_vela: "Sail dimensions",
      modello: "Model",
      nome: "Name",
      nome_inverter: "Inverter name",
      nome_tracker: "Tracker name",
      nome_vela: "Sail name",
      offset_direzione: "Direction offset",
      reset_vista: "Reset view",
      righe_visualizzate: "Rows shown",
      type_code: "Node type",
      unita_misura: "Unit of measure",
      vela_collegata: "Linked sail",
      velocita_max: "Max speed",
      zoom_in: "Zoom in",
      zoom_out: "Zoom out",
      titolo_scada: "SCADA Telemetry",
      placeholder_filtra_componenti: "Search Tracker, Inverter, Weather...",
      placeholder_tutti_tipi: "All types",
      totale_tracker_help: "Total trackers/sails in the current dataset.",
      righe_help: "Number of rows used to visually layout sails on the map.",
      colonne_help:
        "Number of columns calculated automatically from total trackers and requested rows.",
      totale_abbr: "Tot",
      righe_abbr: "R",
      colonne_abbr: "C",
      tipo_hardware: "Hardware type",
      // Modifiche xxx
      vers_so: "Operating System Version",
      vers_app: "Application Version",
      // FINE - Modifiche xxx
      username_quadro: "Switchboard username",
      crea_nodo: "Create node",
      misure: "Dimensions",
      device_id: "Device ID",
      stato: "Status",
      id_sensore: "Sensor ID",
      gruppo_inverter: "Inverter group",
      stazione_meteo: "Weather Station",
      direzione_vento: "Wind Direction",
      motore: "Motor",
      vela_default: "Sail",
      quadro_default: "Switchboard",
      password_quadro: "Switchboard password",
      password_nascosta: "•••••••• (hidden)",
      password_lascia_vuoto: "Leave blank to keep current",
      id: "ID",
      nessun_dato: "No data",
      repeater: "Repeater",
    },
    tracker_status_cf: {
      ok: "OK",
      timeout: "Timeout",
      offline: "Offline",
      nd: "N/A",
      refused: "Refused",
    },
    tracker_status: {
      ok: "Online",
      allarme: "Alarm",
      offline: "Offline",
      nd: "N/A",
    },
    tracker_mode: {
      stop: "Stop",
      manual: "Manual",
      auto: "Auto",
      local: "Local",
      emergency: "Emergency",
      safety: "Safety",
    },
    weather_code: {
      sereno: "Clear sky",
      prevalentemente_sereno: "Mainly clear",
      parzialmente_nuvoloso: "Partly cloudy",
      coperto: "Overcast",
      nebbia: "Fog",
      nebbia_con_brina: "Depositing rime fog",
      pioggerella_leggera: "Light drizzle",
      pioggerella_moderata: "Moderate drizzle",
      pioggerella_intensa: "Dense drizzle",
      pioggerella_gelata_leggera: "Light freezing drizzle",
      pioggerella_gelata_intensa: "Dense freezing drizzle",
      pioggia_leggera: "Slight rain",
      pioggia_moderata: "Moderate rain",
      pioggia_intensa: "Heavy rain",
      pioggia_gelata_leggera: "Light freezing rain",
      pioggia_gelata_intensa: "Heavy freezing rain",
      neve_leggera: "Slight snow fall",
      neve_moderata: "Moderate snow fall",
      neve_intensa: "Heavy snow fall",
      granelli_di_neve: "Snow grains",
      rovesci_leggeri: "Slight rain showers",
      rovesci_moderati: "Moderate rain showers",
      rovesci_violenti: "Violent rain showers",
      rovesci_di_neve_leggeri: "Slight snow showers",
      rovesci_di_neve_intensi: "Heavy snow showers",
      temporale: "Thunderstorm",
      temporale_con_grandine_leggera: "Thunderstorm with slight hail",
      temporale_con_grandine_intensa: "Thunderstorm with heavy hail",
      ignoto: "Unknown",
    },
    dashboard: {
      layout_solo_lista: "List only",
      layout_diviso: "Split view",
      layout_solo_mappa: "Map only",
      dispositivi_totali: "Total devices",
      comandi_manuali: "Manual commands",
      analisi_tracker_raw_label: "RAW 1:1",
      legenda_stato_tracker: "Status",
      legenda_modalita_tracker: "Mode",
      legenda_vento: "Wind",
      nessun_impianto_trovato: "No plants found",
      cerca_impianto: "Search plant...",
      wind_threshold_tooltip_0: "No wind alarm detected on the plant",
      modalita_selezionate: "Selected modes",
      trackers: "Trackers",
      angolo_attuale: "Current angle",
      angolo_target: "Target angle",
      cerca_tracker: "Search tracker...",
      filtra_stato: "Filter by status",
      filtra_modalita: "Filter by mode",
      stati_selezionati: "{0} statuses selected",
      filtri: "Filters",
      ordina: "Sort",
      ordina_per: "Sort by",
      crescente: "Ascending",
      decrescente: "Descending",
      dispositivi_trovati: "devices found",
      tipologia_filtro: "Filter by tracker type",
      non_root: "Non-root",
      root_tutti: "All",
      aggiornato_alle: "Updated at",
      stato_generale: "Overall status",
      tracker_totali: "Total trackers",
      inverter_totali: "Total inverters",
      batteria_media: "Average battery",
      mappa_dispositivi: "Device map",
      rete_mesh: "Mesh network",
      nodi: "Nodes",
      modalita: "Mode",
      dispositivi: "Devices",
      in_arrivo: "Coming soon",
      impianto: "Plant",
      impianti: "Plants",
      health: {
        ok: "All good",
        attenzione: "Needs attention",
        offline: "Plant offline",
        nd: "Status unavailable",
        online: "Plant online",
      },
      root: "Root",
      analisi_tracker: "Tracker analysis",
      tipologia_tracker: "Tracker type",
      ultime_24h: "Last 24 hours",
      caricamento: "Loading...",
      inclinazione_reale: "Actual angle",
      inclinazione_teorica: "Target angle",
      inclinazione_reale_min: "Minimum actual angle",
      inclinazione_reale_max: "Maximum actual angle",
      inclinazione_teorica_min: "Minimum target angle",
      inclinazione_teorica_max: "Maximum target angle",
      banda_min_max_hint: "Band = min/max range within the bucket",
      escursione_label: "Range",
      analisi_tracker_raw_hint: "1 point per DB row, no buckets",
      analisi_tracker_raw_tooltip_enable:
        "Enable RAW 1:1 mode: the chart uses 1 point for each tracker_telemetry row. Available only up to 7 selected days.",
      analisi_tracker_raw_tooltip_active:
        "RAW 1:1 mode is active: the chart uses 1 point for each tracker_telemetry row.",
      analisi_tracker_raw_tooltip_disabled:
        "RAW 1:1 is available only up to 7 selected days.",
      analisi_tracker_help_title: "How to read this chart",
      analisi_tracker_help_intro:
        "The chart automatically adapts its resolution to the selected period to stay navigable. For angles, the main line shows the latest available value in the bucket, while the band highlights the real min/max range within the same interval.",
      analisi_tracker_help_current_bucket: "Current bucket",
      analisi_tracker_help_resolution_title: "Automatic resolution",
      analisi_tracker_help_rule_5m:
        "For ranges up to 1 day, the chart uses 5-minute buckets: this is the most detailed available view and stays closest to the raw signal.",
      analisi_tracker_help_rule_1h:
        "For ranges up to 7 days, the chart groups data into 1-hour buckets to remain readable without losing the main peaks.",
      analisi_tracker_help_rule_6h:
        "For ranges up to 31 days, the chart uses 6-hour buckets: the line shows the latest value in the bucket, while the band preserves min and max.",
      analisi_tracker_help_rule_1d:
        "Beyond 31 days, the chart uses daily buckets to keep loading time and navigation stable.",
      analisi_tracker_help_reading_title: "How to interpret the series",
      analisi_tracker_help_line:
        "The actual and target angle lines show the latest available value in the selected bucket. If the backend does not provide it yet, the average is used as a fallback.",
      analisi_tracker_help_band:
        "The colored band around the lines shows the minimum/maximum range recorded inside the bucket: it prevents short but meaningful movements from disappearing.",
      analisi_tracker_help_health:
        "Battery and signal remain bucket-aggregated average series: they are useful for the overall trend, not for analyzing very short spikes.",
      analisi_tracker_help_events:
        "The dashed vertical lines mark tracker events within the selected period and help connect behavior changes to the operating context.",
      analisi_tracker_help_raw_mode:
        "When RAW 1:1 is enabled, the chart ignores buckets and uses one point for every tracker_telemetry row. It is more faithful, but heavier, so it is available only up to 7 selected days.",
      analisi_tracker_help_eventi_title: "Chart events",
      analisi_tracker_help_eventi_intro:
        "Shown for periods up to 7 days. Hover a line to see details and time.",
      evento_tracker_mode_change: "Mode change",
      evento_tracker_mode_change_help:
        "The tracker switched to another mode (Stop, Manual, Auto, Local, Emergency, Safety).",
      evento_tracker_cr_change: "Command change",
      evento_tracker_cr_change_help:
        "The tracker took a new command from the platform (Stop, Manual, Auto or Configuration) or cleared the last one.",
      evento_tracker_reset: "Tracker restart",
      evento_tracker_reset_help:
        "The tracker board restarted: its restart counter increased.",
      evento_tracker_comando_config: "Configuration",
      evento_tracker_contatore_reset: "Total restarts",
      energia_oggi: "Energy today",
      potenza_reale: "Real power",
      nome: "Name",
      stato: "Status",
      inclinazione: "Angle",
      inclinazione_tooltip: "Angle (Actual / Target)",
      standard: "Standard",
      batteria: "Battery",
      segnale: "Signal",
      versione_software: "SW version",
      versione_hardware: "HW version",
      andamento: "Trend",
      modello: "Model",
      energia: "Energy",
      tensione: "Voltage",
      tensione_batteria: "Battery voltage",
      reset_counter: "Reset counter",
      motivo_cambio_modalita: "Reason for mode change",
      corrente: "Current",
      dettagli: "Details",
      nessun_impianto: "No plants with valid coordinates available.",
      mappa_layer: "Map style",
      mappa_layer_auto: "Auto",
      mappa_layer_stradale: "Street",
      mappa_layer_chiara: "Light",
      mappa_layer_scura: "Dark",
      mappa_layer_satellitare: "Satellite",
      mappa_layer_ibrida: "Hybrid",
      mappa_layer_topografica: "Topographic",
      mappa_layer_terreno: "Terrain",
      mappa_layer_grigi: "Grayscale",
      mappa_layer_umanitaria: "Humanitarian",
      dettagli_tracker: "Tracker details",
      collassa: "Collapse",
      espandi: "Expand",
      kpi: {
        operativita_auto: "Operatività AUTO",
        operativita: "Operability",
        allineamento: "Alignment",
        allineamento_sub_none: "No tracker in AUTO",
        allineamento_sub_count: "{n} tracker in AUTO",
        vento: "Current wind",
        vento_velocita: "Wind speed",
        vento_direzione: "Wind direction",
        tracker_in_stato: "Tracker in stato",
        tracker_in_modalita: "Tracker in modalità",
        provenienza_api: "Data comes from weather web services.",
        provenienza_sensore: "Information transmitted by the plant's sensor.",
        meteo_corrente: "Current weather",
        api_vento: "Wind",
        api_temperatura: "Temperature",
        api_copertura: "Cloud cover",
        api_precipitazioni: "Precipitation",
        api_dettagli_precipitazioni: "Precipitation details",
        api_tempo: "Weather",
        stato_tracker: "Tracker status details",
        modalita_tracker: "Tracker mode details",
        energia: "Energy details",
        tracker: "trackers",
        kwh_oggi: "daily kwh",
        tracker_non_disponibile: "Trackers not available",
        energia_non_disponibile: "Inverters not available",
        storico_resa: "History",
        mappa_impianto: "Plant Map",
        seleziona_vista: "Select View"
      },
      tracker_stato_ignoto: "Unknown",
      modalita_anomale: "Anomalous modes",
      tracker_stato_ignoto_desc_sing:
        "The tracker status is unknown as it has not yet communicated information with the software.",
      tracker_stato_ignoto_desc_plur:
        "The status of the trackers is unknown as they have not yet communicated information with the software.",
      tracker_stato_ok_desc_sing:
        "The status of the tracker is ok.",
      tracker_stato_ok_desc_plur:
        "The status of the trackers is ok.",
      tracker_stato_allarm_desc_sing:
        "The status of the tracker is in alarm.",
      tracker_stato_allarm_desc_plur:
        "The status of the trackers is in alarm.",
      tracker_stato_offline_desc_sing:
        "The status of the tracker is offline.",
      tracker_stato_offline_desc_plur:
        "The status of the trackers is offline.",
      legenda: "Legend",
      wind_desc: "Wind speed detected on the system: ",
      wind_threshold_label_0: "Normal",
      wind_threshold_label_1: "Low",
      wind_threshold_label_2: "Moderate",
      wind_threshold_label_3: "High",
      wind_threshold_tooltip_1: "Low wind alarm detected on the plant",
      wind_threshold_tooltip_2: "Moderate wind alarm detected on the plant",
      wind_threshold_tooltip_3: "High wind alarm detected on the plant",
      tracker_modalita_stop: "Trackers in STOP",
      tracker_modalita_manual: "Trackers in MANUAL",
      tracker_modalita_local: "Trackers in LOCAL",
      tracker_modalita_emergency: "Trackers in EMERGENCY",
      tracker_modalita_safety: "Trackers in SAFETY",
      allarmi_attivi: "Active alarms",
      dati_non_disponibili: "Data not available",
      attiva_analisi_tracker_raw_label: "Enable RAW 1:1",
      disattiva_analisi_tracker_raw_label: "Disable RAW 1:1",
      configurazione_tracker: "Tracker configuration",
      configurazione_tracker_offline: "Cannot configure offline tracker",
      feedback_ultimo_comando_remoto: "Last remote command feedback",
      ultimo_comando_remoto: "Last remote command",
      azioni_non_disponibili_device: "Actions not available for this device",
      online: "Online",
      riepilogo: "Summary",
      tab_dispositivi: "Devices",
      planimetria_3d: "Planimetry 3D",
      layer_meteo: "Weather data",
      non_raggiungibile: "Unreachable",
      no_trackers: "No associated trackers",
      stili_mappa: "Map Styles",
      livelli_aggiuntivi: "Additional Layers",
      intensita_pioggia: "Rain Intensity",
      debole: "Weak",
      grandine: "Hail",
      label_mobile_tot_imp: "Total Systems",
      label_mobile_onl_imp: "Online Systems",
      label_mobile_off_imp: "Offline Systems",
      label_mobile_all_imp: "Alarm Systems",
      show_list: "Show List",
      risultato: "Result",
      risultati: "Results",
      no_impianti: "No plants on thiscategory",
      storicoResa: {
        titolo: "Plant yield history",
        potenzaInstallata: "Installed power",
        potenzaIstantanea: "Current power",
        selezionaPeriodo: "Select period",
        periodi: {
          giornaliero: { "label": "Daily", "breve": "Day", "descrizione": "Today" },
          settimanale: { "label": "Weekly", "breve": "Week", "descrizione": "Last 7 days" },
          mensile: { "label": "Monthly", "breve": "Month", "descrizione": "Current month" },
          annuale: { "label": "Yearly", "breve": "Year", "descrizione": "Current year" },
          totale: { "label": "Total", "breve": "All", "descrizione": "Since commissioning" }
        },
        dalInizio: "Since {data}",
        kpi: {
          energiaProdotta: "Energy produced",
          resaSpecifica: "Specific yield",
          co2Evitata: "CO₂ saved",
          ricavoIncentivo: "Incentive revenue",
          ricavoVendita: "Sales revenue",
          guadagnoTotale: "Total earnings"
        },
        grafico: {
          energiaProdotta: "Energy produced ({unita})",
          ariaLabel: "Energy production chart, {periodo} view"
        },
        stati: {
          vuotoTitolo: "Monitoring data not available yet",
          vuotoDescrizione: "The chart will be populated as soon as the plant's inverters start sending data.",
          erroreTitolo: "Unable to load monitoring data",
          riprova: "Retry"
        },
        nonDisponibile: "N/A",
        nonDisponibileEsteso: "Data not available"
      },
      dispositivi: {
        riepilogo: {
          titolo: "Plant devices",
          stato: "Device status",
          totale: "Total",
          conteggio: "{n} devices | {n} device | {n} devices",
          barraAria: "Devices by status"
        },
        mesh: {
          titolo: "Mesh network",
          dettaglio: "Details",
          topologia: "Topology",
          nodi: "{n} nodes | {n} node | {n} nodes",
          elencoAria: "Mesh network node list",
          topologiaAria: "Mesh network topology",
          legenda: "Status legend",
          comandiGrafico: "Chart controls",
          livello: "level {n}",
          radice: "Plant",
          nonCollegati: "Not connected",
          nascosti: "{n} hidden nodes | {n} hidden node | {n} hidden nodes",
          espandiTutto: "Expand all",
          comprimiTutto: "Collapse all",
          espandiRamo: "Expand branch",
          comprimiRamo: "Collapse branch",
          riduci: "Zoom out",
          ingrandisci: "Zoom in",
          adatta: "Fit to width",
          mostraInTopologia: "Show in topology"
        },
        filtri: {
          tipologia: "Device type",
          modalita: "Tracker mode",
          stato: "Tracker status",
          tutte: "All",
          tutti: "All",
          azzera: "Clear filters"
        },
        comandi: {
          tutti: "Commands for all",
          rapidi: "Quick commands"
        },
        elenco: {
          titolo: "Device list"
        },
        vista: {
          etichetta: "View mode",
          tabella: "Table",
          griglia: "Grid"
        },
        stati: {
          ok: "Online",
          alarm: "In alarm",
          offline: "Offline",
          unknown: "Unknown"
        },
        allarmi: {
          titolo: "Latest alarms",
          ordina: "Sort alarms",
          gravita: "Severity",
          recenti: "Recent",
          nessuno: "No alarms recorded",
          errore: "Unable to load alarms",
          riprova: "Retry",
          vediTutti: "View all ({n})",
          caricamento: "Loading…",
          caricaAltri: "Load more",
          apertoDa: "Aperto da {durata}",
          durata: {
            giorni: "{n} g",
            ore: "{n} h",
            minuti: "{n} min",
            menoDiUnMinuto: "meno di 1 min"
          }
        }
      }
    },
    misura: {
      metri_secondo: "m/s — meters per second",
      km_orari: "km/h — kilometers per hour",
      nodi: "kn — knots",
    },
    message: {
      conferma_elimina_selezionati:
        "Are you sure you want to delete the {count} selected backups?",
      conferma_elimina_backup:
        'Are you sure you want to delete the backup "{nome}"?',
      coordinate_non_trovate: "Coordinates not found for the provided address.",
      coordinate_calcolate: "Coordinates calculated successfully.",
      conferma_chiusura_dialog:
        "Are you sure you want to close this window? Unsaved changes will be lost.",
      id_device_obbligatorio: "Device ID is required",
      type_code_obbligatorio: "Type code is required",
      eliminazione_tipo_nodo_non_disponibile:
        "Delete is not available for this node type",
      conferma_eliminazione_tipo: "Confirm deletion of {tipo}?",
      nodo_creato: "Node created",
      import_mappa_completato: "Map import completed",
      vela_aggiornata: "Sail updated",
      tracker_aggiornato: "Tracker updated",
      inverter_aggiornato: "Inverter updated",
      stazione_meteo_aggiornata: "Weather station updated",
      anemometro_aggiornato: "Anemometer updated",
      direzione_vento_aggiornata: "Wind direction updated",
      entita_eliminata: "{entita} deleted",
      credenziali_quadro_aggiornate: "Switchboard credentials updated",
      username_quadro_obbligatorio:
        "Switchboard username is required (minimum 3 characters)",
      password_quadro_obbligatoria:
        "Switchboard password is invalid (minimum 3 characters)",
      repeater_aggiornato: "Repeater updated",
      import_kml_completato: "Map layer imported successfully"
    },
    menu_configurazioni: "Setups",
    menu_gruppi_trackers: "Tracker groups",
    menu_modelli_inverters: "Inverter models",
    menu_utenti_api: "API users",
    numero_impianti_associati: "Associated plants",
    datatable: {
      attiva_gridlines: "Enable grid lines",
      disattiva_gridlines: "Disable grid lines",
      numero_impianti_associati: "Associated plants",
      immagine_profilo: "Profile picture",
      creatoIl: "Created at",
      nome_file: "File name",
      colonna_bloccata: "This column is locked and cannot be hidden",
      dimensione: "Size",
      stato: "Status",
      durata: "Duration",
      data: "Date",
      azioni: "Actions",
      note: "Notes",
      dati_non_disponibili: "Data not available",
      colonne_da_visualizzare: "Columns to display",
      cerca: "Search...",
      foto_profilo: "Profile picture",
      profilo: {
        completo: "Complete",
      },
      tutto_completo: "Complete",
      username: "Username",
      email: "Email",
      azienda: "Company",
      cognome: "Last Name",
      nome: "First Name",
      data_nascita: "Date of Birth",
      paese_nascita: "Country of Birth",
      provincia_nascita: "Province of Birth",
      stato_nascita: "State of Birth",
      telefono: "Phone",
      indirizzo: "Address",
      cap: "ZIP Code",
      citta: "City",
      frazione: "District",
      provincia: "Province",
      data_ultimo_login: "Last Login Date",
      comune_nascita: "Birth Municipality",
      codice_fiscale: "Tax Code",
      regione: "Region",
      ragione_sociale: "Company Name",
      partita_iva: "VAT Number",
      referente: "Contact Person",
      numero_utenti_associati: "Number of associated users",
      logo_azienda: "Company logo",
      nome_impianto: "Plant name",
      pec: "PEC",
      impianti: "Plants",
      nome_licenza: "License Name",
      id: "ID",
    },
    header: {
      impianti_associati: "Impianti associati",
      elimina: "Delete",
      gestisci_dipendenti_azienda: "Manage company employees",
      gestisci_dipendenti_impianto: "Manage plant employees",
      conferma_azione: "Confirm action",
      proprietari_impianti_associati:
        "Owners/Technicians associated with the plant",
      tecnici_impianti_associati: "Tecnici associati",
    },
    tooltip: {
      apri_impianto: "Open plant details",
      proprietari_impianti_associati:
        "Owners/Technicians associated with the plant",
      get_setup: "Retrieve locally saved form data",
      elimina_setup_localmente: "Delete locally saved form data",
      salva_setup_localmente:
        "Save form data locally (in the browser), so you can retrieve it in the future",
      chiudi: "Close",
      massimizza: "Maximize/restore window",
      minimizza: "Minimize window",
      centra_dialog: "Center this window",
      visualizza_tabs: "View data in table format",
      visualizza_dataview: "View data in dataview format",
      aggiungi_elemento_creazione: "Add element",
      mostra_nascondi_linee_griglia: "Show/hide grid lines",
      rigenera_password: "Regenerate password",
      revoca_token: "Revoke tokens",
      copia: "Copy",
      salva: "Save",
      dettagli: "Details",
      cambia_password: "Change password",
      cambia_colore_riga: "Change row color",
      modifica: "Edit",
      elimina: "Delete",
      scarica: "Download",
      conferma: "Confirm",
      crea: "Create",
      ultima_volta_sincronizzati: "Data last synchronized at",
      gestisci_dipendenti_impianto: "Manage plant employees",
      sposta_a: "Move to",
      sinistra: "Left",
      destra: "Right",
      gestisci_dipendenti_azienda: "Manage company employees",
      tecnici_impianti: "Technicians associated with the plant",
      ancora_destra: "Anchor right",
      ancora_sinistra: "Anchor left",
      chiudi_elemento: "Close element",
      scorciatoia_ctrl_b: "Open/close menu: CTRL + B",
    },
    summary: {
      errore: "Error",
      successo: "Success",
      eliminato: "Deleted",
      creato: "Created",
      aggiornato: "Updated",
      backup_avviato: "Backup started",
      backup_completato: "Backup completed",
      backup_fallito: "Backup failed",
      avviso: "Warning",
      informazione: "Information",
      dato_ripristinato: "Data restored",
    },
    dialog: {
      configura_licenza_per_impianto: "Configure license for plant",
      selezionati: "Selected",
      data_attivazione: "Activation date",
      licenze_per_impianto: "Licenses for plant",
      licenza: "License",
      scadenza_non_richiesta: "Expiry not requested",
      abilita_email_scadenza_licenze:
        "Enable email to receive license expirations",
      informativa_codice_fiscale:
        "By entering the tax code, some fields will be automatically filled in.",
      invia_credenziali: "Send credentials",
      password: "Password",
      password_non_valida: "Invalid password",
      email_non_valida: "Invalid email address",
      seleziona_azienda: "Select company",
      nessun_elemento_aperto_dialog: "No element opened",
      suggerimenti_dialog_vuota:
        "To get started, you can open an existing element by clicking the 'Details' button on the right side of the table, or create a new one using the Toolbar above.\nIf you have previously saved a setup, you can always recover it from the Toolbar.",
      dati_anagrafici: "Personal data",
      domicilio_residenza: "Residence address",
      dati_accesso: "Access data",
      campo_obbligatorio: "This field is required",
      minimo_2_caratteri: "Minimum 2 characters",
      minimo_3_caratteri: "Minimum 3 characters",
      carica_immagine: "Upload image",
      immagine_profilo: "Profile picture",
      formati_supportati: "Formats: png, jpg, jpeg, webp. Max size 5MB.",
      dati_impianto: "Plant data",
      riferimento_anagrafica: "Record reference",
      codice_fiscale_non_valido: "Invalid tax code",
      localizzazione_impianto: "Plant location",
      seleziona_impianto: "Select plant",
    },
    impostazioni: {
      email_comunicazioni_licenze: "License communications email addresses",
      impostazioni_generali: "General Settings",
      modifica_impostazioni_descrizione:
        "Modify the general settings of the application",
      manutenzione: "Maintenance",
      generali: "General",
      impostazioni_email_help_body:
        "Enter email addresses separated by Enter or comma..",
      ultimo_aggiornamento: "Last update",
    },
    in_corso: "In progress",
    fallito: "Failed",
    note: "Notes",
    nome_file: "File name",
    dimensione: "Size",
    eliminato: "Deleted",
    abilita_dueeffea: "Enable two-factor authentication",
    disabilita_dueeffea: "Disable two-factor authentication",
    dueeffea_attivato_con_successo:
      "Two-factor authentication enabled successfully",
    errore_generazione_qr_code: "Error generating QR Code",
    utente_super_admin: "Super Administrator User",
    numero_utenti_associati: "Number of associated users",
    immagine_personalizzata: "Custom image",
    immagine_default: "Default image",
    imposta_logo_azienda: "Set company logo",
    logo_azienda: "Company logo",
    immagine_default_evocleaners: "Default image for Evocleaners",
    ragione_sociale_gia_esistente_nel_database:
      "Company name already exists in the database",
    email_gia_esistente_nel_database: "EEmail already exists in the database",
    suggerimento_immagine_default_evocleaners:
      "Default image shown for Evocleaners without a profile image uploaded. If empty, a generic icon will be displayed, otherwise the uploaded image will be set here.",
    filtri_statistiche_azienda_macchina_periodo:
      "Statistics for company, machine and period",
    lista_missioni: "List of missions",
    utente_azienda_esterna: "User from another company",
    tu: "You yourself",
    icona: "Icon",
    campi_mancanti: "Missing fields",
    nessuna_missione_trovata: "No mission found",
    nome_dispositivo: "Device name",
    missioni_correlate_ricerca: "Missioni correlate alla ricerca",
    aggiorna_elenco_email: "Aggiorna elenco email",
    scannerizza_per_dueffea:
      "Scannerizza il QR Code per abilitare l'accesso tramite Google Authenticator o Passwords di Apple.",
    notifiche_push_abilitate: "Notifiche push abilitate",
    tempo_accensione: "Tempo accensione",
    dispositivi_associati: "Dispositivi associati",
    missione_iniziata_Il: "Missione iniziata il",
    tempo_valvola_aperta: "Tempo valvola aperta",
    dati_aggiornati_in_automatico: "Dati aggiornati in automatico",
    aggiorna_i_dati_manualmente: "Aggiorna i dati manualmente",
    pacchetti_in_attesa: "Pacchetti in attesa",
    quando_ricevuta_comunicazione_dalla_macchina:
      "Quando ricevuta comunicazione dalla macchina",
    aggiorna_in_automatico: "Aggiorna i dati in automatico",
    attendi_aggiornamento_manualmente: "Attendi aggiornamento manuale dei dati",
    trasparente: "Trasparente",
    bianco: "Bianco",
    grigio_chiaro: "Grigio chiaro",
    argento: "Argento",
    marrone: "Marrone",
    oro: "Oro",
    giallo: "Giallo",
    verde_lime: "Verde lime",
    verde: "Verde",
    verde_scuro: "Verde scuro",
    turchese: "Turchese",
    ciano: "Ciano",
    blu: "Blu",
    success: "Successo",
    blu_scuro: "Blu scuro",
    viola: "Viola",
    rosa: "Rosa",
    rosso: "Rosso",
    rosso_scuro: "Rosso scuro",
    arancione: "Arancione",
    grigio: "Grigio",
    menu_privacy: "Privacy",
    menu_quadro: "Switchboard",
    data_lettura: "Data lettura",
    lettura_email_eseguita_con_successo: "Lettura email eseguita con successo",
    visualizza_resoconto_letture: "Visualizza resoconto letture",
    forza_lettura_email: "Forza lettura email",
    apri_inbox_evocleaner: "Apri Inbox Evocleaner",
    visualizza_inbox: "Visualizza Inbox",
    visualizza_tabella: "Visualizza tabella",
    inbox_evocleaner: "Inbox Evocleaner",
    cerca_evocleaner: "Search evocleaner...",
    cerca_oggetto_email: "Search email subject...",
    aggiorna: "Update",
    nessuna_email: "No emails available",
    nessuna_email_trovata: "No emails found",
    nessun_evocleaner_trovato: "Nessun evocleaner trovato",
    ultima_email: "Ultima email",
    ultime_email: "Ultime email",
    dettagli_email: "Dettagli email",
    altri_campi: "Altri campi",
    seleziona_evocleaner: "Seleziona un evocleaner",
    nessuna_email_per_evocleaner: "Nessuna email per questo evocleaner",
    evocleaners_con_email: "evocleaner con email",
    email_totali: "email totali",
    ultima_esecuzione: "Ultima esecuzione",
    prossima_esecuzione: "Prossima esecuzione",
    esito: "Esito",
    resoconto_letture_email: "Resoconto letture email",
    eseguito_da_nome: "Eseguito da",
    data_esecuzione: "Data esecuzione",
    push_notifications_enabled: "Push notifications enabled",
    push_notifications_disabled: "Push notifications disabled",
    push_notifications_detail_on: "You will receive instant push notifications",
    push_notifications_detail_off: "You will not receive push notifications",
    attive: "Attive",
    non_attive: "Non attive",
    le_notifiche_push_non_sono_supportate:
      "Push notifications are not supported",
    le_notifiche_push_su_ios_richiesto_safari:
      "On iOS devices, push notifications are only supported in Safari (iOS 16.4+).",
    notifiche_push: "Push notifications",
    notifiche_sottotitolo:
      "Configure how to receive EvoSense notifications for devices and updates",
    notifiche_push_ios_attivare_titolo: "To enable notifications:",
    notifiche_push_ios_step1: "1. Open this page in Safari",
    notifiche_push_ios_step2: "2. Update to iOS 16.4 or later if needed",
    notifiche_push_ios_step3: "3. Return here to enable notifications",
    notifiche_push_browser_non_supportato:
      "Your browser does not support push notifications. Try updating it or use a different browser.",
    notifiche_push_bloccate_descrizione:
      "Notifications have been blocked. To enable them:",
    notifiche_push_bloccate_step1:
      "1. Click the padlock icon in the address bar",
    notifiche_push_bloccate_step2: '2. Select "Allow" for notifications',
    notifiche_push_bloccate_step3: "3. Reload the page",
    notifiche_push_richiesta_descrizione:
      "Enable notifications to receive real-time updates",
    notifiche_push_bottone_abilita: "Enable",
    notifiche_push_bottone_test: "Test",
    notifiche_push_bottone_test_titolo: "Send test notification",
    notifiche_push_bottone_attiva: "Activate",
    notifiche_push_bottone_disattiva: "Deactivate",
    notifiche_push_configurate_titolo: "Push notifications configured!",
    notifiche_push_configurate_descrizione:
      "You will receive instant push notifications on your devices, missions and system updates.",
    notifiche_push_permesso_concesso:
      "Permission granted! You can now enable push notifications",
    notifiche_push_permesso_negato:
      "Permission denied - Cannot enable notifications",
    notifiche_push_permesso_errore: "Error while requesting permission",
    notifiche_push_attivate_successo:
      "Notifications enabled! You will receive updates from EvoSense on your devices",
    notifiche_push_attivate_errore: "Unable to enable notifications",
    notifiche_push_disattivate_successo:
      "Notifications disabled - You will no longer receive push notifications",
    notifiche_push_disattivate_errore: "Unable to disable notifications",
    notifiche_push_test_successo: "Test sent! Check your device notifications",
    notifiche_push_test_errore: "Unable to send test notification",
    notifiche_email_test_successo: "Test email sent! Check your inbox",
    notifiche_email_test_errore: "Error while sending test email",
    notifiche_email_preferenze_errore:
      "Unable to load email preferences: {error}",
    notifiche_email_attivate_successo: "Email notifications enabled!",
    notifiche_email_disattivate_successo: "Email notifications disabled",
    notifiche_email_impostazioni_errore: "Unable to update email settings",
    nessun_dispositivo_registrato: "Nessun dispositivo registrato",
    rimuovi_dispositivo_corrente_avviso:
      "Attenzione: stai per rimuovere il dispositivo corrente. Procedendo, effettuerai il logout dall'applicazione e dovrai nuovamente verificare il dispositivo.",
    dispositivo_corrente: "Dispositivo corrente",
    codice_inviato_via_email: "Codice inviato via email",
    mesi: "Mesi",
    conferma_rimozione_dispositivo_nome:
      "Confermi la rimozione del dispositivo",
    salvataggio_dispositivo_titolo: "Stiamo salvando il tuo dispositivo…",
    salvataggio_dispositivo_sottotitolo:
      "Così al prossimo accesso sarà più veloce e immediato",
    salvataggio_dispositivo_descrizione_1:
      "Stiamo registrando questo dispositivo per riconoscerlo automaticamente.",
    salvataggio_dispositivo_descrizione_2:
      "È un passaggio rapido: ti eviterà verifiche ripetute e renderà l’accesso più fluido.",
    salvataggio_dispositivo_hint:
      "Non chiudere la pagina: mancano solo pochi secondi.",
    codice_non_valido: "Codice non valido",
    prosegui: "Prosegui",
    verifica_metodi_dispositivo:
      "È richiesta la verifica del dispositivo per confermare l'accesso.",
    verifica_metodi_dispositivo_descrizione:
      "Per motivi di sicurezza, è necessario verificare il dispositivo da cui stai effettuando l'accesso. Scegli uno dei metodi di verifica disponibili per procedere con il login.",
    visualizza_informativa_privacy: "Visualizza informativa privacy",
    credits: "Credits",
    visualizza_credits: "Visualizza credits",
    resetta_filtri: "Reset filters",
    g_speed: "Velocità G",
    storico_missioni: "Storico missioni",
    singola_missione: "Singola missione",
    anima_percorso: "Anima percorso",
    timeline_on: "Timeline on",
    mostra_intero: "Mostra intero",
    copia_id: "Copia ID",
    esporta_csv: "Export CSV",
    esporta_gpx: "Esporta GPX",
    status_code: "Codice stato",
    modifica_note: "Modifica note",
    menu_guida: "Guida",
    visualizza_guida: "Visualizza guida",
    visualizza_note: "Visualizza note",
    punti: "Punti",
    distanza_totale_km: "Distanza totale (km)",
    km_h: "Km/h",
    mph: "Mph",
    menu_profilo: "Profile",
    menu_comandi_manuali_attivi: "Manual commands active",
    emails: "Emails",
    consumo_acqua_media_stimata: "Consumo acqua media stimata",
    ore_accensione: "Ore accensione",
    blocca: "Blocca",
    ore_valvola_aperta: "Ore valvola aperta",
    sblocca: "Sblocca",
    ip: "Indirizzo IP",
    confermi_modifica_cella: "Confermi la modifica della cella?",
    click_cella_per_edit: "Clicca sulla cella per modificare",
    user_agent: "User Agent",
    imei_modem_saet: "S.A.E.T. Modem IMEI",
    token_last8: "Ultimi 8 caratteri del token",
    latency_ms: "Latenza (ms)",
    payload_bytes: "Byte del payload",
    db_ops: "Operazioni DB",
    error_code: "Codice errore",
    error_message: "Messaggio errore",
    requested_action: "Azione richiesta",
    mission_id: "ID Missione",
    em_local: "EM Local",
    em_remote: "EM Remote",
    distance_delta_km: "Delta distanza (km)",
    meta: "Meta",
    imsi: "IMSI",
    apri_dettaglio: "Apri dettaglio",
    mesi_dall_ultima_manutenzione: "Mesi dall'ultima manutenzione",
    conferma_sblocco_obbligo_manutenzione:
      "Confermi sia stata effettuata la manutenzione sulla macchina?",
    ricevuto_dal_cloud: "Ricevuto dal cloud",
    dispositivi_collegati_descrizione:
      "Numero di dispositivi attualmente collegati",
    sblocca_macchina: "Unlock machine",
    spiegazione_sblocco_macchina:
      "Per sbloccare la macchina è necessario che questa sia accesa e connessa alla Web App tramite la scheda prodotta da S.a.e.t. s.r.l.",
    dueeffea: "Autenticazione a due fattori",
    bloccato: "Bloccato",
    dispositivi: "Devices",
    non_bloccato: "Non bloccato",
    bloccato_per_obbligo_manutenzione: "Bloccato per obbligo manutenzione",
    mesi_passati_da_ultima_manutenzione: "Mesi passati da ultima manutenzione",
    mesi_rimanenti: "Mesi rimanenti",
    immagine: "Immagine",
    macchina_bloccata_obbligo_manutenzione:
      "Macchina bloccata per obbligo manutenzione",
    richiedi_sblocco: "Richiedi sblocco",
    stato_macchina_per_manutenzione: "Stato macchina per manutenzione",
    manutenzione: "Manutenzione",
    evocleaner_bloccato_per_obbligo_manutenzione:
      "Evocleaner bloccato per obbligo manutenzione",
    carica_immagine: "Load image",
    rimuovi: "Remove",
    salva: "Save",
    ripristina: "Ripristina",
    ultimo_aggiornamento: "Last update",
    impostazioni_email_help_body:
      "Inserisci gli indirizzi email separandoli con Invio o virgola.",
    formati_supportati: "Formati: png, jpg, jpeg, webp. Max 1MB.",
    immagine_selezionata_salva_per_applicare:
      "Immagine selezionata. Premi Salva per applicare.",
    data_ultima_manutenzione: "Data ultima manutenzione",
    generali: "Generali",
    suggerimento_contattare_m2:
      "List of email addresses to be notified when the license is about to expire. The notification will also be automatically sent to all owners of the plant.",
    ore_per_notifica_manutenzione:
      "Numero di ore che fanno scattare la notifica di manutenzione",
    suggerimento_ore_per_notifica_manutenzione:
      "Numero di ore che fanno scattare la notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina.",
    suggerimento_ore_per_manutenzione:
      "La macchina, appena connessa, verrà bloccata se il numero di ore di accensione raggiunge questo valore. Verrà inoltre inviata una notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina. La macchina potrà essere sbloccata solo dopo aver eseguito la manutenzione da parte di un tecnico autorizzato.",
    mesi_per_notifica_manutenzione:
      "Numero di mesi che fanno scattare la notifica di manutenzione",
    suggerimento_mesi_per_notifica_manutenzione:
      "Numero di mesi che fanno scattare la notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina.",
    mesi_per_manutenzione: "Numero di mesi che fanno scattare la manutenzione",
    suggerimento_mesi_per_manutenzione:
      "La macchina, appena connessa, verrà bloccata se il numero di mesi dall'ultima manutenzione raggiunge questo valore. Verrà inoltre inviata una notifica di manutenzione alla mail impostata sotto e agli utenti associati all'azienda proprietaria della macchina. La macchina potrà essere sbloccata solo dopo aver eseguito la manutenzione da parte di un tecnico autorizzato.",
    suggerimento_comunicazioni_manutenzione:
      "Indirizzo email alla quale verrà inviata la comunicazione di manutenzione necessaria della macchina. La comunicazione verrà anche automaticamente inviata a tutti gli utenti associati all'azienda proprietaria della macchina.",
    email_comunicazioni_manutenzione: "Email comunicazioni manutenzione",
    resoconto_ultima_missione: "Resoconto ultima missione",
    focus_macchina: "Focus macchina",
    vai_a_dettaglio_macchina: "Vai al dettaglio macchina",
    ultima_missione_descrizione:
      "Ultima missione della {seriale} presso {azienda}.",
    altre_missioni_nel_periodo:
      "Altre {count} missioni nel periodo selezionato.",
    missioni_medie_giornaliere: "Missioni medie/giorno",
    giorno_piu_attivo: "Giorno più attivo",
    giorno_meno_attivo: "Giorno meno attivo",
    variazione_medio_periodo: "Trend rispetto all'inizio periodo",
    azienda_non_disponibile: "Azienda non disponibile",
    missioni_x: "{count} missioni",
    resoconto_periodo: "Period recap",
    ultima_macchina: "Last machine",
    nessuna_missione_nel_periodo: "No missions in the selected period.",
    andamento_missioni: "Mission trend",
    andamento_missioni_descrizione: "Mission trend over the selected period.",
    top_macchine_per_ore: "Top machines by hours",
    top_macchine_descrizione: "The 5 machines with the highest working hours.",
    seleziona_periodo: "Select period",
    seleziona_periodo_rapido: "Quick period",
    tutte_le_aziende: "All companies",
    tutte_le_macchine: "All machines",
    dettaglio_missioni: "Mission details",
    dettaglio_macchine: "Machine details",
    riduci: "Collapse",
    espandi: "Expand",
    km_totali: "Total km",
    oggetto_tradotto: "Oggetto tradotto",
    corpo_tradotto: "Corpo tradotto",
    oggetto_originale: "Oggetto originale",
    corpo_originale: "Corpo originale",
    manutenzione_ok: "Manutenzione in ordine",
    manutenzione_da_programmare: "Manutenzione da programmare",
    manutenzione_urgente: "Manutenzione urgente",
    ore_usate_di: "ore usate di",
    ore: "ore",
    ore_rimanenti: "ore rimanenti",
    totale_ore_accensione_per_manutenzione:
      "Totale ore accensione per manutenzione",
    totale_ore_accensione: "Totale ore accensione",
    nessuna_risposta_dispositivo: "Nessuna risposta dal dispositivo",
    attesa_ack_dispositivo: "Attesa conferma dal dispositivo",
    attesa_ack_dispositivo_descrizione:
      "In attesa della conferma dal dispositivo",
    nessuna_risposta_dispositivo_descrizione:
      "Nessuna risposta ricevuta dal dispositivo",
    comando_remoto_inviato: "Comando remoto inviato al dispositivo",
    visualizza_impostazioni: "Visualizza impostazioni",
    email_inviata_con_successo: "Email inviata con successo!",
    super_amministratore: "Super Administrator",
    comando_remoto_eseguito_descrizione: "Comando remoto eseguito con successo",
    ore_per_manutenzione:
      "Numero di ore che fanno scattare l'obbligo di manutenzione",
    notifiche_credenziali_evocleaners:
      "Indirizzi mail alla quale vengono inviate le credenziali di accesso Wss dei nuovi Evocleaner creati",
    suggerimento_notifiche_credenziali_evocleaners:
      "Dopo aver inserito l'indirizzo mail, premere INVIO per aggiungerlo alla lista.",
    email_comunicazioni_envirologic:
      "Indirizzo mail che riceve le comunicazioni Envirologic",
    foto_profilo: "Profile photo",
    controlla_casella_mail:
      "È stato inviato un codice via email all'indirizzo associato al tuo account",
    passa_a_tema_chiaro: "Switch to light theme",
    em_stop_attivo_tooltip: "La macchina risulta già fermata da remoto",
    em_stop_non_attivo_tooltip: "La macchina non risulta fermata da remoto",
    comando_remoto_blocco_ack_ok:
      "Comando di blocco remoto eseguito con successo",
    comando_remoto_sblocco_ack_ok:
      "Comando di sblocco remoto eseguito con successo",
    ack_ricevuto: "Conferma ricevuta dalla macchina",
    errore_aggiornamento_stato_em_stop:
      "Errore durante l'aggiornamento dello stato di blocco remoto",
    tema: "Theme",
    lingua: "Language",
    seleziona_lingua: "Select language",
    cambio_lingua: "Change language",
    passa_a_tema_scuro: "Switch to dark theme",
    visualizza_log_sistema: "View system logs",
    visualizza_comunicazioni: "View communications",
    evento: "Event",
    risposta: "Response",
    socket_autenticazione_ricevuta: "WebSocket authentication received",
    stato_connessione: "Stato connessione",
    online: "Online",
    offline: "Offline",
    aggiorna_stato_connessione: "Aggiorna stato connessione",
    dispositivi_attivi: "Dispositivi attivi",
    totale_pacchetti: "Totale pacchetti",
    ultimo_pacchetto: "Ultimo pacchetto",
    ultima_attivita: "Ultima attività",
    nessun_dispositivo_attivo: "Nessun dispositivo attivo",
    apri_monitor_connessioni: "Visualizza dispositivi",
    dispostivo_con_seriale: "Device with serial",
    autenticato_con_successo: "successfully authenticated",
    ricevuto_status: "Status received from device",
    dettaglio: "Detail",
    blocca_macchina: "Stop machine",
    azienda: "Company",
    seriale: "Serial",
    premi_per_visualizzare: "Premi per visualizzare",
    username_wss: "Username for WebSocket communication",
    password_wss: "Password for WebSocket communication",
    conferma_rimozione_foto_profilo:
      "Confermi la rimozione della foto profilo?",
    rimuovi_foto_profilo: "Rimuovi foto profilo",
    dispositivo_rimosso: "Dispositivo rimosso con successo",
    cambia_foto_profilo: "Cambia foto profilo",
    dati_macchina: "Machine data",
    ultima_settimana: "Last week",
    notifiche: "Notifiche",
    ultimo_mese: "Month to date",
    mese_scorso: "Last month",
    sempre: "Sempre",
    metri: "Metri",
    ore_totali: "Ore totali",
    nessuna_manutenzione_registrata: "Nessuna manutenzione registrata.",
    macchine_attive: "Macchine attive",
    distanza_totale: "Distanza totale",
    missioni_totali: "Missioni totali",
    macchina: "Macchina",
    dati_accesso_websocket: "WebSocket access data",
    info_creazione_credenziali_websocket:
      "Once created, credentials will be sent by email to S.A.E.T. S.r.l. staff for device configuration. They are essential for communication between the app and the EvoCleaner robot.",
    info_modifica_credenziali_websocket:
      "Once associated, the password is encrypted and no longer visible. When changed, the new password will be emailed to S.A.E.T. S.r.l. staff for device reconfiguration.",
    tema_chiaro: "Light Theme",
    tema_scuro: "Dark Theme",
    calcola_coordinate: "Calculate coordinates",
    login_non_ancora_effettuato: "Login not yet performed",
    dipendenti_azienda: "Company employees",
    visualizza_profilo_utente: "View user profile",
    mappa_aziende: "Company map",
    mappa_impianti: "Plants map",
    ricarlica_coordinate: "Recalculate coordinates",
    esempio_indirizzo: "Example: Piazza Annibale Galateri, 9",
    inserire_indirizzo_completo:
      "Enter a complete address to calculate coordinates",
    archiviazione_eseguita: "Archived successfully!",
    proprio_ora: "Proprio ora",
    secondi_fa: "{value} secondi fa",
    minuti_fa: "{value} minuti fa",
    ore_fa: "{value} ore fa",
    giorni_fa: "{value} giorni fa",
    menu_notifiche: "Notifications / Announcements",
    impostazioni_turno: "Shift settings",
    menu_configura_orari: "Configure schedules",
    conferma_archivia: "Are you sure you want to archive selected items?",
    mostra_nascondi_linee_griglia: "Show/Hide grid lines",
    manca_id_elemento: "Element ID is missing",
    pec_non_valida: "Invalid PEC address",
    dati_aziendali: "Company data",
    contatti: "Contacts",
    sede: "Headquarters",
    disabilitato: "Disabled",
    abilitato: "Enabled",
    facoltativo: "Optional",
    nessun_file: "No file selected",
    generazione_pdf_in_corso: "PDF generation in progress...",
    install_pwa: {
      title: "Installa l’app",
      subtitle:
        "Scarica la nostra web app per un’esperienza più veloce e comoda",
      follow_guide: "Segui la guida qui sotto",
      install_now: "Installa ora",
      close: "Chiudi",
      close_and_dont_show: "Chiudi e non mostrare più",
      login_auto: {
        title: "Login automatico",
        step1: "Installando la PWA, la sessione sarà riconosciuta",
        step2: "Non servirà accedere di nuovo",
        step3: "L'app ti autenticherà ogni volta che la apri",
      },
      desktop: {
        title: "Desktop",
        step1: "Apri questo sito su Chrome o Edge.",
        step2:
          "Clicca sull’icona <i class='fas fa-display-arrow-down'></i> nella barra degli indirizzi.",
        step3: "Conferma su “Installa”.",
      },
      android: {
        title: "Android",
        step1: "Apri il sito su Chrome.",
        step2: "Tocca il menu <i class='fas fa-ellipsis-vertical'></i>.",
        step3: "Seleziona “Aggiungi a schermata Home”.",
        step4: "Conferma su “Installa”.",
      },
      ios: {
        title: "iOS",
        step1: "Apri il sito in Safari.",
        step2: "Tocca <i class='fas fa-arrow-up-from-square'></i>.",
        step3: "Seleziona “Aggiungi alla schermata Home”.",
        step4: "Conferma su “Aggiungi”.",
      },
    },
    totale_elementi: "Total items",
    comune_nascita: "Place of birth",
    dati_bancari: "Bank details",
    dati_personali: "Personal details",
    seleziona_azienda: "Select company",
    ragione_sociale: "Company name",
    dati_accesso: "Access data",
    domicilio_residenza: "Domicile/Residence",
    selezionati: "Selected",
    pagina: "Page",
    risultati: "Results",
    nome: "Name",
    creato: "Created",
    modificato: "Modified",
    ultima_modifica: "Last update",
    password_non_valida:
      "Password must contain at least 12 characters, an uppercase letter, a lowercase letter, a number and a special character",
    errore: "Error",
    minimo_12_caratteri: "Minimum 12 characters required",
    cambia_colore_riga: "Change row color",
    aggiungi_preferito: "Add to favorites",
    apri_popup_esterno: "Open external popup",
    regione: "Region",
    localita: "Locality",
    nazione: "Country",
    provincia: "Province",
    referente: "Contact person",
    menu_permessi: "Permissions",
    menu_resoconto: "Summary",
    menu_categorie: "Categories",
    menu_rilevazione_presenze: "Attendance tracking",
    progetto_aggiornato: "The project has been updated!",
    testo_aggiornamento_app:
      "To continue, reload the page or reinstall the PWA",
    descrizione_orario_turno_rotazione: "Enter shift start and end time",
    descrizione_orario_turno_fisso: "Enter shift start and end time",
    info_tipologia_orario_turno:
      "The shift type defines how working hours are calculated and how shifts are assigned when using automatic assignment.",
    durata_turno: "Shift duration",
    tipo_orario_turno: "Shift time type",
    info_durata_turno:
      "Shift duration defines how many hours must be worked in this shift. Unpaid breaks are excluded.",
    descrizione_orario_turno_selezionato: "Enter shift start and end time",
    orario_turno: "Shift time",
    descrizione_orario_turno: "Shift time description",
    descrizione_orario_turno_libero:
      "This shift can start and end at any time of the day, but a total of {ore} hours must be worked.",
    info_nome_turni:
      "The shift name must be unique and easily identifiable. It is used in views, search and reports.",
    info_sigla_turni:
      "The shift code is a short identifier used where space is limited, such as tables or exports. It must be unique.",
    inizio: "Start",
    fine: "End",
    durata: "Duration",
    info_nome_gruppi:
      "In the 'Name' field, enter the name to assign to the group. It appears in the Employees table, in Groups, in 'GROUP ATTENDANCE' and in the Calendar filters. Choosing a color helps identify the group.",
    menu_turni: "Shifts",
    menu_impostazioni: "Settings",
    aiuto: "Aiuto",
    turni_assegnati: "Assigned shifts",
    info_turni_assegnati:
      "In 'Assigned Shifts' select the shifts that can be assigned to group members. The first button filters shifts, the second clears filters. Assigned shifts are visible in 'GROUP ATTENDANCE'.",
    info_bollatura_attiva:
      "If 'Attendance tracking active' is checked, group members can clock in at the kiosk. This can be checked in Groups under 'MEMBERS ATTENDANCE'.",
    info_bollatura_remota_attiva:
      "If 'Remote attendance tracking active' is checked, members can record attendance remotely via the app with GPS coordinates.",
    turni_info:
      "In 'Working days' select the days on which group members can be assigned shifts. Working days are shown in Groups under 'MEMBERS ATTENDANCE'.",
    presenze_membri: "Members attendance",
    nome_gruppo_esistente: "Group name already exists in database",
    errore_creazione_gruppo: "Error creating group",
    errore_aggiornamento_gruppo: "Error updating group",
    gruppo_creato: "Group created successfully!",
    gruppo_aggiornato: "Group updated successfully!",
    turni: "Shifts",
    rilevazioni_presenze: "Attendance records",
    giorni_lavorativi: "Working days",
    dispositivo_di_sicurezza: "Safety device",
    telefono_non_valido: "Invalid phone number",
    email_non_valida: "Invalid email",
    bollatura_attiva: "Attendance enabled",
    bollatura_remota_attiva: "Remote attendance enabled",
    richiesta_ferie_nuova: "New vacation request",
    richiesta_ferie_modificata: "Vacation request updated",
    richiesta_rimborso_nuova: "New reimbursement request",
    richiesta_rimborso_aggiornata: "Reimbursement request updated",
    richiesta_file_nuova: "New file request",
    file_ricevuti: "Received files",
    rapporto_assenze: "Absence report",
    rapporto_inattivita: "Inactivity report",
    licenza_non_valida: "Invalid license",
    licenza: "License",
    accedi: "Login",
    nome_licenza: "License name",
    durata_mesi: "Duration (months)",
    creata_il: "Created at",
    aborto: "Abortion",
    quanti_aborti: "How many abortions",
    tipologia_transazione: "Transaction Type",
    giftcard: "Giftcard",
    firma_non_presente: "Signature not present",
    credito_attuale: "Credito attuale",
    aggiunta: "Aggiunta",
    sottrazione: "Sottrazione",
    credito_residuo_dopo_operazione: "Credito residuo dopo operazione",
    calcolo_automatico_del_nuovo_saldo: "Calcolo automatico del nuovo saldo",
    paese_nascita: "Place of birth",
    campo_obbligatorio: "This field is required",
    importo: "Importo",
    conferma_inserimento_transazione: "Conferma inserimento transazione",
    saldo_pre_transazione: "Saldo pre-transazione",
    saldo_post_transazione: "Saldo post-transazione",
    resoconto_transazioni: "Resoconto transazioni",
    aggiungi_transazione: "Aggiungi transazione",
    registra_firma: "Registra firma",
    attendendo_firma_dispositivo: "Attendere firma dispositivo...",
    cambia_firma: "Cambia firma",
    nessuna_transazione: "Nessuna transazione",
    nessuna_transazione_giftcard_registrata:
      "Nessuna transazione giftcard registrata",
    inserimento_eseguito: "Inserimento eseguito con successo!",
    stampa: "Stampa",
    menu_gruppi: "Gruppi",
    tipo: "Type",
    a: "a",
    aggiungi: "Aggiungi",
    aggiungi_note: "Aggiungi note",
    aggiorna_tabella: "Aggiorna la tabella",
    anamnesi: "Anamnesi",
    anno: "Anno",
    annulla: "Cancel",
    annulla_modifica: "Annulla modifica",
    autenticazione_2FA: "Autenticazione 2FA",
    avvia_timer: "Avvia timer",
    avviso_date_con_date_disabilitate:
      "In caso il range di date selezionato comprenda delle date disabilitate, il sistema andrà a generare tante associazioni quanti sono i range di date che vengono trovati.",
    azioni: "Actions",
    benvenuto_descrizione: "Gestione e pianificazione commesse",
    benvenuto_utente: "Benvenuto",
    recapito_emergenza: "Contatto d'emergenza",
    calcola_data_fine: "Calcola data fine stimata",
    calendario: "Calendario",
    cambia_immagine: "Cambia immagine",
    cambia_tema: "Cambia tema",
    campo_richiesto: "Campo richiesto",
    caricamento_dati: "Caricamento dei dati in corso...",
    categorie: "Categorie",
    categoria: "Categoria",
    tipologia: "Tipologia Operatori",
    cerca: "Search...",
    cerca_in_tutti_i_campi: "Search all fields...",
    aliquota_iva: "Aliquota IVA",
    descrizione_aliquota_iva: "Descrizione Aliquota IVA",
    prezzo_lordo: "Prezzo Lordo",
    prezzo_di_acquisto: "Prezzo di Acquisto",
    giacenza: "Giacenza",
    extra: "Extra",
    paziente: "Paziente",
    registra_nuovo_paziente: "Registra nuovo paziente",
    ora: "Ora",
    medico: "Medico",
    struttura: "Struttura",
    tipologia_visita: "Tipologia Visita",
    data_creazione: "Data Creazione",
    udm: "Unità di Misura",
    chiudi: "Chiudi",
    cliente: "Cliente",
    codice: "Codice",
    codice_email: "Codice via email",
    partita_iva: "VAT number",
    codice_sdi: "Codice SDI",
    pec: "PEC",
    peso: "Peso",
    attuale_peso: "Attuale Peso",
    altezza: "Height",
    altezza_precisa: "Altezza in cm",
    circonferenza_polso: "Circonferenza polso in cm",
    circonferenza_addome: "Circonferenza addome in cm",
    gruppo_sanguigno: "Gruppo sanguigno",
    sport: "Fai sport",
    sport_quali: "Quali sport?",
    sport_frequenza: "Frequenza sportiva",
    regime_alimentare: "Regime alimentare",
    regime_alimentare_altro: "Altro regime alimentare",
    alimentazione_e_idratazione: "Alimentazione e idratazione",
    rapporto_corpo_desc: "Hai un buon rapporto con il tuo corpo?",
    rapporto_corpo: "Rapporto con il corpo",
    capelli_desc: "I capelli hanno subito trattamento colorante, tinta, altro?",
    capelli_descrizione: "Descrizione trattamento capelli",
    acqua: "Acqua",
    iban: "IBAN",
    bic_swift: "BIC/SWIFT",
    nominativo_conto: "Nominativo conto",
    rs_banca: "Banca",
    paese_banca: "Paese banca",
    codice_abi: "Codice ABI",
    iban_valido: "IBAN valido",
    iban_non_valido: "IBAN non valido",
    banca_rilevata: "Banca rilevata automaticamente",
    banca_non_trovata: "Banca non trovata per questo IBAN",
    verifica_iban: "Verifica IBAN",
    validazione_iban_in_corso: "Validazione IBAN in corso...",
    codice_autenticazione: "Codice di autenticazione",
    codice_inviato: "Codice inviato! Controlla la tua email per continuare.",
    codice_obbligatorio: "Il codice è obbligatorio!",
    codice_recupera_password_verificato:
      "Codice verificato correttamente, procedi con l'inserimento della nuova password",
    codice_testo:
      "Inserisci il codice che ti è stato inviato tramite e-mail prima della scadenza del tempo",
    colore: "Colore",
    collaboratori_esterni: "Collaboratori esterni",
    commessa: "Commessa",
    esporta_excel: "Esporta excel",
    transazioni_disponibili_dopo_creazione:
      "Le transazioni risulteranno disponibili dopo la creazione",
    inserisci_saldo_iniziale_o_lascia_vuoto:
      "Al momento, inserisci il saldo iniziale del paziente oppure lascia vuoto per impostare €0,00",
    commessa_duplicata: "Commessa duplicata con successo!",
    commessa_eliminata: "Commessa eliminata con successo!",
    commessa_ricevuta: "Commessa ricevuta",
    commessa_utente_aggiornata: "Commessa aggiornata con successo!",
    commesse_importate: "Commesse importate con successo",
    concludi: "Concludi",
    conferma: "Conferma",
    conferma_eliminazione: "Sicuro di voler eliminare i dati selezionati?",
    conferma_eliminazione_transazione:
      "Sicuro di voler eliminare la transazione? Così facendo verrà solamente eliminata la transazione, il credito residuo non verrà modificato.",
    costo_finale: "Costo finale",
    crea: "Create",
    creatoIl: "Creato il",
    creazione_eseguita: "Creazione eseguita con successo!",
    data: "Date",
    data_fine: "Data fine",
    data_fine_maggiore_data_inizio:
      "La data di fine deve essere maggiore della data di inizio",
    data_fine_stimata: "Data fine stimata",
    data_inizio: "Data inizio",
    data_intervento: "Data intervento",
    data_nascita: "Date of birth",
    luogo_nascita: "Luogo di nascita",
    provincia_nascita: "Province of birth",
    stato_nascita: "Place of birth",
    dati_non_disponibili: "Data not available",
    da_pianificare: "Da pianificare",
    denominazione: "Denominazione",
    descrizione: "Descrizione",
    dettagli_base: "Dettagli base",
    error_torna_pagina_iniziale: "Back to home page",
    error_effettua_login: "Go back",
    favorite_page_pagina_rimossa: "Pagina rimossa dai preferiti",
    ferma_timer: "Ferma timer",
    file_e_documenti: "File e documenti",
    file_troppo_grande: "File troppo grande",
    fornitura: "Fornitura",
    genera_password: "Genera password",
    grafico: "Grafico",
    id: "ID",
    immagine_profilo: "Profile picture",
    immagine_profilo_aggiornata: "Immagine profilo aggiornata con successo!",
    importa: "Importa",
    inattivita_descrizione_1: "È stata rilevata un'inattività prolungata.",
    inattivita_descrizione_2: "Per motivi di sicurezza sei stato disconnesso.",
    inattivita_titolo: "Inattività rilevata!",
    indirizzo_ip: "Indirizzo IP",
    indirizzo_luogo_intervento: "Indirizzo luogo intervento",
    informazione: "Informazione",
    inserisci_mail_valida: "Inserisci una mail valida",
    invia_credenziali: "Invia credenziali tramite e-mail",
    invia_file: "Invia file",
    invia_rapportino: "Invia rapportino",
    inviata_amministrazione: "Inviata all'amministrazione",
    inviata_cliente: "Inviata al cliente",
    km_percorsi: "Km percorsi",
    livello: "Livello",
    lista: "Lista",
    totale_utenti: "Totale Utenti",
    completa_profilo: "Completa tutti i campi per continuare",
    login_aggiorna_accedi: "Aggiorna e accedi",
    login_attendi: "Attendi...",
    login_attendi_riprova: "Attendi per riprovare!",
    login_benvenuto: "Benvenuto!",
    login_campo_non_sicuro: "Campo non sicuro!",
    login_campi_obbligatori:
      "Inserire sia username che password per continuare",
    login_codice_scaduto: "Codice scaduto! riprova per continuare",
    login_conferma_password: "Conferma password",
    login_nuova_password: "Nuova password",
    login_controlla_mail: "Controllare le email per continuare",
    login_effetta_accesso: "Effettua l'accesso",
    login_email_reset_pass_inviata:
      "Email per reset password inviata all'utente specificato.",
    login_livello_sicurezza_password: "Livello di sicurezza password",
    login_password: "Password",
    modifica_password: "Modifica Password",
    login_password_dimenticata: "Forgot your password?",
    login_password_non_uguali: "Le password non corrispondono",
    login_reset_password: "Resetta la password",
    login_scegli_autenticazione: "Seleziona il metodo di autenticazione",
    login_submit_text: "Login",
    login_suggerimenti_password: "Suggerimenti password",
    login_suggerimenti_password_1:
      "La password deve contenere almeno una lettera minuscola",
    login_suggerimenti_password_2:
      "La password deve contenere almeno una lettera maiuscola",
    login_suggerimenti_password_3:
      "La password deve contenere almeno un numero",
    login_suggerimenti_password_4:
      "La password deve contenere almeno uno carattere speciale",
    login_suggerimenti_password_5:
      "La password deve contenere almeno 8 caratteri",
    login_timeout_codice: "Codice di verifica scaduto",
    login_troppe_richieste: "Hai effettuato troppe richieste!",
    login_usa_password: "Usa la tua password",
    login_username: "Username",
    login_username_reset_password:
      "Inserisci l'username per cui si vuole richiedere il reset password nel campo 'username'.",
    login_utente_non_trovato: "Impossibile trovare l'utente inserito!",
    login_tagline: "Photovoltaic panel management system",
    login_sottotitolo: "Enter your credentials to continue",
    login_feature_2fa: "2FA Authentication & WebAuthn",
    login_feature_interfaccia: "Responsive interface",
    login_feature_report: "Reports and analysis",
    login_feature_monitoring: "Real-time plant monitoring",
    login_feature_security: "Secure and traceable access",
    login_welcome_heading: "Welcome to your solar dashboard.",
    login_welcome_subtitle:
      "Sign in to monitor production, performance and status of your photovoltaic plants.",
    login_kpi_mwh: "Energy produced",
    login_kpi_impianti: "Monitored plants",
    login_kpi_uptime: "Reliability",
    login_footer_supporto: "Technical support",
    idle_inattivita_rilevata: "Inactivity detected",
    idle_descrizione_1:
      "Your session has expired due to inactivity. Please log in again to continue.",
    logout_conferma_disconnessione: "Confirm",
    logout_disconnetti: "Logout",
    logout_disconnessione: "Disconnection",
    logout_messaggio_disconnessione: "Are you sure you want to log out?",
    luogo_intervento: "Luogo intervento",
    menu_categorie_commesse: "Categorie commesse",
    menu_tipologia_operatori: "Tipologia Operatori",
    menu_clienti: "Clienti",
    menu_appuntamenti: "Appuntamenti",
    menu_dashboard: "Dashboard",
    menu_strutture: "Strutture",
    menu_occupazione: "Occupazione",
    menu_priorita_commesse: "Priorità commesse",
    menu_prodotti: "Prodotti",
    menu_rapportini: "Rapportini",
    menu_rapportini_nuovo: "Crea nuovo",
    menu_rapportini_nuovo_rapportino: "Nuovo rapportino",
    menu_rapportini_resoconto: "Resoconto",
    menu_macro_gruppi: "Macro Gruppi",
    menu_pazienti: "Pazienti",
    menu_sconti: "Sconti",
    menu_tag_commesse: "Tag commesse",
    menu_utilita_calendario_eventi: "Calendario eventi",
    menu_utilita: "Utilità",
    menu_utilita_archivio: "Archivio",
    menu_utilita_chat: "Chat",
    messaggio_conferma_eliminazione_selezionati: "Dati eliminati con successo!",
    messaggio_conferma_ripristino_selezionati:
      "Dati ripristinati con successo!",
    messaggio_duplicazione: "Duplicare la commessa?",
    messaggio_eliminazione: "Eliminare la commessa?",
    messaggio_eliminazione_selezionati:
      "Sicuro di voler eliminare i dati selezionati?",
    messaggio_ripristina_selezionati:
      "Sicuro di voler ripristinare i dati selezionati?",
    abitudini_vita: "Abitudini di vita",
    messaggio_eliminato: "Messaggio eliminato",
    dieta_libera_varia: "Dieta libera e varia",
    dieta_controllata: "Controllata per",
    digestione: "Digestione regolare",
    medico_curante: "Medico curante",
    storia_malattie_paziente: "Storia delle malattie del paziente",
    malattie_cuore: "Malattie del cuore",
    malattie_cuore_descrizione: "Descrizione malattie del cuore",
    pressione: "Pressione",
    allergie: "Allergie",
    quali_allergie: "Quali allergie?",
    diabete: "Diabete",
    tipologia_diabete: "Tipologia diabete",
    epatite_virale: "Epatite virale",
    tipologia_epatite: "Tipologia epatite",
    malattie_fegato: "Malattie del fegato",
    malattie_fegato_descrizione: "Descrizione malattie del fegato",
    malattie_renali: "Malattie renali",
    malattie_renali_descrizione: "Descrizione malattie renali",
    malattie_tiroide: "Malattie della tiroide",
    malattie_tiroide_descrizione: "Descrizione malattie della tiroide",
    malattie_stomaco_tubo_digerente:
      "Malattie dello stomaco o del tubo digerente",
    malattie_stomaco_tubo_digerente_descrizione:
      "Descrizione malattie dello stomaco o del tubo digerente",
    malattie_polmonari: "Malattie polmonari",
    malattie_polmonari_descrizione: "Descrizione malattie polmonari",
    malattie_veneree: "Malattie veneree",
    malattie_veneree_descrizione: "Descrizione malattie veneree",
    malattie_nervose_depressive: "Malattie nervose e depressive",
    malattie_nervose_depressive_descrizione:
      "Descrizione malattie nervose e depressive",
    malattie_oculari: "Malattie oculari",
    malattie_oculari_descrizione: "Descrizione malattie oculari",
    malattie_sangue_emorragie: "Malattie del sangue ed emorragie",
    malattie_sangue_emorragie_descrizione:
      "Descrizione malattie del sangue ed emorragie",
    malattie_non_elencate: "Malattie non elencate",
    alitosi: "Alitosi",
    conseguenze_particolari:
      "Conseguenze particolari in seguito all'assunzione di anestetici, antibiotici, analgesici o altri farmaci ?",
    esami_radiografici: "Esami radiografici",
    terapia_irradiante: "Terapia irradiante",
    esami_radiografici_descrizione: "Descrizione esami radiografici",
    terapia_irradiante_descrizione: "Descrizione terapia irradiante",
    malattie_gravi_interventi_chirurgici:
      "Malattie gravi e/o interventi chirurgici",
    malattie_gravi_interventi_chirurgici_descrizione:
      "Descrizione malattie gravi e/o interventi chirurgici",
    menu_tipologie_visite: "Tipologie visite",
    alvo: "Alvo regolare",
    per_uomini: "Per gli uomini",
    sonno: "Sonno regolare",
    seleziona_elementi_da_esportare: "Seleziona gli elementi da esportare",
    pdf_generato_correttamente: "PDF generato correttamente",
    fumo: "Fumo",
    fame_nervosa_desc: "Soffri di fame nervosa?",
    stitichezza_desc: "Soffri di stitichezza?",
    stitichezza: "Stitichezza",
    fame_nervosa: "Fame nervosa",
    tipo_acqua: "Tipo di acqua",
    litri_giorno: "Litri di acqua al giorno",
    andropausa: "Andropausa",
    andropausa_anni: "Anni di andropausa",
    seleziona_alimenti_preferiti:
      "Seleziona alimenti preferiti (possibili più scelte)",
    quanto_fumo: "Quantità giornaliera",
    tempo_fumo: "Da quanto tempo?",
    numero_caffe: "Numero di caffè giornalieri",
    caffe: "Caffè",
    alcol: "Alcolici",
    quali_alcol: "Quali alcolici?",
    farmaci: "Assume farmaci e/o droghe?",
    quali_farmaci: "Quali farmaci e/o droghe?",
    tempo_farmaci: "Da quanto tempo?",
    perche_farmaci: "Perché?",
    antitetanica: "Antitetanica",
    ultimo_antitetanica: "Data ultima somministrazione",
    professione: "Professione",
    per_donne: "Per le donne",
    menarca_anni: "Menarca",
    menarca_anni_testo: "Anni",
    ultimo_ciclo: "Ultimo ciclo",
    ciclo_regolare: "Ciclo regolare",
    gravidanze: "Gravidanze",
    numero_gravidanze: "Numero di gravidanze",
    modifica: "Edit",
    mostra_ore: "Visualizza il monte ore",
    nessuna_chat_selezionata: "Nessuna chat selezionata",
    nessun_dato: "Nessun dato presente",
    nessun_dato_disponibile: "No data available",
    nessun_dato_disponibile_descrizione:
      "There are no evocleaners matching current filters. Adjust search or create a new item.",
    seleziona_anamnesi: "Seleziona anamnesi",
    chiudi_anamnesi: "Chiudi anamnesi",
    seleziona_icd9: "Seleziona ICD9",
    ICD9: "ICD9",
    anamnesi_salvata: "Anamnesi salvata con successo!",
    data_evento: "Data evento",
    appunti: "Appunti",
    familiare: "Familiare",
    seleziona_familiare: "Seleziona familiare",
    diagnosi: "Diagnosi",
    annotazioni: "Annotazioni",
    nessuna_email_cliente: "Nessuna email presente per il cliente selezionato",
    nessun_cliente_selezionato: "Nessun cliente selezionato",
    nessun_dato_archiviato:
      "Non è presente alcun dato contrassegnato come archiviato",
    nominativo: "Nominativo",
    nominativo_cliente: "Nominativo cliente",
    nominativo_dipendente: "Nominativo dipendente cliente",
    sesso: "Sex",
    citta: "City",
    destra: "Right",
    sinistra: "Left",
    frazione: "Fraction / Locality",
    codice_fiscale: "Tax code",
    indirizzo: "Address",
    non_programmato: "Non programmato",
    note_amministrative: "Note amministrative",
    note_intervento: "Note intervento",
    numero: "Numero",
    numero_missioni: "Number of missions",
    numero_documento: "Numero documento",
    oggi: "Today",
    compila_tutti_i_campi_obbligatori: "Compila tutti i campi obbligatori",
    occupazione: "Occupazione",
    ore_effettive: "Ore effettive",
    ore_lavorate: "Ore lavorate",
    ore_lavorate_breve: "ore lav.",
    ore_lavorate_breve_header: "Ore lav.",
    ore_lavorate_effettive: "Ore lavorate effettive",
    ore_lavorate_effettive_breve_header: "Ore eff.",
    ore_viaggio: "Ore viaggio",
    modifica_referto: "Modifica referto",
    oppure: "Oppure",
    parametri: "Parametri",
    pdf_generato_con_successo: "PDF generato con successo",
    errore_generazione_pdf: "Errore durante la generazione del PDF",
    password: "Password",
    password_aggiornata: "Password aggiornata con successo!",
    password_cambiata: "Password cambiata con successo!",
    password_gia_usata:
      "La password è già stata utilizzata in precedenza! Inserirne un'altra per continuare.",
    percentuale_completamento: "Progresso",
    pianificazione: "Pianificazione",
    prodotti: "Prodotti",
    qrcode: "QR Code",
    prodotto: "Prodotto",
    prodotti_relativi_ordine: "Prodotti relativi all'ordine",
    prodotti_utilizzati: "Prodotti utilizzati",
    profilo_aggiornato: "Profilo aggiornato con successo!",
    profilo: {
      completo: "Complete",
    },
    rapportini: "Rapportini",
    referti: "Referti",
    oggetto: "Oggetto",
    menu_referti_nuovo: "Nuovo Referto",
    menu_referti_aggiorna: "Aggiorna Referto",
    menu_referti_visualizza: "Visualizza Referti",
    menu_referti_resoconto: "Resoconto Referti",
    oggetto_referto: "Oggetto Referto",
    menu_referti: "Referti",
    nuovo_referto_medico: "Nuovo Referto Medico",
    data_referto: "Data Referto",
    esame_obiettivo: "Esame Obiettivo",
    terapia_prescritta: "Terapia Prescritta",
    note_aggiuntive: "Note Aggiuntive",
    firma: "Firma",
    firma_referto: "Firma referto",
    salva_bozza: "Salva Bozza",
    bozza: "Bozza",
    consegnato: "Consegnato",
    salva_referto: "Salva Referto",
    nuovo_referto: "Nuovo Referto",
    rapportino_inviato: "Rapportino inviato con successo!",
    rapportino_ricevuto: "Rapportino ricevuto",
    relazione_intervento: "Relazione intervento",
    resoconto: "Resoconto",
    riprendi_timer: "Riprendi timer",
    dipendenti: "Collaboratori",
    seleziona: "Seleziona",
    seleziona_foto: "Seleziona foto",
    settimana: "Settimana",
    settimana_attuale: "Settimana attuale",
    standard: "Standard",
    stato: "Status",
    successo: "Successo",
    su: "su",
    su_cosa_hai_lavorato: "Su cosa hai lavorato?",
    tempo_rimanente: "Tempo rimanente",
    termina_modifica: "Termina prima la modifica in corso!",
    testo_copiato: "Testo copiato negli appunti",
    titolo_cambio_password: "Cambio password",
    torna_indietro: "Torna indietro",
    totale_ore: "Totale ore",
    trasferta: "Trasferta",
    tutti_i_campi_devono_essere_compilati:
      "Tutti i campi obbligatori devono essere compilati",
    url: "URL",
    username: "Username",
    utenti: "Utenti",
    verifica_campi: "Verifica i campi inseriti",
    visualizzi_da: "Visualizzi da",
    zero_ore_lavorate_breve: "0 ore lav.",
    allergie_intolleranze: "Allergie e intolleranze",
    insorgenza_malattia: "Insorgenza malattia",
    modalita_insorgenza: "Modalità insorgenza",
    sintomatologia: "Sintomatologia",
    fattori_scatenanti: "Fattori scatenanti",
    fattori_allevianti: "Fattori allevianti",
    farmaci_assunti: "Farmaci assunti",
    terapie_precedenti: "Terapie precedenti",
    disturbi_associati: "Disturbi associati",
    paziente_gia_presente: "Paziente già presente",
    paziente_aggiornato: "Paziente aggiornato",
    paziente_aggiunto: "Paziente aggiunto",
    dati_importati_con_successo: "Dati importati con successo",
    errore_importazione: "Errore durante l'importazione",
    formato_file_non_supportato: "Formato file non supportato",
    seleziona_file_excel: "Seleziona file Excel",
    anteprima_dati: "Anteprima dati",
    conferma_importazione: "Conferma importazione",
    pazienti_da_importare: "Pazienti da importare",
    pazienti_importati: "Pazienti importati",
    pazienti_aggiornati: "Pazienti aggiornati",
    processing_import: "Elaborazione importazione in corso...",
    file_non_valido: "File non valido",
    dati_non_validi: "Dati non validi nel file",
    conferma_creazione_commessa_con_padre:
      "Sei sicuro di voler creare una commessa figlia? Se la commessa padre ha una pianificazione, questa verrà eliminata.",
    utenti_in_carico: "Utenti in carico",
    lascia_incarico: "Lascia incarico",
    conferma_lascia_incarico:
      "Sei sicuro di voler lasciare l'incarico di questa commessa?",
    conferma_presa_in_carico:
      "Sei sicuro di voler prendere in carico questa commessa?",
    commessa_presa_in_carico: "Commessa presa correttamente in carico!",
    no_utente_in_carico:
      "Nessun utente ha ancora preso in carico questa commessa",
    prendi_in_carico: "Prendi in carico",
    conferma_svuotamento_tabella: "Sei sicuro di voler svuotare la tabella?",
    svuotamento_tabella: "Svuotamento tabella",
    svuota_tabella: "Svuota tabella",
    codice_otp: "Codice OTP",
    codice_otp_testo:
      "Inserisci il codice OTP generato dalla tua app di autenticazione.",
    troppi_errori_verifica_codice:
      "Troppi errori nella verifica del codice, stai per essere riportato alla pagina del login.",
    codice_inserito_errato: "Il codice inserito non è corretto, riprova.",
    prezzo_totale: "Prezzo totale",
    tentativi_rimanenti: "Tentativi rimanenti: ",
    periodo: "Period",
    mostra_utenti_selezionati: "Mostra utenti",
    nascondi_utenti_selezionati: "Nascondi utenti",
    visualizza: "Visualizza",
    crea_copia: "Crea copia",
    ricorda_calcola_prezzi:
      "Ricorda di calcolare i prezzi se non l'hai ancora fatto!",
    modifica_copia: "Modifica copia",
    totale: "Totale",
    genera_pdf: "Genera PDF",
    desideri_generare_pdf: "Desideri generare il PDF",
    creato_con_successo: "Creato con successo",
    nessuna_commessa: "Nessuna commessa presente",
    collaboratori: "Collaboratori",
    copia_rapportino: "Copia rapportino",
    denominazione_commessa: "Denominazione commessa",
    chiudi_righe: "Chiudi righe",
    firma_cliente_mancante: "Firma del cliente mancante",
    firma_tecnico_mancante: "Firma del tecnico mancante",
    configurazione_tabella_salvata: "Configurazione tabella salvata",
    errore_salvataggio_configurazione:
      "Errore durante il salvataggio della configurazione",
    sconti: "Sconti",
    mostra_sconti: "Mostra sconti",
    installa_pwa: "Installa app",
    dialog_recuperato: "Finestra recuperata",
    passato_a_dataview: "Passato alla visualizzazione tramite 'Griglia'",
    passato_a_tabs: "Passato alla visualizzazione tramite 'Tabs'",
    ultima_volta_sincronizzati: "Data last synchronized at",
    minimizza_mobile: "Minimizza",
    massimizza_mobile: "Massimizza",
    mostra_eventi_click: "Mostra eventi al click",
    mostra_eventi_hover: "Mostra eventi al hover",
    riapri_dialog: "Riapri finestra",
    setup_salvato: "Dati del form salvati localmente",
    setup_rimosso: "Dati del form rimossi localmente",
    elimina_setup_localmente: "Elimina i dati del form salvati localmente",
    visualizza_tabs: "Passa alla visualizzazione tramite 'Tabs'",
    visualizza_dataview: "Passa alla visualizzazione tramite 'Griglia'",
    no_dato_trovato: "Nessun dato trovato",
    disancora_elemento: "Unanchor element",
    ancora_destra: "Anchor right",
    chiudi_elemento: "Close element",
    ricarica: "Reload",
    cap: "ZIP Code",
    email: "Email",
    telefono: "Phone",
    minimo_2_caratteri: "Minimum 2 characters",
    minimo_3_caratteri: "Minimum 3 characters",
    nome_impianto: "Plant name",
    conferma_azione: "Confirm action",
    sposta_a: "Sposta a",
    elimina: "Delete",
    duefa: "App di autenticazione",
    password_temporanea: "Password temporanea",
    setup_ripristinato: "Data restored, save to confirm",
    avviso: "Avviso",
    tooltip_password_temporanea:
      "La password temporanea sarà disponibile per il login solo una volta: una volta effettuato il primo accesso, l'utente verrà obbligato a cambiarla!",
    creazione_gia_in_corso: "Creazione già in corso!",
    archivia: "elimina",
    seleziona_file: "Seleziona file",
    importazione_dati: "Importazione di dati",
    importazione_dati_riuscita: "Importazione di dati riuscita!",
    importazione_dati_fallita: "Importazione di dati fallita!",
    importazione_dati_errore: "Errore durante l'importazione dei dati!",
    importazione_in_corso: "Importazione in corso...",
    elementi_importati: "Elementi importati",
    sigla: "Sigla",
    descma: "Descma",
    cod_fornitore: "Cod. fornitore",
    cod_prodotto: "Cod. prodotto",
    prezzo_netto: "Prezzo netto",
    prezzo_listino: "Prezzo di listino",
    stato_prodotto: "Stato prodotto",
    barcode: "Barcode",
    unita_misura: "Unit of measure",
    serie_vendita: "Serie vendita",
    cod_numerico: "Cod. numerico",
    qta_min_acquistabile: "Qta. min. acquistabile",
    gruppo_1: "Gruppo 1",
    gruppo_2: "Gruppo 2",
    gruppo_3: "Gruppo 3",
    moltipli_prezzo: "Moltipl. prezzo",
    moltipli_prezzo_netto: "Moltipl. prezzo netto",
    iva: "Iva",
    preferiti: "Preferiti",
    dettagli: "Details",
    cvs_headers_errore: "Errore nel file inserito! Headers mancanti",
    desc_serie_vendita: "Descrizione serie vendita",
    data_validita: "Data validità",
    sconto1: "Sconto 1",
    sconto2: "Sconto 2",
    sconto3: "Sconto 3",
    sconto4: "Sconto 4",
    sconto5: "Sconto 5",
    seleziona_righe_pdf:
      "Seleziona prima le righe tramite la casella sulla sinistra della tabella da includere nel PDF",
    seleziona_righe_prima:
      "Per poter eliminare degli elementi, prima seleziona delle righe tramite la casella sulla sinistra della tabella!",
    data_non_valida: "Data non valida",
    prezzo_ora: "Prezzo ora",
    commessa_padre: "Commessa padre",
    alta: "Alta",
    media: "Media",
    bassa: "Bassa",
    priorita: "Priorità",
    dal: "From",
    al: "To",
    no_categoria: "Nessuna categoria",
    note_per_dipendenti: "Note per le dipendenti",
    descrizione_commessa: "Descrizione commessa",
    commessa_principale: "Commessa principale",
    utenti_creatori: "Utenti creatori",
    unione_filtri: "Unione filtri",
    applica_filtri: "Apply filters",
    filtri: "Filters",
    filtra: "Filter",
    filtro_attivo: "active filter",
    filtri_attivi: "active filters",
    tutti: "All",
    ha: "Has",
    non_ha: "Doesn't have",
    em_stop_remoto: "Remote EM stop",
    em_stop_locale: "Local EM stop",
    consumo_acqua: "Water usage",
    durata_min_minuti: "Min duration (min)",
    durata_max_minuti: "Max duration (min)",
    consumo_acqua_stimato_min_l: "Min estimated water (L)",
    consumo_acqua_stimato_max_l: "Max estimated water (L)",
    e: "E",
    amministratore: "Amministratore",
    se_null_imposta_inizio:
      "Se lasciato vuoto, verrà automaticamente impostato come un'evento con durata solo un giorno (quello selezionato come inizio)",
    vai_a_profilo: "Vai al profilo",
    commessa_da_pianificare: "La commessa non è ancora stata pianificata.",
    commessa_gia_pianificata: "La commessa è già stata pianificata.",
    pianifica: "Pianifica",
    firma_cliente: "Firma cliente",
    firma_tecnico: "Firma tecnico",
    pulisci: "Pulisci",
    totale_imponibile_iva_esclusa: "Totale imponibile iva esclusa",
    prezzo_orario: "Prezzo orario",
    nessun_prodotto_utilizzato: "Nessun prodotto utilizzato",
    aggiungi_un_prodotto_per_cominciare: "Aggiungi un prodotto per cominciare",
    nessun_utente_associata: "Nessuna utente associata",
    aggiungi_una_utente_per_cominciare: "Aggiungi una utente per cominciare",
    ditta_installatrice: "Ditta installatrice",
    prezzo_calcolato: "Prezzo calcolato",
    quantita: "Quantità",
    calcola: "Calcola",
    tipologia_lavoro_svolto: "Tipologia lavoro svolto",
    mostra_prodotti_selezionati: "Mostra prodotti",
    nascondi_prodotti_selezionati: "Nascondi prodotti",
    mostra_dipendenti_selezionate: "Mostra dipendenti",
    nascondi_dipendenti_selezionate: "Nascondi dipendenti",
    sei_sicuro_di_voler_rimuovere_prodotto:
      "Sei sicuro di voler rimuovere il prodotto",
    sei_sicuro_di_voler_rimuovere_utente:
      "Sei sicuro di voler rimuovere la utente",
    si: "Si",
    no: "No",
    attenzione: "Attenzione",
    numero_rapportini: "Numero rapportini",
    mese: "Mese",
    denominazione_cliente: "Denominazione cliente",
    visualizza_firme: "Visualizza firme",
    pdf_rapportino: "PDF rapportino",
    visualizza_rapportino_pdf: "Visualizza PDF rapportino",
    scarica_rapportino_pdf: "Scarica PDF rapportino",
    elimina_rapportino_pdf: "Elimina PDF rapportino",
    generazione_pdf: "Generazione PDF in corso...",
    generazione_pdf_completata: "Generazione PDF completata con successo!",
    programmata: "Programmata",
    completata: "Completata",
    info_commesse_pianificazione: "INFO COMMESSE",
    modifica_creazione: "Creazione e Modifica",
    visualizza_commesse: "Visualizzazione Commesse",
    step_commesse: "Step delle Commesse",
    pianificazione_commesse: "Pianificazione Commesse",
    descrizione_modifica_creazione:
      "Qui puoi creare nuove commesse e modificarle facilmente.",
    descrizione_visualizzazione:
      "Accedi alla lista delle commesse per una panoramica completa.",
    descrizione_step:
      " Ogni commessa è suddivisa in vari step che possono essere monitorati.",
    conferma_pianifica: "Vuoi pianificare la commessa appena creata?",
    descrizione_pianificazione:
      "La pianificazione di una commessa consiste nella organizzazione di tutte le attività necessarie per completarla in modo efficiente.",
    popup_modifica_creazione:
      "\n              <p><strong>Premendo il tasto \"+\" in alto a destra si possono inserire nuove commesse con relativi dati:</strong></p>\n              <ul>\n                <li><strong>Nome:</strong> Identificativo univoco della commessa per facilitarne la gestione e il riconoscimento.</li>\n                <br>\n                <li><strong>Cliente:</strong> Nome del cliente per cui viene creata la commessa.</li>\n                <br>\n                <li><strong>Commessa padre:</strong> Opzione per creare gerarchie tra commesse, assegnando una commessa principale (utile per suddividere progetti più complessi).</li>\n                <br>\n                <li><strong>Priorità:</strong> Indica l'urgenza della commessa, scegliendo tra Alta, Media o Bassa per facilitare l'organizzazione delle attività.</li>\n                <br>\n                <li><strong>Descrizione:</strong> Testo libero in cui specificare dettagli e informazioni fondamentali sul contenuto della commessa.</li>\n                <br>\n                <li><strong>Note:</strong> Sezione per aggiungere annotazioni, commenti o eventuali informazioni aggiuntive utili alla gestione della commessa.</li>\n              </ul>\n              ",
    popup_visualizza_commesse:
      "\n                <p><strong>Visualizzazione delle Commesse</strong></p>\n                <p>Le commesse vengono organizzate e visualizzate con criteri chiari e strutturati per garantire una gestione efficace e intuitiva.\n                La visualizzazione può avvenire in base a diversi parametri:</p>\n                <ul>\n                  <li>\n                    <strong>Nome:</strong> Le commesse vengono identificate attraverso il loro nome univoco, consentendo una ricerca immediata e precisa.\n                    Questo criterio è utile per chi gestisce numerose commesse e ha bisogno di riconoscerle facilmente.\n                  </li>\n                  <br>\n                  <li>\n                    <strong>Priorità:</strong> Ogni commessa è classificata in base al livello di urgenza, che può essere <strong>Alta</strong>, <strong>Media</strong> o <strong>Bassa</strong>.\n                    Questo filtro permette di organizzare le attività in modo efficace, dando precedenza alle commesse più importanti o urgenti.\n                  </li>\n                  <br>\n                  <li>\n                    <strong>Data di Creazione:</strong> Le commesse vengono elencate in ordine cronologico, permettendo di identificare rapidamente le più recenti\n                    oppure di consultare quelle meno recenti per eventuali revisioni o aggiornamenti. Questo metodo di visualizzazione è utile per tracciare\n                    l’evoluzione delle attività nel tempo.\n                  </li>\n                </ul>\n                ",
    popup_step_commesse:
      '\n                <p><strong>Visualizzazione delle Gerarchie delle Commesse</strong></p>\n                <p>Premendo il tasto "<strong>></strong>", sarà possibile espandere e visualizzare la struttura gerarchica delle commesse.</p>\n                <ul>\n                  <li><strong>Commesse principali:</strong> Verranno inizialmente mostrate in un elenco compatto per una visualizzazione più chiara.</li>\n                  <br>\n                  <li><strong>Commesse subordinate:</strong> Cliccando sul pulsante di espansione, si potranno vedere le commesse collegate a ciascuna commessa principale.</li>\n                  <br>\n                  <li><strong>Organizzazione intuitiva:</strong> Grazie a questa struttura, è possibile gestire progetti complessi suddividendo le attività in sezioni più chiare e facilmente navigabili.</li>\n                </ul>\n                ',
    popup_pianifazione_commesse:
      "\n            <p><strong>Pianificazione della Commesse</strong></p>\n            <p>La pianificazione di una commessa è essenziale per garantire un'organizzazione chiara e una gestione efficiente delle attività. Ogni commessa viene strutturata in base a diversi parametri fondamentali:</p>\n            <ul>\n              <li><strong>Commessa principale:</strong> Identificativo della commessa principale, utile per creare una gerarchia tra le attività e suddividere progetti più complessi.</li>\n              <br>\n              <li><strong>Data di inizio e fine:</strong> Ogni commessa è programmata con una data di inizio e una data di completamento, permettendo di stabilire scadenze e monitorare i progressi nel tempo.</li>\n              <br>\n              <li><strong>Collaboratori:</strong> La commessa può essere assegnata a uno o più collaboratori, facilitando il lavoro di squadra e la distribuzione dei compiti tra i vari membri del team.</li>\n              <br>\n              <li><strong>Stato della commessa:</strong> Ogni commessa può trovarsi in uno dei seguenti stati:</li>\n              <ul>\n                <li><strong>In corso:</strong> La commessa è attiva e le attività sono in fase di sviluppo.</li>\n                <br>\n                <li><strong>Completata:</strong> Tutte le attività sono state concluse con successo.</li>\n                <br>\n                <li><strong>Non completata:</strong> La commessa è stata interrotta o non è stata portata a termine secondo la pianificazione iniziale.</li>\n                <br>\n              </ul>\n            </ul>\n          <p>Grazie a questa struttura organizzativa, la pianificazione delle commesse diventa più chiara e permette un controllo preciso su ogni fase del lavoro.</p>\n          ",
    mostra_commesse: "Mostra",
    funzionamento_filtri: "Funzionamento filtri",
    descrizione_filtri:
      '\n           <h2>1. Filtro Collaboratori <i class="fal fa-solid fa-users"></i></h2>\n            <p>Permette di selezionare uno o più utenti per visualizzare solo gli elementi (progetti, attività, dipendenti) a cui partecipano.</p>\n            <p><strong>Logica Oppure:</strong> Mostra gli elementi con almeno uno dei collaboratori selezionati (es. Marco oppure Luca).</p>\n            <p><strong>Logica E:</strong> Mostra solo gli elementi dove tutti i collaboratori selezionati sono presenti (es. Marco e Luca insieme).</p>\n\n            <h2>2. Filtro Categorie <i class="fal fa-solid fa-list"></i></h2>\n            <p>Filtra per tipologia di contenuto (es. Marketing, Formazione...). Supporta selezione singola o multipla.</p>\n            <p><strong>Logica consigliata:</strong> Oppure. Esempio: selezionando “Marketing” e “Vendite” si vedono gli elementi che appartengono a una delle due.</p>\n\n            <h2>3. Filtro Utenti Creatore <i class="fa-solid fa-user-tie"></i></h2>\n            <p>Filtra in base a chi ha creato l’elemento (es. “mostra tutte le dipendenti create da Marco”).</p>\n\n            <h2>Logica E vs Oppure <i class="fal fa-solid fa-gears"></i></h2>\n            <ul>\n              <li><strong>Collaboratori:</strong> E = tutti presenti / Oppure = almeno uno presente</li>\n              <li><strong>Categorie:</strong> E = tutte / Oppure = una qualsiasi</li>\n              <li><strong>Clienti:</strong> E = tutti  / Oppure = uno qualsiasi</li>\n              <li><strong>Creatori:</strong> E = poco sensato / Oppure = uno qualsiasi</li>\n            </ul>\n            <p><strong>Nota:</strong> la logica Oppure è la più intuitiva e raccomandata nella maggior parte dei casi.</p>\n',
    sconto_percentuale: "Sconto percentuale",
    recupera_password: "Recupera password",
    inserisci_Username: "Inserisci lo username",
    inserisci_Username_per_recupero_passoword:
      "Inserisci il tuo username per effettuare la richiesta di recupero della password",
    verifica_il_codice: "Verifica il codice",
    codice_tramite_email:
      "Inserisci il codice che ti è stato inviato tramite e-mail",
    resetta_password: "Resetta la password",
    generatore_password:
      "Utilizza il generatore per creare una password robusta e sicura. Riceverai un'e-mail con la nuova password.",
    torna_al_login: "Torna al login",
    missioni_macchina: "Missioni macchina",
    ultima_missione_ricevuta: "Ultima missione ricevuta",
    totale_missioni_label: "Totale missioni: {count}",
    mission: "Mission",
    messaggi: "Messaggi",
    distanza_km: "Distanza (km)",
    velocita_media: "Velocità media",
    em_stop_label: "EM stop",
    velocita: "Velocità",
    percorso: "Percorso",
    missioni: "Missioni",
    tot_breve: "Tot",
    seriale_mancante: "Seriale mancante",
    confermi_em_stop_remoto: "Confermi EM Stop remoto?",
    confermi_sblocco_remoto: "Confermi sblocco remoto?",
    conferma_em_stop: "Conferma EM Stop",
    conferma_sblocco: "Conferma sblocco",
    em_stop_inviato: "EM Stop inviato",
    sblocco_inviato: "Sblocco inviato",
    socket_non_disponibile: "Socket non disponibile",
    errore_invio: "Errore invio",
    max_label: "max:",
    msg_abbrev: "msg",
    paginazione: "Pagination",
    color_trasparente: "Transparent",
    color_bianco: "White",
    color_grigio_chiaro: "Light gray",
    color_argento: "Silver",
    color_marrone: "Brown",
    color_oro: "Gold",
    color_giallo: "Yellow",
    color_lime: "Lime",
    color_verde: "Green",
    color_verde_scuro: "Dark green",
    color_turchese: "Turquoise",
    color_ciano: "Cyan",
    color_blu: "Blue",
    color_blu_scuro: "Dark blue",
    color_viola: "Purple",
    color_rosa: "Pink",
    color_rosso: "Red",
    color_rosso_scuro: "Dark red",
    color_arancione: "Orange",
    color_grigio: "Gray",
    abilita_2fa: "Enable 2FA",
    rigenera_qr: "Regenerate QR",
    attendi_reindirizzamento:
      "Attendi il reindirizzamento alla verifica del dispositivo...",
    primo_login_potrebbe_impiegarci_un_po:
      "Il primo login potrebbe impiegarci un po' di più del solito.",
    device_types: {
      sconosciuto: "Unknown",
      tracker: "Tracker",
      tracker_meteo: "Weather tracker",
      anemometro: "Anemometer",
      sensore_direzione_vento: "Wind direction sensor",
      stazione_meteo: "Weather station",
      inverter: "Inverter",
      repeater: "Repeater",
      tracker_repeater: "Tracker repeater",
    },
    conn_types: {
      wifi: "WiFi",
      rs485: "RS485",
      ethernet: "Ethernet",
    },
    mappa_impianto: {
      titolo_dialog: "Plant map",
      titolo_wizard: "Plant map import",
      tooltip_apri_mappa: "Plant map",
      tooltip_importa_csv: "Import CSV",
      aggiungi_nodo: "Add node",
      credenziali: "Credentials",
      credenziali_modifica_hint:
        "Leave the password field empty to keep the current one. The password is stored encrypted on the server.",
      step_upload: "1. Upload and preview",
      step_credenziali: "2. Switchboard credentials",
      label_file_csv: "CSV file",
      hint_separatori:
        "Field separator: ; — decimal separator: , or . — encoding: UTF-8.",
      dropzone_hint: "Or drag and drop the CSV file here",
      warning_mappa_esistente:
        "This plant already has switchboards. During parsing, any existing QL in the current plant is automatically excluded from the CSV; only new switchboards are imported.",
      riepilogo: "Summary",
      quadri_distinti: "Distinct switchboards",
      label_tracker: "Trackers",
      label_inverter: "Inverters",
      label_weather_station: "Weather stations",
      label_devices: "Devices",
      label_quadro: "Switchboard",
      label_tipo: "Type",
      label_vele_dedup: "Sails (dedup)",
      genera_username_bulk: "Generate usernames",
      genera_password_bulk: "Generate passwords",
      apply_stesse_credenziali: "Apply same credentials to all switchboards",
      col_codice_locale: "Local code",
      col_numero_dispositivi: "# devices",
      col_username: "Username",
      col_password: "Password",
      label_codice_locale: "Local code",
      label_username: "Username",
      label_password: "Password",
      label_password_optional: "Password (leave empty to keep current)",
      label_nome: "Name",
      label_marca: "Brand",
      label_modello: "Model",
      label_id_device: "id_device",
      label_conn: "Conn (int)",
      label_larghezza: "Width (m)",
      label_lunghezza: "Length (m)",
      label_distanza: "Row spacing (m)",
      label_altezza: "Height (m)",
      label_latitudine: "Latitude",
      label_longitudine: "Longitude",
      label_axis_azimuth: "Azimuth tracker axis (°)",
      label_slope_tilt: "Terrain Inclination (°)",
      label_slope_azimuth: "Direction Slope Azimuth (°)",
      placeholder_auto: "auto",
      placeholder_nessuna: "None",
      placeholder_cerca: "Search by name or id_device...",
      titolo_crea_quadro: "Create Switchboard",
      titolo_modifica_quadro: "Edit Switchboard",
      titolo_crea_vela: "Create Sail",
      titolo_modifica_vela: "Edit Sail",
      titolo_crea_tracker: "Create Tracker",
      titolo_modifica_tracker: "Edit Tracker",
      titolo_crea_inverter: "Create Inverter",
      titolo_modifica_inverter: "Edit Inverter",
      titolo_crea_weather_station: "Create Weather Station",
      titolo_modifica_weather_station: "Edit Weather Station",
      titolo_crea_device: "Create Device",
      titolo_modifica_device: "Edit Device",
      vista_geografica: "Geographic view",
      vista_albero: "Tree view",
      btn_aggiorna: "Refresh",
      reset_view_graph: "Reset view",
      hint_interazione: 'Click a node to edit it · "+" to add a child',
      seleziona_file: "Select CSV file",
      cambia_file: "Change file",
      context_edit: "Edit",
      context_show_only_this: "Show only this",
      context_show_selected: "Show selected",
      section_dati_quadro: "Switchboard data",
      section_dati_vela: "Sail data",
      section_dimensioni: "Dimensions",
      section_coordinate: "Coordinates",
      nessun_dato_titolo: "No data",
      nessun_dato:
        "No data available. Import the map or manually create switchboards.",
      conferma_eliminazione: "Confirm deletion?",
      conferma_eliminazione_quadro_cascade:
        "Delete this switchboard? All connected devices and sails will also be deleted.",
      import_completato: "Import completed",
      salvato: "Saved",
      vela_standalone: "(standalone)",
      caricamento: "Loading...",
      crea_figlio: "Add child",
      quale_tipo_nodo:
        "Which type of node do you want to add to the switchboard?",
      altro: "Other...",
      tipo_nodo: "Node type",
      quale_tipo_nodo_specifico: "Inverter, Weather Station or Sail?",
      err_parsing: "CSV parsing error: {msg}",
      err_colonne_mancanti: "Missing columns: {cols}",
      err_csv_vuoto: "The CSV is empty.",
      err_riga_type: "Row {row}: invalid Type ({type})",
      err_riga_id_mancante: "Row {row}: missing Id field",
      err_riga_id_ql: "Row {row}: invalid ID QL",
      err_riga_duplicato:
        "Row {row}: duplicate id_device ({id}) in same switchboard",
      err_riga_tracker_no_vela: "Row {row}: tracker without valid ID Vela",
      err_tutte_righe_escluse:
        "No rows imported: every row in the CSV points to switchboards already defined in the plant (QL {quadri}). The import is only for the initial setup of the switchboards. To edit the map, use the interface. To reinitialize the whole plant, delete it and create a new one.",
      regole_titolo: "Import rules",
      regole_formato_titolo: "File format",
      regole_separatore: "Field separator: ; (semicolon)",
      regole_encoding: "Encoding: UTF-8",
      regole_decimali:
        "Decimal separator: comma (,) or dot (.) — both accepted, normalized internally.",
      regole_intestazione:
        "First row: mandatory header with the exact column names listed below.",
      regole_colonne_titolo: "Expected columns (in order)",
      regole_type_titolo: "Node types (Type field)",
      regole_richiede_vela: "requires sail",
      regole_conn_titolo: "Connection types (Conn field)",
      regole_vincoli_titolo: "Import constraints",
      regole_tracker_vela:
        "Trackers (Type 1, 2): require ID Vela, Nome Vela, Larg./Lung./Dist./Alt. Vela, Lat, Long.",
      regole_device_no_vela: "Devices (Type 3+): sail columns must be empty.",
      regole_id_univoco:
        "Id unique per switchboard: no duplicate id_device within the same ID QL.",
      regole_id_ql_locale:
        "ID QL is local to the plant: different plants may share the same ID QL. If an ID QL already exists in the current plant, all of its rows are excluded from the import.",
      regole_vela_dedup:
        "Sails deduplicated by (ID QL, ID Vela): on conflicting values across rows, the first row wins.",
      info_aiuto: "Help",
      filtra_per_tipo: "Filter by type",
      filtri_attivi: "Active filters",
      esci_focus: "Exit focus",
      focus_subtree: "Focus subtree",
      focus_mode_single: "Only this",
      focus_mode_multi: "Selected",
      focus_mode_subtree: "Subtree",
      elementi: "items",
      info_titolo: "Shortcuts and tools",
      info_mouse: "Mouse",
      info_tastiera: "Keyboard",
      info_strumenti: "Available tools",
      info_click: "edit node (quick rename for tracker/device/sail)",
      info_ctrl_click: "add/remove from multi-selection",
      info_right_click: "open context menu (edit, delete, focus)",
      info_hover: "rich node preview",
      info_scroll: "zoom · drag empty area: pan",
      info_slash: "focus search field",
      info_fit: "fit map to screen",
      info_esc: "exit focus or close tooltip",
      info_del: "delete selected node",
      info_layout:
        "Layout: radial, hierarchical (layered) or force-directed via ELK.",
      info_collapse:
        "Collapse/expand single families (tracker, device, sail) or all at once.",
      info_filter:
        "Filter nodes by type_code: each chip hides or restores that class.",
      info_breadcrumb:
        "Breadcrumb shows the focus chain: click any level to recenter it.",
      info_url:
        "State (switchboard, layout, focus, filters) is stored in the URL: share the link to reopen it identically.",
      upload_kml_title: "Import Map Layer (KML)",
      info_kml: "Upload a .kml file to update the topographic view of the facility.",
      label_file_kml: "KML File",
      select_file: "Select file",
      layer_attivo_titolo: "Map layer present",
      layer_attivo_desc: "This facility already has a KML file configured. Loading a new one will overwrite it.",
      delete_kml_completato: "Map layer successfully deleted",
      last_upload: "Last upload:",
      upload_info: "Uploading a new file will replace the current map."
    },
    mappa_import_pending: {
      banner: {
        titolo: "{n} map import(s) awaiting review",
        titolo_generico: "Map import awaiting review",
        bottone_rivedi: "Review",
      },
      dialog: {
        titolo: "Map import review",
        riepilogo_inseriti: "inserted",
        riepilogo_aggiornati: "updated",
        riepilogo_eliminati: "deleted",
        sezione_vele: "Sails",
        sezione_trackers: "Trackers",
        sezione_devices: "Devices",
        colonna_prima: "Current",
        colonna_dopo: "To import",
        etichetta_nuovo: "New",
        etichetta_eliminato: "Deleted",
        etichetta_mac: "MAC",
        etichetta_id: "ID",
        nessuna_modifica: "No field changes",
      },
      button: {
        accetta: "Accept",
        rifiuta: "Reject",
      },
      toast: {
        accettato: "Map import accepted and applied",
        rifiutato: "Map import rejected",
      },
    },
    monitoraggio: {
      titolo_dialog: "Plant monitoring",
      tooltip_apri: "Open plant monitoring",
      adatta_schermo: "Fit to screen",
      aggiorna: "Refresh",
      aggiornato: "Updated",
      alimentazione: "Power supply",
      allarmi_attivi: "Active alarms",
      angoli: "Angles",
      angolo_attuale: "Current angle",
      angolo_tabella: "Table angle",
      angolo_target: "Target angle",
      batteria: "Battery",
      caricamento: "Loading...",
      cerca: "Search",
      direzione_vento: "Wind direction",
      modalita: "Mode",
      nessun_dato: "No data",
      rete: "Network",
      seleziona_quadro: "Select panel",
      stato: "Status",
      tensione: "Voltage",
      tracker_senza_vela: "Tracker without sail",
      velocita_vento: "Wind speed",
      vento: "Wind",
      vista_albero: "Tree view",
      vista_griglia: "Grid view",
    },
    errore_generico: "Something went wrong",
    login_campo_obbligatorio: "Please fill in all fields to continue",
    tema_scuro_suggerimento_eyebrow: "Suggestion",
    tema_scuro_suggerimento_titolo: "Switch to dark theme?",
    tema_scuro_suggerimento_messaggio:
      "We noticed your system is using dark mode. You can enable it here too for a more comfortable experience.",
    pwa_nuovi_contenuti_disponibili:
      "New content available. Please refresh the page.",
    wss_log: {
      ultimo_evento: "Last event received at: ",
      impianto: "Plant",
      seleziona_impianto: "Select a plant",
      seleziona_impianto_prima: "Please select a plant first",
      seleziona_quadro: "Select a switchboard to view logs",
      nessun_quadro: "No switchboard available",
      nessun_evento: "No events",
      nessun_evento_periodo: "No events in the selected period",
      intervallo: "Range",
      categoria: "Category",
      categorie: "Categories",
      livelli: "Levels",
      cerca: "Search",
      cerca_placeholder: "Search by event, code or message…",
      data_ora: "Date & time",
      evento: "Event",
      messaggio: "Message",
      esito: "Outcome",
      successo: "Success",
      fallimento: "Failure",
      codice_errore: "Error code",
      durata_ms: "Duration (ms)",
      dettaglio_errore: "Error detail",
      copia_dettaglio_errore: "Copy error detail",
      dettaglio_errore_copiato: "Error detail copied to clipboard",
      metadata: "Metadata",
      token: "Token",
      concern: {
        comunicazione: "Communication",
        connessione: "Connection",
        tutto: "All",
        label: "Concern",
      },
      categoria_label: {
        connection: "Connection",
        plant_map: "Plant map",
        tracker_status: "Tracker status",
        tracker_config: "Tracker configuration",
        manual_command: "Manual command",
        firmware: "Firmware",
        inverter_status: "Inverter status",
      },
      livello_label: {
        info: "Info",
        warn: "Warning",
        error: "Error",
      },
      range: {
        "1h": "Last hour",
        "24h": "Last 24 hours",
        "7d": "Last 7 days",
        "30d": "Last 30 days",
      },
      eventi: {
        status_push_processed: "Status push processed",
        auth_success: "Authentication succeeded",
        auth_failed: "Authentication failed",
        connection_opened: "Connection opened",
        connection_closed: "Connection closed",
        token_invalid: "Invalid token",
        protocol_error: "Protocol error",
        map_request_received: "Map request received",
        map_csv_generated: "Map CSV generated",
        map_csv_generation_failed: "Map CSV generation failed",
        map_push_received: "Map push received",
        map_push_applied: "Map push applied",
        map_version_mismatch: "Map version mismatch",
        map_crc_mismatch: "Map CRC mismatch",
        status_push_failed: "Status push failed",
        conf_received: "Configuration received",
        conf_received_unknown_device: "Configuration from unknown device",
        conf_push_ack: "Configuration push ack",
        manual_cmd_response: "Manual command response",
        manual_cmd_res_no_id: "Manual command response without ID",
        manual_cmd_res_unknown_id: "Manual command response with unknown ID",
        fw_request_received: "Firmware request received",
        fw_file_generated: "Firmware file generated",
        fw_generation_failed: "Firmware generation failed",
        fw_no_version: "No firmware version available",
        fw_blob_missing: "Firmware blob missing",
        fw_download_ok: "Firmware download succeeded",
        fw_crc_mismatch: "Firmware CRC mismatch",
        fw_download_failed: "Firmware download failed",
        fw_write_failed: "Firmware write failed",
        fw_bad_version: "Firmware version not valid for the tracker",
        ql_upload: "Quick log upload",
        ql_upload_unauthorized: "Quick log upload unauthorized",
        ql_upload_forbidden: "Quick log upload forbidden",
        ql_upload_invalid_csv: "Invalid quick log CSV",
        ql_upload_unsupported_media: "Unsupported quick log format",
        ql_upload_merge_error: "Quick log merge error",
        ql_upload_pending: "Map upload awaiting review",
        ql_upload_diff_error: "Error computing map diff",
      },
      stato_label: {
        offline: "Offline",
        online: "Online",
        unknown: "Unrecognized",
      },
      errori_24h: "Errors (24h)",
      non_riconosciuto: "unrecognized",
      quadro_non_riconosciuto:
        "QL not registered in this plant: failed authentication events before a real switchboard could be resolved",
      evento_non_verificato:
        "Not verified: no successful authentication, the link to this switchboard relies only on the declared code",
    },
    allarmi: {
      nome_tracker: "Tracker name",
      id_tracker: "Tracker ID",
      titolo_sezione: "Alarm History",
      colonna_data_apertura: "Opening Date",
      colonna_data_chiusura: "Closing Date",
      colonna_durata: "Duration",
      colonna_codice: "Code",
      colonna_titolo: "Title",
      colonna_descrizione: "Description",
      colonna_severity: "Severity",
      colonna_stato: "Status",
      stato_aperto: "Open",
      stato_chiuso: "Closed",
      filtro_severity: "Filter by Severity",
      filtro_tutti: "All",
      filtro_warn: "Warning",
      filtro_error: "Error",
      filtro_critical: "Critical",
      paginazione_di: "of",
      paginazione_righe: "rows",
      bottone_esporta_xls: "Export XLS",
      nessun_allarme: "No alarms recorded",
      errore_caricamento: "Error loading alarms",
      errore_esportazione: "Error during export",
      esportazione_completata: "File exported successfully",
      esportazione_troncata: "Export truncated: too many results",
      filtro_stato: "Filter by status",
      filtro_data_da: "Date from",
      filtro_data_a: "Date to",
      filtro_ricerca: "Search",
      filtro_ricerca_placeholder: "Search code or description...",
      filtro_ricerca_placeholder_impianto:
        "Cerca per codice, nome o ID tracker",
      nessun_risultato_filtri: "No alarms match the filters",
      azione_pulisci_filtri: "Clear filters",
      colonna_dispositivo: "Device",
      colonna_nome_dispositivo: "Device name",
      colonna_tipo_dispositivo: "Device type",
      filtro_tipo_dispositivo: "Filter by device type",
      nome: "Name",
    },
    menu_alarm_codes: "Alarm codes",
    alarm_codes: {
      titolo_crea: "New alarm code",
      titolo_modifica: "Edit alarm code",
      sezione_dati_base: "Basic data",
      titolo: "Title",
      descrizione: "Description",
      sezione_traduzioni: "Translations",
      colonna: {
        code: "Code",
        severity: "Severity",
        category: "Category",
        is_blocking: "Blocking",
        title: "Short description",
      },
      severity_options: {
        warn: "Warning",
        error: "Error",
        critical: "Critical",
      },
      filtro: {
        search_placeholder: "Search by code, description, category…",
        severity_placeholder: "Filter by severity",
        category_placeholder: "Filter by category",
      },
      codice: "Code",
      messaggi: {
        create_ok: "Alarm code created",
        edit_ok: "Alarm code updated",
        delete_ok: "Alarm code deleted",
      },
      errore: {
        code_obbligatorio: "Code is required",
        code_duplicato: "An alarm code with this number already exists",
        code_non_trovato: "Alarm code not found",
        severity_non_valida: "Invalid severity",
        titolo_obbligatorio: "The Italian short description is required",
        in_uso:
          "Cannot delete: codes referenced by historical alarms ({codes})",
        nessun_codice: "No code selected for deletion",
      },
    },
    username_gestito_da_admin:
      "The username is managed by administrators and cannot be edited.",
    errore_durante_upload: "Upload error",
    foto_profilo_aggiornata: "Profile photo updated",
    copia_fingerprint: "Copy fingerprint",
    inserisci_una_password: "Enter a password",
    password_debole: "Weak",
    password_media: "Medium",
    password_forte: "Strong",
    password_non_combaciano: "Passwords do not match",
    dueeffea_attiva: "2FA active",
    dueeffea_qr_solo_attivazione:
      "For security reasons the QR code is only shown when 2FA is activated. If you changed phone or app, disable and re-enable 2FA to generate a new one.",
    dueeffea_non_attiva: "2FA inactive",
    dueeffea_descrizione:
      "Add an extra layer of security to your account with two-factor authentication.",
    errore_disabilitazione_dueeffea: "Error while disabling 2FA",
    attivo: "Active",
    non_attivo: "Inactive",
    mai_collegato: "Never connected",
    conferma_mario: "Confirm",
    nessuna_foto_profilo: "No profile photo",
    anteprima_immagine: "Image preview",
    anteprima_logo: "Logo preview",
    cambia_password: "Change password",
    cognome: "Surname",
    colonna_bloccata: "Column locked",
    conferma_chiusura_dialog: "There are unsaved changes. Close anyway?",
    crea_backup: "Create backup",
    creazione_non_riesciuta: "Creation failed",
    dati_anagrafici: "Personal data",
    errore_logout: "Error during logout",
    errore_comando_remoto: "Remote command error",
    errore_comando_remoto_descrizione:
      "An error occurred while sending the remote command.",
    nessun_impianto_associato: "No associated plant",
    nessuna: "None",
    perpetua: "Perpetual",
    sblocco: "Unlock",
    scarica: "Download",
    singolo: "Single",
    timeline_off: "Timeline off",
    async_ops: {
      session: {
        waiting: "Pending",
        ok: "Completed",
        error: "Completed with errors",
        timeout: "Timed out",
        partial: "Partially completed",
      },
      dialog: {
        titolo: "Ongoing operations",
        operazioni_attive: "Active operations",
        nessuna_operazione_attiva: "No active operations",
        nessuna_operazione_attiva_sottotitolo:
          "Background operations will appear here.",
        avanzamento_totale: "Total progress",
        pulisci_completate: "Clear completed",
        rimuovi: "Remove",
      },
      pill: {
        sessioni: "Sessions",
        in_attesa: "Pending",
        progresso: "Progress",
        espandi: "Expand",
        trascina: "Drag",
        tutti_completati: "All completed",
      },
    },
    eliminazione_dati: "Data deletion",
    dato_ricaricato: "Data reloaded successfully!",
    categoria_utente: "User category",
    tutto_completo: "All complete",
    inverter: {
      allarmi: "Alarms",
      anagrafica: "Inverter registry",
      apri_anagrafica: "Open registry",
      apri_dettagli: "Open details",
      confronto_inverter: "Inverter comparison",
      corrente_dc: "DC current",
      cos_phi: "Cos φ",
      cos_phi_medio: "Average cos φ",
      dettaglio_impianto: "Plant details",
      dettaglio_inverter: "Inverter details",
      energia_oggi: "Energy today",
      energia_periodo: "Energy for the period",
      energia_prodotta: "Produced energy",
      energia_totale: "Total energy",
      errore_caricamento_telemetria: "Error while loading telemetry",
      gauge_aria: "Current power {valore} out of a maximum of {massimo}",
      gauge_escluso_singolo: "{nome} is not counted in the maximum power: {motivo}",
      gauge_esclusi_multipli: "{n} inverters not counted in the maximum power",
      gauge_fondo_scala_non_disponibile: "Maximum power unavailable: no inverter is linked to a model with a known maximum AC power",
      gauge_mai_aggiornato: "Never updated",
      gauge_non_aggiornati_multipli: "{n} inverters not updated for more than 15 minutes",
      gauge_non_aggiornato_singolo: "{nome} has not been updated for more than 15 minutes (last data: {ultimo})",
      gauge_percentuale: "{percentuale}% of maximum power ({massimo})",
      grafico_dc: "DC side trend",
      grafico_energia: "Energy trend",
      grafico_potenza: "Power trend",
      grafico_potenza_impianto: "Plant power",
      in_allarme: "In alarm",
      motivo_modello_ambiguo: "the model matches several brands and none matches the inverter's brand",
      motivo_modello_assente: "the inverter has no model set",
      motivo_modello_non_trovato: "no registered model matches this inverter",
      motivo_modello_senza_potenza: "the registered model has no maximum AC power set",
      online: "Online",
      periodo_giorno: "Day",
      periodo_settimana: "Week",
      periodo_mese: "Month",
      picco_oggi: "Today's peak",
      picco_periodo: "Period peak",
      potenza_ac: "AC power",
      potenza_attuale: "Current power",
      potenza_dc: "DC power",
      riepilogo_giornata: "Daily summary",
      serie_troncata: "Truncated series: only the first points of the selected period are shown",
      tensione_dc: "DC voltage",
      ultimo_aggiornamento: "Last update",
    },
    inverter_granularita: {
      raw: "Raw data",
      quindici_minuti: "15 minutes",
      giornaliera: "Daily",
    },
    inverter_status: {
      run: "Producing",
      off: "Off",
      nd: "N/A",
    },
  },
};
